function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
  "@swc/helpers - typeof";

  return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment ClickstreamAnalyticsFragment on ClickstreamAnalytics {\n    event {\n      clickstreamTraceId\n      eventCategory\n      eventName\n      eventType\n      eventVersion\n    }\n    payload {\n      ...TripRecommendationModuleFragment\n    }\n  }\n\n  fragment TripRecommendationModuleFragment on TripRecommendationModule {\n    title\n    responseId\n    recommendations {\n      ...TripRecommendationFragment\n    }\n  }\n\n  fragment TripRecommendationFragment on TripRecommendation {\n    id\n    position\n    priceDisplayed\n    currencyCode\n    name\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n    uisPrimeMessages {\n      messageContent\n      schemaName\n    }\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment ClientSideImpressionAnalyticsFragment on ClientSideImpressionAnalytics {\n    uisPrimeAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    clickstreamAnalytics {\n      ...ClickstreamAnalyticsFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment TripsInfoToastFragment on TripsInfoToast {\n    primary\n    impressionTracking {\n      ...ClientSideImpressionAnalyticsFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment TripsDismissActionFragment on TripsDismissAction {\n    __typename\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n  }\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment TripsNavigateToViewActionFragment on TripsNavigateToViewAction {\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    tripItemId\n    tripViewId\n    viewFilter {\n      filter\n    }\n    viewType\n    viewUrl\n    displayMode\n  }\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n    spotLight\n  }\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment EGDSIllustrationFragment on Illustration {\n    id\n    description\n    link: url\n  }\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment EGDSMarkFragment on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        __typename\n        relativePath\n        value\n      }\n    }\n  }\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment UIGraphicFragment on UIGraphic {\n    ...EGDSIconFragment\n    ...EGDSMarkFragment\n    ...EGDSIllustrationFragment\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    graphic {\n      ...UIGraphicFragment\n    }\n    text\n  }\n\n  ", "\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextFragment on EGDSText {\n    ...EGDSPlainTextFragment\n    ...EGDSGraphicTextFragment\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment TripsStaticContentDrawerContentFragment on TripsStaticContentDrawerContent {\n    ...EGDSPlainTextFragment\n    ... on Image {\n      description\n      url\n    }\n  }\n\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment TripsStaticContentDrawerFragment on TripsStaticContentDrawer {\n    heading\n    content {\n      ...TripsStaticContentDrawerContentFragment\n    }\n    buttons {\n      ... on TripsPrimaryButton {\n        primary\n        accessibility {\n          label\n        }\n        action {\n          ... on TripsDismissAction {\n            analytics {\n              referrerId\n              linkName\n              uisPrimeMessages {\n                messageContent\n                schemaName\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment TripsOpenDrawerActionFragment on TripsOpenDrawerAction {\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    drawer {\n      ...TripsStaticContentDrawerFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  fragment TripsToastButtonFragment on TripsButton {\n    primary\n    action {\n      ...TripsNavigateToViewActionFragment\n      ...TripsDismissActionFragment\n      ...TripsOpenDrawerActionFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  fragment TripsInlineActionToastFragment on TripsInlineActionToast {\n    primary\n    button {\n      ...TripsToastButtonFragment\n    }\n    impressionTracking {\n      ...ClientSideImpressionAnalyticsFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment TripsStackedActionToastFragment on TripsStackedActionToast {\n    primary\n    button {\n      ...TripsToastButtonFragment\n    }\n    impressionTracking {\n      ...ClientSideImpressionAnalyticsFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  fragment TripsToastFragment on TripsToast {\n    ...TripsInfoToastFragment\n    ...TripsInlineActionToastFragment\n    ...TripsStackedActionToastFragment\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  fragment TripsLocalSavedItemFragment on TripsLocalSavedItem {\n    id\n    checked\n  }\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  query TripsLocalSavedItemQuery {\n    localSavedItems @client {\n      ...TripsLocalSavedItemFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject22() {
  var data = _tagged_template_literal(["\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n"]);
  _templateObject22 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject23() {
  var data = _tagged_template_literal(["\n  fragment TripsSaveActivityAttributesFragment on TripsSaveActivityAttributes {\n    regionId\n    dateRange {\n      start {\n        ...DateFragment\n      }\n      end {\n        ...DateFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject23 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject24() {
  var data = _tagged_template_literal(["\n  fragment CarRentalLocationFragment on CarRentalLocation {\n    airportCode\n    coordinates {\n      latitude\n      longitude\n    }\n    isExactLocationSearch\n    regionId\n    searchTerm\n  }\n"]);
  _templateObject24 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject25() {
  var data = _tagged_template_literal(["\n  fragment DateTimeFragment on DateTime {\n    day\n    month\n    year\n    hour\n    minute\n    second\n  }\n"]);
  _templateObject25 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject26() {
  var data = _tagged_template_literal(["\n  fragment TripsSaveCarOfferAttributesFragment on TripsSaveCarOfferAttributes {\n    categoryCode\n    fuelAcCode\n    offerToken\n    searchCriteria {\n      dropOffDateTime {\n        ...DateTimeFragment\n      }\n      dropOffLocation {\n        ...CarRentalLocationFragment\n      }\n      pickUpDateTime {\n        ...DateTimeFragment\n      }\n      pickUpLocation {\n        ...CarRentalLocationFragment\n      }\n    }\n    transmissionDriveCode\n    typeCode\n    vendorCode\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject26 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject27() {
  var data = _tagged_template_literal(["\n  fragment TripsSaveFlightSearchAttributesFragment on TripsSaveFlightSearchAttributes {\n    searchCriteria {\n      primary {\n        journeyCriterias {\n          arrivalDate {\n            ...DateFragment\n          }\n          departureDate {\n            ...DateFragment\n          }\n          destination\n          destinationAirportLocationType\n          origin\n          originAirportLocationType\n        }\n        searchPreferences {\n          advancedFilters\n          airline\n          cabinClass\n        }\n        travelers {\n          age\n          type\n        }\n        tripType\n      }\n      secondary {\n        booleans {\n          id\n          value\n        }\n        counts {\n          id\n          value\n        }\n        dates {\n          id\n          value {\n            ...DateFragment\n          }\n        }\n        ranges {\n          id\n          min\n          max\n        }\n        selections {\n          id\n          value\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject27 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject28() {
  var data = _tagged_template_literal(["\n  fragment TripsSavePackageAttributesFragment on TripsSavePackageAttributes {\n    packageOfferId\n    sessionId\n  }\n"]);
  _templateObject28 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject29() {
  var data = _tagged_template_literal(["\n  fragment TripsSaveStayAttributesFragment on TripsSaveStayAttributes {\n    checkInDate {\n      ...DateFragment\n    }\n    checkoutDate {\n      ...DateFragment\n    }\n    regionId\n    roomConfiguration {\n      numberOfAdults\n      childAges\n    }\n  }\n\n  ", "\n"]);
  _templateObject29 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject30() {
  var data = _tagged_template_literal(["\n  fragment TripsSaveItemAttributesFragment on TripsSaveItemAttributes {\n    ...TripsSaveStayAttributesFragment\n    ...TripsSaveActivityAttributesFragment\n    ...TripsSaveFlightSearchAttributesFragment\n    ...TripsSaveCarOfferAttributesFragment\n    ...TripsSavePackageAttributesFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject30 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject31() {
  var data = _tagged_template_literal(["\n  fragment TripsChangeSaveItemStateFragment on TripsChangeSaveItemState {\n    toggleState\n    tripItemId\n  }\n"]);
  _templateObject31 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject32() {
  var data = _tagged_template_literal(["\n  mutation SaveItemToTrip($context: ContextInput!, $tripId: String, $newTripInputs: [GraphQLPairInput!], $itemInput: TripsPlanInput!) {\n    trip(context: $context) {\n      saveItemToTrip(tripId: $tripId, newTripInputs: $newTripInputs, itemInput: $itemInput) {\n        ... on TripsView {\n          toast {\n            ...TripsToastFragment\n          }\n          tripsSideEffects {\n            ...TripsChangeSaveItemStateFragment\n          }\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject32 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject33() {
  var data = _tagged_template_literal(["\n  fragment TripsSaveItemToTripActionFragment on TripsSaveItemToTripAction {\n    analytics {\n      linkName\n      referrerId\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    tripId\n    saveItemInput {\n      ...TripsSaveItemToTripSaveItemInputFragment\n    }\n  }\n\n  fragment TripsSaveItemToTripSaveItemInputFragment on TripsPlan {\n    attributes {\n      ...TripsSaveItemAttributesFragment\n    }\n    itemId\n    pageLocation\n    source\n    subscriptionAttributes {\n      anchorPrice\n    }\n    tripItem {\n      tripItemId\n      tripViewId\n    }\n  }\n\n  ", "\n"]);
  _templateObject33 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject34() {
  var data = _tagged_template_literal(["\n  fragment TripsSaveItemPropertiesFragment on TripsSaveItemProperties {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    label\n    tooltip\n  }\n"]);
  _templateObject34 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject35() {
  var data = _tagged_template_literal(["\n  fragment TripsInternalComposableDrawerFragment on TripsComposableDrawer {\n    tripsViewHeader {\n      primary\n      secondaries\n    }\n    impressionTracking {\n      ...ClientSideImpressionAnalyticsFragment\n    }\n    type\n  }\n\n  ", "\n"]);
  _templateObject35 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject36() {
  var data = _tagged_template_literal(["\n  fragment TripsInternalPrimaryButtonFragment on TripsPrimaryButton {\n    __typename\n    primary\n    accessibility {\n      label\n    }\n    icon {\n      description\n      id\n    }\n    disabled\n    width\n  }\n"]);
  _templateObject36 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject37() {
  var data = _tagged_template_literal(["\n  fragment TripsInternalSecondaryButtonFragment on TripsSecondaryButton {\n    __typename\n    primary\n    accessibility {\n      label\n    }\n    icon {\n      description\n      id\n    }\n    disabled\n  }\n"]);
  _templateObject37 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject38() {
  var data = _tagged_template_literal(["\n  fragment TripsInternalTertiaryButtonFragment on TripsTertiaryButton {\n    __typename\n    primary\n    icon {\n      description\n      id\n    }\n    accessibility {\n      label\n    }\n    disabled\n    width\n  }\n"]);
  _templateObject38 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject39() {
  var data = _tagged_template_literal(["\n  fragment TripsInternalLinkActionFragment on TripsLinkAction {\n    __typename\n    resource {\n      value\n    }\n    target\n    analytics {\n      __typename\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n  }\n"]);
  _templateObject39 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject40() {
  var data = _tagged_template_literal(["\n  fragment TripsCreateTripFromItemActionFragment on TripsCreateTripFromItemAction {\n    analytics {\n      linkName\n      referrerId\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    saveItemInput {\n      ...TripsCreateTripSaveItemInputFragment\n    }\n    inputIds\n  }\n\n  fragment TripsCreateTripSaveItemInputFragment on TripsPlan {\n    itemId\n    pageLocation\n    attributes {\n      ...TripsSaveItemAttributesFragment\n    }\n    subscriptionAttributes {\n      anchorPrice\n    }\n  }\n\n  ", "\n"]);
  _templateObject40 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject41() {
  var data = _tagged_template_literal(["\n  fragment TripsDismissDrawerActionFragment on TripsDismissDrawerAction {\n    analytics {\n      linkName\n      referrerId\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n  }\n"]);
  _templateObject41 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject42() {
  var data = _tagged_template_literal(["\n  fragment TripsOpenCreateNewTripDrawerForItemActionFragment on TripsOpenCreateNewTripDrawerForItemAction {\n    analytics {\n      linkName\n      referrerId\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    createTripMetadata {\n      saveItemInput {\n        ...TripsOpenCreateNewTripActionSaveItemInputFragment\n      }\n    }\n  }\n\n  fragment TripsOpenCreateNewTripActionSaveItemInputFragment on TripsPlan {\n    itemId\n    pageLocation\n    attributes {\n      ...TripsSaveItemAttributesFragment\n    }\n    subscriptionAttributes {\n      anchorPrice\n    }\n  }\n\n  ", "\n"]);
  _templateObject42 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject43() {
  var data = _tagged_template_literal(["\n  fragment TripsOpenSaveToTripDrawerActionFragment on TripsOpenSaveToTripDrawerAction {\n    analytics {\n      linkName\n      referrerId\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    input {\n      ...TripsOpenSaveToTripSaveItemInputFragment\n    }\n  }\n\n  fragment TripsOpenSaveToTripSaveItemInputFragment on TripsPlan {\n    itemId\n    pageLocation\n    attributes {\n      ...TripsSaveItemAttributesFragment\n    }\n    subscriptionAttributes {\n      anchorPrice\n    }\n    tripItem {\n      tripItemId\n      tripViewId\n    }\n  }\n\n  ", "\n"]);
  _templateObject43 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject44() {
  var data = _tagged_template_literal(["\n  fragment TripsDialogDismissActionFragment on TripsDismissAction {\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n  }\n"]);
  _templateObject44 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject45() {
  var data = _tagged_template_literal(["\n  fragment TripsFormDataFragment on TripsFormData {\n    ... on TripsCreateTripFromItem {\n      input {\n        itemId\n        source\n        attributes {\n          ...TripsSaveItemAttributesFragment\n        }\n        pageLocation\n        subscriptionAttributes {\n          anchorPrice\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject45 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject46() {
  var data = _tagged_template_literal(["\n  fragment TripsFormActionFragment on TripsFormAction {\n    validatedInputIds\n    type\n    formData {\n      ...TripsFormDataFragment\n    }\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    validatedInputAnalytics {\n      egdsElementId\n      analytics {\n        referrerId\n        linkName\n        uisPrimeMessages {\n          messageContent\n          schemaName\n        }\n      }\n      ... on TripsValidatedInputChangeAnalytics {\n        referenceValue\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject46 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject47() {
  var data = _tagged_template_literal(["\n  mutation UnsaveItemFromTrip($context: ContextInput!, $tripItem: TripItemInput!, $tripEntity: TripEntity!) {\n    trip(context: $context) {\n      unsaveItemFromTrip(tripItem: $tripItem, tripEntity: $tripEntity) {\n        ... on TripsView {\n          toast {\n            ...TripsToastFragment\n          }\n          tripsSideEffects {\n            ...TripsChangeSaveItemStateFragment\n          }\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject47 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject48() {
  var data = _tagged_template_literal(["\n  fragment TripsUnsaveItemFromTripActionFragment on TripsUnsaveItemFromTripAction {\n    tripEntity\n    itemId\n    tripItem {\n      filter\n      tripItemId\n      tripViewId\n    }\n    analytics {\n      linkName\n      referrerId\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n  }\n"]);
  _templateObject48 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject49() {
  var data = _tagged_template_literal(["\n  fragment TripsPrimaryButtonFragment on TripsPrimaryButton {\n    ...TripsInternalPrimaryButtonFragment\n    action {\n      ...TripsInternalLinkActionFragment\n      ...TripsNavigateToViewActionFragment\n      ...TripsOpenCreateNewTripDrawerForItemActionFragment\n      ...TripsCreateTripFromItemActionFragment\n      ...TripsFormActionFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject49 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject50() {
  var data = _tagged_template_literal(["\n  fragment TripsDialogPrimaryButtonFragment on TripsPrimaryButton {\n    primary\n    icon {\n      description\n      id\n    }\n    disabled\n    width\n    action {\n      ...TripsSaveItemToTripActionFragment\n    }\n  }\n\n  fragment TripsDialogTertiaryButtonFragment on TripsTertiaryButton {\n    primary\n    icon {\n      description\n      id\n    }\n    disabled\n    width\n    action {\n      ...TripsDialogDismissActionFragment\n    }\n  }\n\n  fragment TripsDialogSecondaryButtonFragment on TripsSecondaryButton {\n    primary\n    icon {\n      description\n      id\n    }\n    disabled\n    width\n    action {\n      ...TripsDialogDismissActionFragment\n    }\n  }\n\n  fragment TripsDialogOverlayButtonFragment on TripsOverlayButton {\n    primary\n    icon {\n      description\n      id\n    }\n    disabled\n    width\n    action {\n      ...TripsDialogDismissActionFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject50 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject51() {
  var data = _tagged_template_literal(["\n  fragment TripsEmbeddedContentListFragment on TripsEmbeddedContentList {\n    secondaries\n  }\n"]);
  _templateObject51 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject52() {
  var data = _tagged_template_literal(["\n  fragment TripsModalDialogFragment on TripsModalDialog {\n    heading\n    buttonLayout\n    buttons {\n      ...TripsDialogPrimaryButtonFragment\n      ...TripsDialogSecondaryButtonFragment\n      ...TripsDialogTertiaryButtonFragment\n      ...TripsDialogOverlayButtonFragment\n    }\n    content {\n      ...TripsEmbeddedContentListFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject52 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject53() {
  var data = _tagged_template_literal(["\n  fragment TripsOpenDialogActionFragment on TripsOpenDialogAction {\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    modalDialog {\n      ...TripsModalDialogFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject53 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject54() {
  var data = _tagged_template_literal(["\n  fragment TripsSecondaryButtonFragment on TripsSecondaryButton {\n    ...TripsInternalSecondaryButtonFragment\n    action {\n      ...TripsOpenSaveToTripDrawerActionFragment\n      ...TripsInternalLinkActionFragment\n      ...TripsDismissDrawerActionFragment\n      ...TripsOpenCreateNewTripDrawerForItemActionFragment\n      ...TripsCreateTripFromItemActionFragment\n      ...TripsOpenDialogActionFragment\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject54 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject55() {
  var data = _tagged_template_literal(["\n  fragment TripsTertiaryButtonFragment on TripsTertiaryButton {\n    ...TripsInternalTertiaryButtonFragment\n\n    action {\n      ...TripsInternalLinkActionFragment\n      ...TripsOpenCreateNewTripDrawerForItemActionFragment\n      ...TripsCreateTripFromItemActionFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject55 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject56() {
  var data = _tagged_template_literal(["\n  fragment TripsIllustrationCardFragment on TripsIllustrationCard {\n    primary\n    secondaries\n    illustration {\n      url\n      description\n    }\n  }\n"]);
  _templateObject56 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject57() {
  var data = _tagged_template_literal(["\n  fragment EGDSLoyaltyBadgeFragment on EGDSLoyaltyBadge {\n    accessibility\n    text\n    size\n    theme\n  }\n"]);
  _templateObject57 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject58() {
  var data = _tagged_template_literal(["\n  fragment EGDSProgramBadgeFragment on EGDSProgramBadge {\n    accessibility\n    text\n    theme\n  }\n"]);
  _templateObject58 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject59() {
  var data = _tagged_template_literal(["\n  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {\n    accessibility\n    graphic {\n      ...UIGraphicFragment\n    }\n    text\n    size\n    theme\n  }\n\n  ", "\n"]);
  _templateObject59 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject60() {
  var data = _tagged_template_literal(["\n  fragment EGDSBadgeFragment on EGDSBadge {\n    ...EGDSStandardBadgeFragment\n    ...EGDSLoyaltyBadgeFragment\n    ...EGDSProgramBadgeFragment\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject60 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject61() {
  var data = _tagged_template_literal(["\n  fragment TripsInternalImageSlimCardFragment on TripsImageSlimCard {\n    primary\n    secondaries\n    badgeList {\n      ...EGDSBadgeFragment\n    }\n    thumbnail {\n      aspectRatio\n      description\n      url\n    }\n    impressionTracking {\n      ...ClientSideImpressionAnalyticsFragment\n    }\n    accessibility {\n      hint\n      label\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject61 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject62() {
  var data = _tagged_template_literal(["\n  fragment TripsInternalSlimCardFragment on TripsSlimCard {\n    graphic {\n      ...EGDSIconFragment\n      ...EGDSMarkFragment\n      ...EGDSIllustrationFragment\n    }\n    primary\n    secondaries\n    impressionTracking {\n      ...ClientSideImpressionAnalyticsFragment\n    }\n    accessibility {\n      label\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject62 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject63() {
  var data = _tagged_template_literal(["\n  fragment TripsIconFragment on TripsIcon {\n    label\n    icon {\n      id\n      description\n      title\n      theme\n    }\n    action {\n      ...TripsSaveItemToTripActionFragment\n      ...TripsUnsaveItemFromTripActionFragment\n      ...TripsInternalLinkActionFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject63 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject64() {
  var data = _tagged_template_literal(["\n  fragment TripsImageSlimCardFragment on TripsImageSlimCard {\n    ...TripsInternalImageSlimCardFragment\n    primaryAction {\n      ...TripsSaveItemToTripActionFragment\n      ...TripsUnsaveItemFromTripActionFragment\n      ...TripsInternalLinkActionFragment\n    }\n    secondaryAction {\n      ...TripsSaveItemToTripActionFragment\n      ...TripsUnsaveItemFromTripActionFragment\n      ...TripsInternalLinkActionFragment\n    }\n    cardIcon {\n      ...TripsIconFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject64 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject65() {
  var data = _tagged_template_literal(["\n  fragment TripsItemRecallCardFragment on TripsItemRecallCard {\n    primary\n    secondaries\n    image {\n      description\n      url\n    }\n  }\n"]);
  _templateObject65 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject66() {
  var data = _tagged_template_literal(["\n  fragment TripsSlimCardFragment on TripsSlimCard {\n    ...TripsInternalSlimCardFragment\n    action {\n      ...TripsNavigateToViewActionFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject66 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject67() {
  var data = _tagged_template_literal(["\n  fragment EGDSMaxLengthInputValidationFragment on EGDSMaxLengthInputValidation {\n    __typename\n    errorMessage\n    maxLength\n  }\n"]);
  _templateObject67 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject68() {
  var data = _tagged_template_literal(["\n  fragment EGDSMinLengthInputValidationFragment on EGDSMinLengthInputValidation {\n    __typename\n    errorMessage\n    minLength\n  }\n"]);
  _templateObject68 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject69() {
  var data = _tagged_template_literal(["\n  fragment EGDSRegexInputValidationFragment on EGDSRegexInputValidation {\n    __typename\n    errorMessage\n    pattern\n  }\n"]);
  _templateObject69 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject70() {
  var data = _tagged_template_literal(["\n  fragment EGDSRequiredInputValidationFragment on EGDSRequiredInputValidation {\n    __typename\n    errorMessage\n  }\n"]);
  _templateObject70 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject71() {
  var data = _tagged_template_literal(["\n  fragment EGDSTravelersInputValidationFragment on EGDSTravelersInputValidation {\n    __typename\n    errorMessage\n  }\n"]);
  _templateObject71 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject72() {
  var data = _tagged_template_literal(["\n  fragment MultiEmailValidationFragment on MultiEmailValidation {\n    __typename\n    errorMessage\n  }\n"]);
  _templateObject72 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject73() {
  var data = _tagged_template_literal(["\n  fragment SingleEmailValidationFragment on SingleEmailValidation {\n    __typename\n    errorMessage\n  }\n"]);
  _templateObject73 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject74() {
  var data = _tagged_template_literal(["\n  fragment DurationSpanInputValidationFragment on DurationSpanInputValidation {\n    __typename\n    errorMessage\n  }\n"]);
  _templateObject74 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject75() {
  var data = _tagged_template_literal(["\n  fragment TripsValidatedInputFragment on TripsValidatedInput {\n    egdsElementId\n    instructions\n    label\n    placeholder\n    required\n    value\n    inputType\n    leftIcon {\n      leftIconId: id\n      title\n      description\n    }\n    rightIcon {\n      rightIconId: id\n      title\n      description\n    }\n    validations {\n      ...EGDSInputValidationFragment\n    }\n  }\n\n  fragment EGDSInputValidationFragment on EGDSInputValidation {\n    ...EGDSMaxLengthInputValidationFragment\n    ...EGDSMinLengthInputValidationFragment\n    ...EGDSRegexInputValidationFragment\n    ...EGDSRequiredInputValidationFragment\n    ...EGDSTravelersInputValidationFragment\n    ...MultiEmailValidationFragment\n    ...SingleEmailValidationFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject75 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject76() {
  var data = _tagged_template_literal(["\n  fragment TripsFormContainerFragment on TripsFormContainer {\n    elements {\n      ...TripsPrimaryButtonFragment\n      ...TripsSecondaryButtonFragment\n      ...TripsValidatedInputFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject76 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject77() {
  var data = _tagged_template_literal(["\n  fragment TripsInternalSectionContainerFragment on TripsSectionContainer {\n    __typename\n    heading\n    subheadings\n    tripsListSubTexts: subTexts\n    theme\n    impressionAnalytics {\n      ...ClientSideImpressionAnalyticsFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject77 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject78() {
  var data = _tagged_template_literal(["\n  fragment TripsSectionContainerFragment on TripsSectionContainer {\n    ...TripsInternalSectionContainerFragment\n    elements {\n      ...TripsPrimaryButtonFragment\n      ...TripsSecondaryButtonFragment\n      ...TripsTertiaryButtonFragment\n      ...TripsImageSlimCardFragment\n      ...TripsSlimCardFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject78 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject79() {
  var data = _tagged_template_literal(["\n  fragment ToolbarFragment on TripsToolbar {\n    actions {\n      primary {\n        accessibility {\n          label\n        }\n        action {\n          analytics {\n            linkName\n            referrerId\n          }\n        }\n      }\n      secondaries {\n        ...TripsTertiaryButtonFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject79 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject80() {
  var data = _tagged_template_literal(["\n  fragment TripsComposableDrawerFragment on TripsComposableDrawer {\n    ...TripsInternalComposableDrawerFragment\n    tripsViewHeader {\n      toolbar {\n        ...ToolbarFragment\n      }\n    }\n    elements {\n      ...TripsSectionContainerFragment\n      ...TripsFormContainerFragment\n      ...TripsPrimaryButtonFragment\n      ...TripsSecondaryButtonFragment\n      ...TripsTertiaryButtonFragment\n      ...TripsImageSlimCardFragment\n      ...TripsSlimCardFragment\n      ...TripsIllustrationCardFragment\n      ...TripsItemRecallCardFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject80 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject81() {
  var data = _tagged_template_literal(["\n  query TripCreationQuery($metadata: TripCreationMetadataInput, $context: ContextInput!) {\n    trip(context: $context) {\n      creation(metadata: $metadata) {\n        ...TripsComposableDrawerFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject81 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject82() {
  var data = _tagged_template_literal(["\n  query TripsPlanQuery($item: TripsPlanInput!, $context: ContextInput!) {\n    trips(context: $context) {\n      plan(input: $item) {\n        ...TripsComposableDrawerFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject82 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject83() {
  var data = _tagged_template_literal(["\n  fragment TripsSaveItemFragment on TripsSaveItem {\n    initialChecked\n    itemId\n    source\n    attributes {\n      ...TripsSaveItemAttributesFragment\n    }\n    save {\n      ...TripsSaveItemPropertiesFragment\n    }\n    remove {\n      ...TripsSaveItemPropertiesFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject83 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject84() {
  var data = _tagged_template_literal(["\n  fragment TripsSaveItemButtonFragment on TripsSecondaryButton {\n    primary\n    icon {\n      theme\n    }\n    action {\n      ...TripsOpenDialogActionFragment\n      ...TripsOpenSaveToTripDrawerActionFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject84 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject85() {
  var data = _tagged_template_literal(["\n  fragment TripsViewContentItemFragment on TripsViewContentItem {\n    primary\n    action {\n      ...TripsNavigateToViewActionFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject85 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject86() {
  var data = _tagged_template_literal(["\n  fragment TripsInlineContentFragment on TripsInlineContent {\n    items {\n      ...TripsViewContentItemFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject86 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject87() {
  var data = _tagged_template_literal(["\n  fragment TripsSaveItemDetailsFragment on TripsSaveItemDetails {\n    heading\n    primary {\n      ...TripsInlineContentFragment\n    }\n    saveItemButton {\n      ...TripsSaveItemButtonFragment\n    }\n    graphicText {\n      text\n      graphic {\n        ... on Illustration {\n          description\n          url\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject87 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject88() {
  var data = _tagged_template_literal(["\n  query TripSaveEntityQuery($context: ContextInput!, $saveItemInput: TripsSaveItemInput!) {\n    trips(context: $context) {\n      saveItem(input: $saveItemInput) {\n        subscriptionAttributes {\n          anchorPrice\n        }\n        saveItemDetails {\n          ...TripsSaveItemDetailsFragment\n        }\n        saveItemButton {\n          ...TripsSaveItemButtonFragment\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject88 = function _templateObject() {
    return data;
  };
  return data;
}
var __defProp = Object.defineProperty;
var __defNormalProp = function (obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField = function (obj, key, value) {
  __defNormalProp(obj, (typeof key === "undefined" ? "undefined" : _type_of(key)) !== "symbol" ? key + "" : key, value);
  return value;
};
// src/components/trip-save-item.tsx
import React58, { useEffect as useEffect2 } from "react";
import { useHistory } from "react-router-dom";
import { gql as gql83, useQuery as useQuery3, useReactiveVar as useReactiveVar5 } from "@apollo/client";
import { EGDSLocalFavoriteButton } from "@egds/react-trips";
import { useBexApi as useBexApi6 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog11 } from "@shared-ui/dialog-context";
import { useExperiment } from "@shared-ui/experiment-context";
import { useProvidedState as useProvidedState7 } from "@shared-ui/provided-state-context";
// ../internal/src/components/mutation-action-state-component/mutation-action-state-component.tsx
import React3, { useEffect } from "react";
import { useReactiveVar } from "@apollo/client";
import { useLocalization } from "@shared-ui/localization-context";
import { useReactPortal } from "@shared-ui/portal-context";
import { UitkPageLoader } from "uitk-react-loader";
import { UitkToast } from "uitk-react-toast";
// ../internal/src/utils/react-portal-handler.tsx
import ReactDOM from "react-dom";
var renderChildren = function (jsxElement, htmlElement) {
  return htmlElement ? ReactDOM.createPortal(jsxElement, htmlElement) : jsxElement;
};
// ../internal/src/utils/trips-toast-handler.tsx
import React2 from "react";
// ../internal/src/components/state/mutation-action-state.tsx
import React from "react";
import { makeVar } from "@apollo/client";
var defaultMutationActionState = makeVar(void 0);
var MutationActionStateContext = React.createContext(defaultMutationActionState);
function useMutationActionState() {
  return React.useContext(MutationActionStateContext);
}
// ../internal/src/utils/trips-toast-handler.tsx
var defaultToastDismissHandler = function (mutationActionState) {
  mutationActionState(void 0);
};
var defaultHandler = {
  onDismiss: defaultToastDismissHandler
};
var TripsToastHandlerContext = React2.createContext(defaultHandler);
function useTripsToastHandler() {
  var handler = React2.useContext(TripsToastHandlerContext);
  var mutationActionState = useMutationActionState();
  return {
    onDismiss: function () {
      defaultHandler.onDismiss(mutationActionState);
      if (defaultHandler !== handler) {
        handler.onDismiss(mutationActionState);
      }
    }
  };
}
// ../internal/src/components/mutation-action-state-component/mutation-action-state-component.tsx
var MutationActionStateComponent = function (param) {
  var ignoreCompleteStatus = param.ignoreCompleteStatus,
    refetch = param.refetch;
  var onDismiss = useTripsToastHandler().onDismiss;
  var formatText = useLocalization().formatText;
  var htmlElement = useReactPortal().htmlElement;
  var mutationActionState = useMutationActionState();
  var mutationActionStateData = useReactiveVar(mutationActionState);
  useEffect(function () {
    if ((mutationActionStateData === null || mutationActionStateData === void 0 ? void 0 : mutationActionStateData.refetch) && refetch) {
      if (mutationActionStateData.queryVariables) {
        refetch(mutationActionStateData.queryVariables);
      } else {
        refetch();
      }
    }
  }, [mutationActionStateData, refetch]);
  if (!mutationActionStateData) {
    return null;
  }
  switch (mutationActionStateData.status) {
    case "reset" /* Reset */:
      mutationActionState(void 0);
      return null;
    case "loading" /* Loading */:
      return renderChildren( /* @__PURE__ */React3.createElement(UitkPageLoader, {
        visible: true
      }), htmlElement);
    case "error" /* Error */:
      return /* @__PURE__ */React3.createElement(UitkToast, {
        onDismiss: onDismiss,
        show: true
      }, formatText("trip.error.cancel.message"));
    case "complete" /* Complete */:
      if (mutationActionStateData.toastElement && !ignoreCompleteStatus) {
        return mutationActionStateData.toastElement;
      }
      mutationActionState(void 0);
      return null;
    default:
      mutationActionState(void 0);
      return null;
  }
};
// ../internal/src/utils/dialog-scope-provider.tsx
import React4 from "react";
var dialogName = "trips-dialog";
var drawerName = "trips-drawer";
var DialogScopeContext = React4.createContext({
  dialogName: dialogName,
  drawerName: drawerName
});
function useTripsDialogName() {
  return React4.useContext(DialogScopeContext).dialogName;
}
function useTripsDrawerName() {
  return React4.useContext(DialogScopeContext).drawerName;
}
// ../internal/src/utils/trip-save-item-provider.tsx
import React5 from "react";
var defaultTripSaveItemContext = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onEditCTAInToastClick: function () {}
};
var TripSaveItemContext = React5.createContext(defaultTripSaveItemContext);
var TripSaveItemContextProvider = function (param) {
  var children = param.children,
    onEditCTAInToastClick = param.onEditCTAInToastClick;
  var value = React5.useMemo(function () {
    return {
      onEditCTAInToastClick: onEditCTAInToastClick
    };
  }, [onEditCTAInToastClick]);
  return /* @__PURE__ */React5.createElement(TripSaveItemContext.Provider, {
    value: value
  }, children);
};
var useTripSaveItemContext = function () {
  return React5.useContext(TripSaveItemContext);
};
// src/components/trip-save-item.tsx
import { SignalProvider } from "@shared-ui/retail-trips-providers";
import { useSignalSubscriber } from "@shared-ui/signal-events-context";
import { defaultViewSizes, useMediaQueries, ViewMedium as ViewMedium2, Viewport as Viewport2 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex9, UitkLayoutFlexItem as UitkLayoutFlexItem8 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing13 } from "uitk-react-spacing";
import { UitkFavoriteSwitch } from "uitk-react-switch";
import { UitkText as UitkText11 } from "uitk-react-text";
// src/components/__private/mappers/use-save-item-attributes-mapper.tsx
import { SystemEvent, SystemEventLevel, useLoggerEvents } from "@shared-ui/logger-context";
var EVENTS = {
  MAP_SAVE_ITEM_ATTRIBUTES_MISSING: new SystemEvent(SystemEventLevel.INFO, "MAP_SAVE_ITEM_ATTRIBUTES_MISSING"),
  MAP_SAVE_ITEM_ATTRIBUTES_UNSUPPORTED_TYPENAME: new SystemEvent(SystemEventLevel.INFO, "MAP_SAVE_ITEM_ATTRIBUTES_UNSUPPORTED_TYPENAME")
};
var buildCarAttributes = function (attributesInput) {
  var categoryCode = attributesInput.categoryCode,
    fuelAcCode = attributesInput.fuelAcCode,
    offerToken = attributesInput.offerToken,
    searchCriteria = attributesInput.searchCriteria,
    transmissionDriveCode = attributesInput.transmissionDriveCode,
    typeCode = attributesInput.typeCode,
    vendorCode = attributesInput.vendorCode;
  var _ref = searchCriteria || {},
    dropOffDateTime = _ref.dropOffDateTime,
    dropOffLocation = _ref.dropOffLocation,
    pickUpDateTime = _ref.pickUpDateTime,
    pickUpLocation = _ref.pickUpLocation;
  var buildDropOffLocation = function () {
    var buildDropOffLocationCoordinates = function (coordinates) {
      if (coordinates) {
        var latitude = coordinates.latitude,
          longitude = coordinates.longitude;
        return {
          latitude: latitude,
          longitude: longitude
        };
      }
      return null;
    };
    if (dropOffLocation) {
      var airportCode = dropOffLocation.airportCode,
        coordinates = dropOffLocation.coordinates,
        isExactLocationSearch = dropOffLocation.isExactLocationSearch,
        regionId = dropOffLocation.regionId,
        searchTerm = dropOffLocation.searchTerm;
      return {
        airportCode: airportCode,
        coordinates: buildDropOffLocationCoordinates(coordinates),
        isExactLocationSearch: isExactLocationSearch,
        regionId: regionId,
        searchTerm: searchTerm
      };
    }
    return null;
  };
  var buildPickUpLocation = function () {
    var buildPickUpLocationCoordinates = function (coordinates2) {
      if (coordinates2) {
        var latitude = coordinates2.latitude,
          longitude = coordinates2.longitude;
        return {
          latitude: latitude,
          longitude: longitude
        };
      }
      return null;
    };
    var airportCode = pickUpLocation.airportCode,
      coordinates = pickUpLocation.coordinates,
      isExactLocationSearch = pickUpLocation.isExactLocationSearch,
      regionId = pickUpLocation.regionId,
      searchTerm = pickUpLocation.searchTerm;
    return {
      airportCode: airportCode,
      coordinates: buildPickUpLocationCoordinates(coordinates),
      isExactLocationSearch: isExactLocationSearch,
      regionId: regionId,
      searchTerm: searchTerm
    };
  };
  var buildSearchCriteriaForDateAndTime = function (dateTimeObj) {
    var day = dateTimeObj.day,
      hour = dateTimeObj.hour,
      month = dateTimeObj.month,
      minute = dateTimeObj.minute,
      second = dateTimeObj.second,
      year = dateTimeObj.year;
    return {
      day: day,
      hour: hour,
      month: month,
      minute: minute,
      second: second,
      year: year
    };
  };
  return {
    carAttributes: {
      categoryCode: categoryCode,
      fuelAcCode: fuelAcCode,
      offerToken: offerToken,
      searchCriteria: {
        dropOffDateTime: buildSearchCriteriaForDateAndTime(dropOffDateTime),
        dropOffLocation: buildDropOffLocation(),
        pickUpDateTime: buildSearchCriteriaForDateAndTime(pickUpDateTime),
        pickUpLocation: buildPickUpLocation()
      },
      transmissionDriveCode: transmissionDriveCode,
      typeCode: typeCode,
      vendorCode: vendorCode
    }
  };
};
function useSaveItemAttributesMapper() {
  var loggerEvents = useLoggerEvents(EVENTS);
  return function (attributesInput) {
    if (!attributesInput) {
      loggerEvents.MAP_SAVE_ITEM_ATTRIBUTES_MISSING.log({});
      return null;
    }
    switch (attributesInput.__typename) {
      case "TripsSaveStayAttributes":
        var _attributesInput_roomConfiguration;
        var _attributesInput_roomConfiguration_map;
        return {
          stayAttributes: {
            checkInDate: attributesInput.checkInDate ? {
              day: attributesInput.checkInDate.day,
              month: attributesInput.checkInDate.month,
              year: attributesInput.checkInDate.year
            } : null,
            checkoutDate: attributesInput.checkoutDate ? {
              day: attributesInput.checkoutDate.day,
              month: attributesInput.checkoutDate.month,
              year: attributesInput.checkoutDate.year
            } : null,
            regionId: attributesInput.regionId,
            roomConfiguration: (_attributesInput_roomConfiguration_map = (_attributesInput_roomConfiguration = attributesInput.roomConfiguration) === null || _attributesInput_roomConfiguration === void 0 ? void 0 : _attributesInput_roomConfiguration.map(function (room) {
              return {
                numberOfAdults: room.numberOfAdults,
                childAges: room.childAges
              };
            })) !== null && _attributesInput_roomConfiguration_map !== void 0 ? _attributesInput_roomConfiguration_map : null
          }
        };
      case "TripsSaveActivityAttributes":
        return {
          activityAttributes: {
            dateRange: attributesInput.dateRange ? {
              start: {
                day: attributesInput.dateRange.start.day,
                month: attributesInput.dateRange.start.month,
                year: attributesInput.dateRange.start.year
              },
              end: {
                day: attributesInput.dateRange.end.day,
                month: attributesInput.dateRange.end.month,
                year: attributesInput.dateRange.end.year
              }
            } : null,
            regionId: attributesInput.regionId
          }
        };
      case "TripsSaveFlightSearchAttributes":
        var _attributesInput_searchCriteria, _attributesInput_searchCriteria1, _attributesInput_searchCriteria2, _attributesInput_searchCriteria3, _attributesInput_searchCriteria4, _attributesInput_searchCriteria_secondary_booleans, _attributesInput_searchCriteria_secondary_counts, _attributesInput_searchCriteria_secondary_dates, _attributesInput_searchCriteria_secondary_ranges, _attributesInput_searchCriteria_secondary_selections;
        return {
          flightAttributes: {
            primary: {
              journeyCriterias: (_attributesInput_searchCriteria = attributesInput.searchCriteria) === null || _attributesInput_searchCriteria === void 0 ? void 0 : _attributesInput_searchCriteria.primary.journeyCriterias.map(function (journeyCriteria) {
                return {
                  departureDate: {
                    day: journeyCriteria.departureDate.day,
                    month: journeyCriteria.departureDate.month,
                    year: journeyCriteria.departureDate.year
                  },
                  destination: journeyCriteria.destination,
                  origin: journeyCriteria.origin,
                  destinationAirportLocationType: journeyCriteria.destinationAirportLocationType,
                  originAirportLocationType: journeyCriteria.destinationAirportLocationType,
                  arrivalDate: journeyCriteria.arrivalDate ? {
                    day: journeyCriteria.arrivalDate.day,
                    month: journeyCriteria.arrivalDate.month,
                    year: journeyCriteria.arrivalDate.year
                  } : null
                };
              }),
              travelers: (_attributesInput_searchCriteria1 = attributesInput.searchCriteria) === null || _attributesInput_searchCriteria1 === void 0 ? void 0 : _attributesInput_searchCriteria1.primary.travelers.map(function (traveler) {
                return {
                  type: traveler.type,
                  age: traveler.age
                };
              }),
              tripType: (_attributesInput_searchCriteria2 = attributesInput.searchCriteria) === null || _attributesInput_searchCriteria2 === void 0 ? void 0 : _attributesInput_searchCriteria2.primary.tripType,
              searchPreferences: ((_attributesInput_searchCriteria3 = attributesInput.searchCriteria) === null || _attributesInput_searchCriteria3 === void 0 ? void 0 : _attributesInput_searchCriteria3.primary.searchPreferences) ? {
                cabinClass: attributesInput.searchCriteria.primary.searchPreferences.cabinClass,
                airline: attributesInput.searchCriteria.primary.searchPreferences.airline,
                advancedFilters: attributesInput.searchCriteria.primary.searchPreferences.advancedFilters
              } : null
            },
            secondary: ((_attributesInput_searchCriteria4 = attributesInput.searchCriteria) === null || _attributesInput_searchCriteria4 === void 0 ? void 0 : _attributesInput_searchCriteria4.secondary) ? {
              booleans: (_attributesInput_searchCriteria_secondary_booleans = attributesInput.searchCriteria.secondary.booleans) === null || _attributesInput_searchCriteria_secondary_booleans === void 0 ? void 0 : _attributesInput_searchCriteria_secondary_booleans.map(function (boolean) {
                return {
                  id: boolean.id,
                  value: boolean.value
                };
              }),
              counts: (_attributesInput_searchCriteria_secondary_counts = attributesInput.searchCriteria.secondary.counts) === null || _attributesInput_searchCriteria_secondary_counts === void 0 ? void 0 : _attributesInput_searchCriteria_secondary_counts.map(function (count) {
                return {
                  id: count.id,
                  value: count.value
                };
              }),
              dates: (_attributesInput_searchCriteria_secondary_dates = attributesInput.searchCriteria.secondary.dates) === null || _attributesInput_searchCriteria_secondary_dates === void 0 ? void 0 : _attributesInput_searchCriteria_secondary_dates.map(function (date) {
                return {
                  id: date.id,
                  value: {
                    month: date.value.month,
                    day: date.value.day,
                    year: date.value.year
                  }
                };
              }),
              ranges: (_attributesInput_searchCriteria_secondary_ranges = attributesInput.searchCriteria.secondary.ranges) === null || _attributesInput_searchCriteria_secondary_ranges === void 0 ? void 0 : _attributesInput_searchCriteria_secondary_ranges.map(function (range) {
                return {
                  id: range.id,
                  min: range.min,
                  max: range.max
                };
              }),
              selections: (_attributesInput_searchCriteria_secondary_selections = attributesInput.searchCriteria.secondary.selections) === null || _attributesInput_searchCriteria_secondary_selections === void 0 ? void 0 : _attributesInput_searchCriteria_secondary_selections.map(function (selection) {
                return {
                  id: selection.id,
                  value: selection.value
                };
              })
            } : null
          }
        };
      case "TripsSaveCarOfferAttributes":
        return buildCarAttributes(attributesInput);
      case "TripsSavePackageAttributes":
        return {
          packageAttributes: {
            packageOfferId: attributesInput.packageOfferId,
            sessionId: attributesInput.sessionId
          }
        };
      default:
        loggerEvents.MAP_SAVE_ITEM_ATTRIBUTES_UNSUPPORTED_TYPENAME.log({});
        return null;
    }
  };
}
// src/__generated__/types.ts
var EGReferrerEventType = /* @__PURE__ */function (EGReferrerEventType2) {
  EGReferrerEventType2["CLICK"] = "CLICK";
  EGReferrerEventType2["IMPRESSION"] = "IMPRESSION";
  return EGReferrerEventType2;
}(EGReferrerEventType || {});
var IconSpotLight = /* @__PURE__ */function (IconSpotLight3) {
  IconSpotLight3["INFO"] = "INFO";
  IconSpotLight3["POSITIVE"] = "POSITIVE";
  IconSpotLight3["STANDARD"] = "STANDARD";
  IconSpotLight3["WARNING"] = "WARNING";
  return IconSpotLight3;
}(IconSpotLight || {});
var IconTheme = /* @__PURE__ */function (IconTheme2) {
  IconTheme2["default"] = "default";
  IconTheme2["emphasis"] = "emphasis";
  IconTheme2["inverse"] = "inverse";
  IconTheme2["negative"] = "negative";
  IconTheme2["positive"] = "positive";
  return IconTheme2;
}(IconTheme || {});
var PageLocation = /* @__PURE__ */function (PageLocation2) {
  PageLocation2["CFAR_DETAILS"] = "CFAR_DETAILS";
  PageLocation2["CHECKOUT"] = "CHECKOUT";
  PageLocation2["CHECKOUT_ERROR"] = "CHECKOUT_ERROR";
  PageLocation2["CONFIRMATION"] = "CONFIRMATION";
  PageLocation2["DETAILS"] = "DETAILS";
  PageLocation2["ENTRY"] = "ENTRY";
  PageLocation2["FEATURES"] = "FEATURES";
  PageLocation2["INSURANCE_DETAILS"] = "INSURANCE_DETAILS";
  PageLocation2["ITINERARY"] = "ITINERARY";
  PageLocation2["PAYMENT_ERROR"] = "PAYMENT_ERROR";
  PageLocation2["POST_BOOKING"] = "POST_BOOKING";
  PageLocation2["SEARCH_RESULTS"] = "SEARCH_RESULTS";
  PageLocation2["SYSTEM"] = "SYSTEM";
  PageLocation2["USER"] = "USER";
  return PageLocation2;
}(PageLocation || {});
var TripEntity = /* @__PURE__ */function (TripEntity2) {
  TripEntity2["ACTIVITY_PRODUCT"] = "ACTIVITY_PRODUCT";
  TripEntity2["CAR_PRODUCT"] = "CAR_PRODUCT";
  TripEntity2["FLIGHT_SEARCH"] = "FLIGHT_SEARCH";
  TripEntity2["LODGING_PRODUCT"] = "LODGING_PRODUCT";
  TripEntity2["PACKAGE_PRODUCT"] = "PACKAGE_PRODUCT";
  return TripEntity2;
}(TripEntity || {});
var TripsButtonWidth = /* @__PURE__ */function (TripsButtonWidth3) {
  TripsButtonWidth3["MATCH_PARENT_CONTAINER"] = "MATCH_PARENT_CONTAINER";
  TripsButtonWidth3["WRAP_CONTENT"] = "WRAP_CONTENT";
  return TripsButtonWidth3;
}(TripsButtonWidth || {});
var TripsDisplayMode = /* @__PURE__ */function (TripsDisplayMode3) {
  TripsDisplayMode3["DEFAULT"] = "DEFAULT";
  TripsDisplayMode3["MODAL"] = "MODAL";
  TripsDisplayMode3["NEW_TAB"] = "NEW_TAB";
  return TripsDisplayMode3;
}(TripsDisplayMode || {});
var TripsLinkTarget = /* @__PURE__ */function (TripsLinkTarget3) {
  TripsLinkTarget3["EXTERNAL"] = "EXTERNAL";
  TripsLinkTarget3["INTERNAL"] = "INTERNAL";
  return TripsLinkTarget3;
}(TripsLinkTarget || {});
var TripsPlanSourceType = /* @__PURE__ */function (TripsPlanSourceType2) {
  TripsPlanSourceType2["ACTIVITY_DETAILS"] = "ACTIVITY_DETAILS";
  TripsPlanSourceType2["ACTIVITY_SEARCH"] = "ACTIVITY_SEARCH";
  TripsPlanSourceType2["CAR_INFOSITE"] = "CAR_INFOSITE";
  TripsPlanSourceType2["CAR_INFOSITE_V2"] = "CAR_INFOSITE_V2";
  TripsPlanSourceType2["CAR_SEARCH"] = "CAR_SEARCH";
  TripsPlanSourceType2["CAR_SEARCH_V2"] = "CAR_SEARCH_V2";
  TripsPlanSourceType2["HOTEL_SEARCH"] = "HOTEL_SEARCH";
  TripsPlanSourceType2["LODGING_DETAILS"] = "LODGING_DETAILS";
  TripsPlanSourceType2["LODGING_SEARCH"] = "LODGING_SEARCH";
  TripsPlanSourceType2["PACKAGE_DETAILS"] = "PACKAGE_DETAILS";
  TripsPlanSourceType2["TRIP_OVERVIEW"] = "TRIP_OVERVIEW";
  return TripsPlanSourceType2;
}(TripsPlanSourceType || {});
var TripsViewType = /* @__PURE__ */function (TripsViewType2) {
  TripsViewType2["ACTIVITIES_SEARCH_RESULTS"] = "ACTIVITIES_SEARCH_RESULTS";
  TripsViewType2["ASC_ACCEPT"] = "ASC_ACCEPT";
  TripsViewType2["ASC_CANCEL"] = "ASC_CANCEL";
  TripsViewType2["BOOKING_FLIGHT_CANCEL"] = "BOOKING_FLIGHT_CANCEL";
  TripsViewType2["BOOKING_FLIGHT_CHANGE"] = "BOOKING_FLIGHT_CHANGE";
  TripsViewType2["CAMPAIGNS"] = "CAMPAIGNS";
  TripsViewType2["CARS_SEARCH_RESULTS"] = "CARS_SEARCH_RESULTS";
  TripsViewType2["CHECKOUT_VAS_CART"] = "CHECKOUT_VAS_CART";
  TripsViewType2["FILTERED"] = "FILTERED";
  TripsViewType2["FIND_ITINERARY_BY_OTHER_EMAIL"] = "FIND_ITINERARY_BY_OTHER_EMAIL";
  TripsViewType2["FIND_ITINERARY_BY_USER_EMAIL"] = "FIND_ITINERARY_BY_USER_EMAIL";
  TripsViewType2["FLIGHTS_SEARCH_RESULTS"] = "FLIGHTS_SEARCH_RESULTS";
  TripsViewType2["ITEM_DETAILS"] = "ITEM_DETAILS";
  TripsViewType2["ITEM_ESSENTIAL_INFO"] = "ITEM_ESSENTIAL_INFO";
  TripsViewType2["ITEM_PRICING_AND_REWARDS"] = "ITEM_PRICING_AND_REWARDS";
  TripsViewType2["ITEM_VOUCHER"] = "ITEM_VOUCHER";
  TripsViewType2["ITINERARY"] = "ITINERARY";
  TripsViewType2["LOB_SELECTION_VIEW"] = "LOB_SELECTION_VIEW";
  TripsViewType2["LODGING_SEARCH_RESULTS"] = "LODGING_SEARCH_RESULTS";
  TripsViewType2["LOGIN_PROMPT"] = "LOGIN_PROMPT";
  TripsViewType2["MANAGE_BOOKING"] = "MANAGE_BOOKING";
  TripsViewType2["MANAGE_GUESTS"] = "MANAGE_GUESTS";
  TripsViewType2["OVERVIEW"] = "OVERVIEW";
  TripsViewType2["PACKAGES_FC_SEARCH_RESULTS"] = "PACKAGES_FC_SEARCH_RESULTS";
  TripsViewType2["PACKAGES_FHC_SEARCH_RESULTS"] = "PACKAGES_FHC_SEARCH_RESULTS";
  TripsViewType2["PACKAGES_HC_SEARCH_RESULTS"] = "PACKAGES_HC_SEARCH_RESULTS";
  TripsViewType2["PACKAGES_HF_SEARCH_RESULTS"] = "PACKAGES_HF_SEARCH_RESULTS";
  TripsViewType2["PENDING_INVITE"] = "PENDING_INVITE";
  TripsViewType2["SEARCH_BY_ITINERARY_NUMBER"] = "SEARCH_BY_ITINERARY_NUMBER";
  TripsViewType2["SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL"] = "SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL";
  TripsViewType2["TRIPS_LIST"] = "TRIPS_LIST";
  TripsViewType2["TRIP_ASSIST"] = "TRIP_ASSIST";
  return TripsViewType2;
}(TripsViewType || {});
// src/components/__private/__fragments/actions/save-item-to-trip-action.tsx
import React21 from "react";
import { gql as gql33, useMutation } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useDialog } from "@shared-ui/dialog-context";
import { SystemEvent as SystemEvent2, SystemEventLevel as SystemEventLevel2, useLoggerEvents as useLoggerEvents2 } from "@shared-ui/logger-context";
import { useReactPortal as useReactPortal2 } from "@shared-ui/portal-context";
// ../internal/src/components/toast/trips-toast.tsx
import { gql as gql20 } from "@apollo/client";
// ../internal/src/utils/trips-composable-element-list.tsx
import React6 from "react";
// ../internal/src/utils/is-non-nullish.ts
function isNonNullish(value) {
  return value != null;
}
// ../internal/src/utils/trips-composable-element-list.tsx
var tripsComposableElementList = function (elements, components) {
  if (!(elements === null || elements === void 0 ? void 0 : elements.length)) {
    return null;
  }
  return elements.map(function (composableElement, index) {
    var _Component_getKey;
    var __typename = composableElement.__typename;
    var Component = components.find(function (component) {
      return component.fragment.__typename === __typename;
    });
    if (!Component) {
      return null;
    }
    var _Component_getKey1;
    var key = (_Component_getKey1 = (_Component_getKey = Component.getKey) === null || _Component_getKey === void 0 ? void 0 : _Component_getKey.call(Component, composableElement)) !== null && _Component_getKey1 !== void 0 ? _Component_getKey1 : "trips-composable-element";
    return /* @__PURE__ */React6.createElement(Component, {
      key: "".concat(__typename, "-").concat(key.toLowerCase(), "-").concat(index),
      data: composableElement
    });
  }).filter(isNonNullish);
};
var tripsComposableElement = function (elementFragment, possibleTypes) {
  var JsxElement = possibleTypes.find(function (possibleType) {
    return possibleType.fragment.__typename === elementFragment.__typename;
  });
  if (!JsxElement) {
    return null;
  }
  return /* @__PURE__ */React6.createElement(JsxElement, {
    data: elementFragment
  });
};
// ../internal/src/components/toast/trips-info-toast.tsx
import React9 from "react";
import { gql as gql4 } from "@apollo/client";
import { useProvidedState } from "@shared-ui/provided-state-context";
import { UitkToast as UitkToast2 } from "uitk-react-toast";
// ../internal/src/components/analytics/client-side-impression-analytics-intersection-tracker.tsx
import React7 from "react";
import { IntersectionTracker, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/utils/eg-clickstream-helper.ts
var egRecommendationBuilder = function (recommendation) {
  return {
    recommendation_id: recommendation.id,
    recommendation_position: recommendation.position,
    presentation_details_price_displayed: recommendation.priceDisplayed,
    presentation_details_currency_code: recommendation.currencyCode,
    presentation_details_recommendation_name: recommendation.name
  };
};
var buildClickstreamAnalyticsEvent = function (clickstreamAnalytics) {
  var _clickstreamAnalytics_event = clickstreamAnalytics.event,
    clickstreamTraceId = _clickstreamAnalytics_event.clickstreamTraceId,
    eventName = _clickstreamAnalytics_event.eventName,
    eventType = _clickstreamAnalytics_event.eventType,
    eventVersion = _clickstreamAnalytics_event.eventVersion,
    eventCategory = _clickstreamAnalytics_event.eventCategory;
  var event = {
    clickstream_trace_id: clickstreamTraceId,
    event_name: eventName,
    event_version: eventVersion,
    event_type: eventType,
    event_category: eventCategory
  };
  switch (clickstreamAnalytics.payload.__typename) {
    case "TripRecommendationModule":
      {
        var _clickstreamAnalytics_payload = clickstreamAnalytics.payload,
          title = _clickstreamAnalytics_payload.title,
          responseId = _clickstreamAnalytics_payload.responseId,
          recommendations = _clickstreamAnalytics_payload.recommendations;
        return {
          event: event,
          recommendation_module: {
            recommendation_title: title,
            eg_recommendation_response_id: responseId,
            recommendations: recommendations.map(function (recommendation) {
              return egRecommendationBuilder(recommendation);
            })
          }
        };
      }
    default:
      {
        return {
          event: event
        };
      }
  }
};
// ../internal/src/components/analytics/fragments/client-side-impression-analytics-fragment.ts
import { gql as gql3 } from "@apollo/client";
// ../internal/src/components/analytics/fragments/clickstream-analytics-fragment.ts
import { gql } from "@apollo/client";
var ClickstreamAnalyticsFragment = gql(_templateObject());
// ../internal/src/components/analytics/fragments/client-side-analytics-fragment.ts
import { gql as gql2 } from "@apollo/client";
var ClientSideAnalyticsFragment = gql2(_templateObject1());
// ../internal/src/components/analytics/fragments/client-side-impression-analytics-fragment.ts
var __ClientSideImpressionAnalyticsFragment = gql3(_templateObject2(), ClientSideAnalyticsFragment, ClickstreamAnalyticsFragment);
// ../internal/src/components/analytics/client-side-impression-analytics-intersection-tracker.tsx
var ClientSideImpressionAnalyticsIntersectionTracker = function (param) {
  var data = param.data,
    children = param.children;
  var track = useEgClickstream();
  React7.useEffect(function () {
    if (data.clickstreamAnalytics) {
      track(buildClickstreamAnalyticsEvent(data.clickstreamAnalytics));
    }
  }, [data.clickstreamAnalytics, track]);
  return data.uisPrimeAnalytics ? /* @__PURE__ */React7.createElement(IntersectionTracker, {
    referrerId: data.uisPrimeAnalytics.referrerId,
    linkName: data.uisPrimeAnalytics.linkName,
    intersectionOptions: {
      threshold: 0.5
    }
  }, children) : /* @__PURE__ */React7.createElement(React7.Fragment, null, children);
};
ClientSideImpressionAnalyticsIntersectionTracker.displayName = "ClientSideImpressionAnalyticsIntersectionTracker";
ClientSideImpressionAnalyticsIntersectionTracker.fragment = __ClientSideImpressionAnalyticsFragment;
// ../internal/src/components/analytics/client-side-impression-analytics-tracker.tsx
import React8 from "react";
import { ITrackType, useClickstreamAnalytics } from "@shared-ui/clickstream-analytics-context";
var ClientSideImpressionAnalyticsTracker = function (param) {
  var data = param.data,
    children = param.children;
  var _data_uisPrimeAnalytics_uisPrimeMessages, _data_uisPrimeAnalytics;
  var track = useClickstreamAnalytics().track;
  var message = data === null || data === void 0 ? void 0 : (_data_uisPrimeAnalytics = data.uisPrimeAnalytics) === null || _data_uisPrimeAnalytics === void 0 ? void 0 : (_data_uisPrimeAnalytics_uisPrimeMessages = _data_uisPrimeAnalytics.uisPrimeMessages) === null || _data_uisPrimeAnalytics_uisPrimeMessages === void 0 ? void 0 : _data_uisPrimeAnalytics_uisPrimeMessages.map(function (param) {
    var schemaName = param.schemaName,
      messageContent = param.messageContent;
    var parsedMessageContent;
    try {
      parsedMessageContent = JSON.parse(messageContent);
    } catch (e) {
      parsedMessageContent = null;
    }
    return {
      schemaName: schemaName,
      messageContent: parsedMessageContent
    };
  });
  React8.useEffect(function () {
    if (data.uisPrimeAnalytics) {
      var trackingData = {
        schemaName: "referrer",
        messageContent: {
          referrerId: data.uisPrimeAnalytics.referrerId,
          linkName: data.uisPrimeAnalytics.linkName,
          eventType: "impression"
        }
      };
      var options = {
        data: [trackingData].concat(_to_consumable_array(message || []))
      };
      track(ITrackType.EVENT, options);
    }
  }, [data.uisPrimeAnalytics, track]);
  return /* @__PURE__ */React8.createElement(React8.Fragment, null, children);
};
ClientSideImpressionAnalyticsTracker.displayName = "ClientSideImpressionAnalyticsTracker";
ClientSideImpressionAnalyticsTracker.fragment = __ClientSideImpressionAnalyticsFragment;
// ../internal/src/components/toast/trips-info-toast.tsx
var __Fragment = gql4(_templateObject3(), ClientSideImpressionAnalyticsTracker.fragment);
var TripsInfoToast = function (param) {
  var data = param.data;
  var _state_toastState;
  var onDismiss = useTripsToastHandler().onDismiss;
  var _useProvidedState = _sliced_to_array(useProvidedState(), 1),
    state = _useProvidedState[0];
  if (!data.primary) {
    return null;
  }
  var infoToast = /* @__PURE__ */React9.createElement(UitkToast2, {
    show: true,
    onDismiss: onDismiss,
    verticalOffset: (_state_toastState = state.toastState) === null || _state_toastState === void 0 ? void 0 : _state_toastState.offset
  }, data.primary);
  return data.impressionTracking ? /* @__PURE__ */React9.createElement(ClientSideImpressionAnalyticsTracker, {
    data: data.impressionTracking
  }, infoToast) : infoToast;
};
TripsInfoToast.displayName = "TripsInfoToast";
TripsInfoToast.fragment = _object_spread_props(_object_spread({}, __Fragment), {
  __typename: "TripsInfoToast"
});
// ../internal/src/components/toast/trips-inline-action-toast.tsx
import React18 from "react";
import { gql as gql18 } from "@apollo/client";
import { useProvidedState as useProvidedState2 } from "@shared-ui/provided-state-context";
import { UitkToast as UitkToast3 } from "uitk-react-toast";
// ../internal/src/components/toast/__private/trips-toast-button-fragment.ts
import { gql as gql17 } from "@apollo/client";
// ../internal/src/components/actions/trips-dismiss-action.ts
import { gql as gql5 } from "@apollo/client";
var __TripsDismissActionFragment = gql5(_templateObject4());
// ../internal/src/components/actions/trips-navigate-to-view-action.ts
import { gql as gql6 } from "@apollo/client";
import { useNavigation } from "@shared-ui/navigation-context";
var __TripsNavigateToViewActionFragment = gql6(_templateObject5());
var useTripsNavigateToViewAction = function (data) {
  var navigate = useNavigation().navigate;
  if (data.__typename !== "TripsNavigateToViewAction") {
    return void 0;
  }
  var viewUrl = data.viewUrl;
  if (!viewUrl) {
    return {};
  }
  var clickEvent = navigate && {
    onClick: function (event) {
      return navigate({
        event: event,
        absoluteURL: viewUrl
      });
    }
  };
  return _object_spread({
    href: viewUrl
  }, clickEvent);
};
// ../internal/src/components/toast/__private/trips-open-drawer-action-fragment.ts
import { gql as gql16 } from "@apollo/client";
// ../internal/src/components/toast/__private/trips-static-content-drawer-fragment.ts
import { gql as gql15 } from "@apollo/client";
// ../internal/src/components/toast/__private/trips-static-content-drawer-content-fragment.ts
import { gql as gql14 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-text.tsx
import React16 from "react";
import { gql as gql13 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-graphic-text.tsx
import React14 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkText } from "uitk-react-text";
// ../internal/src/components/ui-graphic/ui-graphic.tsx
import React13 from "react";
import { gql as gql10 } from "@apollo/client";
// ../internal/src/components/icon/icon.tsx
import React10 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "@egds/react-core/icons";
var _obj;
// ../internal/src/utils/mapper.ts
var iconSpotlightMapper = (_obj = {}, _define_property(_obj, "INFO" /* INFO */, "info"), _define_property(_obj, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj, "STANDARD" /* STANDARD */, "standard"), _define_property(_obj, "WARNING" /* WARNING */, "warning"), _obj);
// ../internal/src/components/icon/icon.tsx
var __IconFragment = gql7(_templateObject6());
var Icon = function (param) /* @__PURE__ */{
  var data = param.data,
    defaultIconSize = param.defaultIconSize,
    className = param.className;
  var _data_title, _data_theme, _data_withBackground;
  return React10.createElement(UitkIcon, {
    className: className,
    description: data.description,
    id: data.id,
    name: data.id,
    size: data.size ? UitkIconSize[data.size] : defaultIconSize,
    title: (_data_title = data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
    theme: (_data_theme = data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
    shadow: (_data_withBackground = data.withBackground) !== null && _data_withBackground !== void 0 ? _data_withBackground : void 0,
    spotlight: data.spotLight ? iconSpotlightMapper[data.spotLight] : void 0
  });
};
Icon.displayName = "Icon";
Icon.fragment = _object_spread_props(_object_spread({}, __IconFragment), {
  __typename: "Icon"
});
// ../internal/src/components/illustration/illustration.tsx
import React11 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkIllustrations } from "uitk-react-illustrations";
var __IllustrationFragment = gql8(_templateObject7());
var Illustration = function (param) {
  var data = param.data;
  return /* @__PURE__ */React11.createElement(UitkIllustrations, {
    alt: data.description,
    url: data.link
  });
};
Illustration.displayName = "Illustration";
Illustration.fragment = _object_spread_props(_object_spread({}, __IllustrationFragment), {
  __typename: "Illustration"
});
// ../internal/src/components/mark/mark.tsx
import React12 from "react";
import { gql as gql9 } from "@apollo/client";
import { UitkMark, UitkMarkSize } from "@egds/react-core/mark";
var __MarkFragment = gql9(_templateObject8());
var Mark = function (param) {
  var data = param.data,
    defaultMarkSize = param.defaultMarkSize,
    className = param.className;
  var _data_url, _data_url1;
  if (!((_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value)) {
    return null;
  }
  return /* @__PURE__ */React12.createElement(UitkMark, {
    className: className,
    description: data.description,
    id: data.id,
    name: data.id,
    size: data.markSize ? UitkMarkSize[data.markSize] : defaultMarkSize,
    url: (_data_url1 = data.url) === null || _data_url1 === void 0 ? void 0 : _data_url1.value
  });
};
Mark.displayName = "Mark";
Mark.fragment = _object_spread_props(_object_spread({}, __MarkFragment), {
  __typename: "Mark"
});
// ../internal/src/components/ui-graphic/ui-graphic.tsx
var __UIGraphicFragment = gql10(_templateObject9(), Icon.fragment, Mark.fragment, Illustration.fragment);
var UIGraphic = function (param) {
  var data = param.data,
    defaultIconSize = param.defaultIconSize,
    defaultMarkSize = param.defaultMarkSize,
    className = param.className;
  switch (data === null || data === void 0 ? void 0 : data.__typename) {
    case "Icon":
      return /* @__PURE__ */React13.createElement(Icon, {
        className: className,
        data: data,
        defaultIconSize: defaultIconSize
      });
    case "Mark":
      return /* @__PURE__ */React13.createElement(Mark, {
        className: className,
        data: data,
        defaultMarkSize: defaultMarkSize
      });
    case "Illustration":
      return /* @__PURE__ */React13.createElement(Illustration, {
        data: data
      });
    default:
      return null;
  }
};
UIGraphic.displayName = "UIGraphic";
UIGraphic.fragment = __UIGraphicFragment;
// ../internal/src/components/egds-text/egds-graphic-text.tsx
var fragment = gql11(_templateObject10(), UIGraphic.fragment);
var EGDSGraphicText = function (param) {
  var className = param.className,
    textSize = param.textSize,
    data = param.data;
  return /* @__PURE__ */React14.createElement(UitkLayoutFlex, {
    className: className,
    space: "one",
    alignItems: "center"
  }, /* @__PURE__ */React14.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React14.createElement(UIGraphic, {
    data: data.graphic
  })), /* @__PURE__ */React14.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React14.createElement(UitkText, {
    size: textSize
  }, data.text)));
};
EGDSGraphicText.fragment = fragment;
EGDSGraphicText.displayName = "EGDSGraphicText";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React15 from "react";
import { gql as gql12 } from "@apollo/client";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment2 = gql12(_templateObject11());
var EGDSPlainText = function (param) {
  var className = param.className,
    align = param.align,
    size = param.size,
    data = param.data;
  var text = data.text;
  return /* @__PURE__ */React15.createElement(UitkText2, {
    className: className,
    align: align,
    size: size
  }, text);
};
EGDSPlainText.fragment = fragment2;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-text.tsx
var fragment3 = gql13(_templateObject12(), EGDSPlainText.fragment, EGDSGraphicText.fragment);
var EGDSText = function (param) {
  var className = param.className,
    textAlign = param.textAlign,
    textSize = param.textSize,
    data = param.data;
  switch (data === null || data === void 0 ? void 0 : data.__typename) {
    case "EGDSPlainText":
      return /* @__PURE__ */React16.createElement(EGDSPlainText, {
        className: className,
        align: textAlign,
        size: textSize,
        data: data
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React16.createElement(EGDSGraphicText, {
        className: className,
        textSize: textSize,
        data: data
      });
    default:
      return null;
  }
};
EGDSText.fragment = fragment3;
EGDSText.displayName = "EGDSText";
// ../internal/src/components/toast/__private/trips-static-content-drawer-content-fragment.ts
var __TripsStaticContentDrawerContentFragment = gql14(_templateObject13(), EGDSPlainText.fragment);
// ../internal/src/components/toast/__private/trips-static-content-drawer-fragment.ts
var __TripsStaticContentDrawerFragment = gql15(_templateObject14(), __TripsStaticContentDrawerContentFragment);
// ../internal/src/components/toast/__private/trips-open-drawer-action-fragment.ts
var __TripsOpenDrawerActionFragment = gql16(_templateObject15(), __TripsStaticContentDrawerFragment);
// ../internal/src/components/toast/__private/trips-toast-button-fragment.ts
var __TripsToastButtonFragment = gql17(_templateObject16(), __TripsNavigateToViewActionFragment, __TripsDismissActionFragment, __TripsOpenDrawerActionFragment);
// ../internal/src/components/toast/__private/use-toast-action.ts
import React17 from "react";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
function transformUisPrimeMessage(uisPrimeMessages) {
  return uisPrimeMessages.map(function (param) {
    var schemaName = param.schemaName,
      messageContent = param.messageContent;
    var parsedMessageContent;
    try {
      parsedMessageContent = JSON.parse(messageContent);
    } catch (e) {
      parsedMessageContent = null;
    }
    return {
      schemaName: schemaName,
      messageContent: parsedMessageContent
    };
  });
}
function useToastAction(data) {
  var mutationActionState = useMutationActionState();
  var clickTracker = useClickTracker();
  var onEditCTAInToastClick = useTripSaveItemContext().onEditCTAInToastClick;
  return React17.useCallback(function () {
    if (!data.button.action) {
      return;
    }
    switch (data.button.action.__typename) {
      case "TripsNavigateToViewAction":
        {
          var message = transformUisPrimeMessage(data.button.action.analytics.uisPrimeMessages);
          clickTracker(data.button.action.analytics.referrerId, data.button.action.analytics.linkName, void 0, message);
          var _data_button_action = data.button.action,
            viewUrl = _data_button_action.viewUrl,
            displayMode = _data_button_action.displayMode;
          if (!viewUrl) {
            return;
          }
          mutationActionState({
            status: "reset" /* Reset */
          });
          if (displayMode === "NEW_TAB" /* NEW_TAB */) {
            window.open(viewUrl, "_blank");
          } else {
            window.location.href = viewUrl;
          }
          break;
        }
      case "TripsDismissAction":
        {
          clickTracker(data.button.action.analytics.referrerId, data.button.action.analytics.linkName);
          mutationActionState({
            status: "reset" /* Reset */
          });
          break;
        }
      case "TripsOpenDrawerAction":
        {
          var message1 = transformUisPrimeMessage(data.button.action.analytics.uisPrimeMessages);
          clickTracker(data.button.action.analytics.referrerId, data.button.action.analytics.linkName, void 0, message1);
          onEditCTAInToastClick();
          mutationActionState({
            status: "reset" /* Reset */
          });
          break;
        }
      default:
        break;
    }
  }, [data, clickTracker, mutationActionState, onEditCTAInToastClick]);
}
// ../internal/src/components/toast/trips-inline-action-toast.tsx
var __Fragment2 = gql18(_templateObject17(), __TripsToastButtonFragment, ClientSideImpressionAnalyticsTracker.fragment);
var TripsInlineActionToast = function (param) {
  var data = param.data;
  var _state_toastState;
  var onDismiss = useTripsToastHandler().onDismiss;
  var _useProvidedState2 = _sliced_to_array(useProvidedState2(), 1),
    state = _useProvidedState2[0];
  var actionCallback = useToastAction(data);
  var inlineActionToast = /* @__PURE__ */React18.createElement(UitkToast3, {
    onDismiss: onDismiss,
    actionCallback: actionCallback,
    actionText: data.button.primary || void 0,
    show: true,
    autoHide: true,
    verticalOffset: (_state_toastState = state.toastState) === null || _state_toastState === void 0 ? void 0 : _state_toastState.offset
  }, data.primary);
  return data.impressionTracking ? /* @__PURE__ */React18.createElement(ClientSideImpressionAnalyticsTracker, {
    data: data.impressionTracking
  }, inlineActionToast) : inlineActionToast;
};
TripsInlineActionToast.displayName = "TripsInlineActionToast";
TripsInlineActionToast.fragment = _object_spread_props(_object_spread({}, __Fragment2), {
  __typename: "TripsInlineActionToast"
});
// ../internal/src/components/toast/trips-stacked-action-toast.tsx
import React19 from "react";
import { gql as gql19 } from "@apollo/client";
import { useProvidedState as useProvidedState3 } from "@shared-ui/provided-state-context";
import { UitkToast as UitkToast4 } from "uitk-react-toast";
var __Fragment3 = gql19(_templateObject18(), __TripsToastButtonFragment, ClientSideImpressionAnalyticsTracker.fragment);
var TripsStackedActionToast = function (param) {
  var data = param.data;
  var _state_toastState;
  var onDismiss = useTripsToastHandler().onDismiss;
  var actionCallback = useToastAction(data);
  var _useProvidedState3 = _sliced_to_array(useProvidedState3(), 1),
    state = _useProvidedState3[0];
  var stackedActionToast = /* @__PURE__ */React19.createElement(UitkToast4, {
    onDismiss: onDismiss,
    actionCallback: actionCallback,
    actionText: data.button.primary || void 0,
    show: true,
    stacked: true,
    autoHide: true,
    verticalOffset: (_state_toastState = state.toastState) === null || _state_toastState === void 0 ? void 0 : _state_toastState.offset
  }, data.primary);
  return data.impressionTracking ? /* @__PURE__ */React19.createElement(ClientSideImpressionAnalyticsTracker, {
    data: data.impressionTracking
  }, stackedActionToast) : stackedActionToast;
};
TripsStackedActionToast.displayName = "TripsStackedActionToast";
TripsStackedActionToast.fragment = _object_spread_props(_object_spread({}, __Fragment3), {
  __typename: "TripsStackedActionToast"
});
// ../internal/src/components/toast/trips-toast.tsx
var __Fragment4 = gql20(_templateObject19(), TripsInfoToast.fragment, TripsInlineActionToast.fragment, TripsStackedActionToast.fragment);
var TripsToast = function (props) {
  var data = props.data;
  return tripsComposableElement(data, [TripsInfoToast, TripsInlineActionToast, TripsStackedActionToast]);
};
TripsToast.fragment = __Fragment4;
TripsToast.displayName = "TripsToast";
// src/components/__private/__fragments/actions/save-item-to-trip-action.tsx
import { useSignalPublisher } from "@shared-ui/signal-events-context";
// src/components/__private/__fragments/dialogs/utils.ts
var dialogName2 = "trips-dialog";
// src/components/__private/cache/update-cache-with-new-checked-state.ts
import React20 from "react";
import { useApolloClient } from "@apollo/client";
// src/components/__private/__fragments/local/trips-local-saved-item.ts
import { gql as gql21 } from "@apollo/client";
var __TripsLocalSavedItem = gql21(_templateObject20());
var __TripsLocalSavedItemQuery = gql21(_templateObject21(), __TripsLocalSavedItem);
// src/components/__private/cache/update-cache-with-new-checked-state.ts
function useUpdateCacheWithNewCheckedState() {
  var cache = useApolloClient().cache;
  return React20.useCallback(function (itemId, newCheckedState) {
    var updatedEntry = {
      __typename: "TripsLocalSavedItem",
      id: itemId,
      checked: newCheckedState
    };
    var cachedEntries = cache.readQuery({
      query: __TripsLocalSavedItemQuery
    });
    var _cachedEntries_localSavedItems_filter;
    var items = (_cachedEntries_localSavedItems_filter = cachedEntries === null || cachedEntries === void 0 ? void 0 : cachedEntries.localSavedItems.filter(function (entry) {
      return entry.id !== itemId;
    })) !== null && _cachedEntries_localSavedItems_filter !== void 0 ? _cachedEntries_localSavedItems_filter : [];
    cache.writeQuery({
      query: __TripsLocalSavedItemQuery,
      data: {
        localSavedItems: _to_consumable_array(items).concat([updatedEntry])
      }
    });
  }, [cache]);
}
// src/components/__private/state/trip-save-item-signals.ts
var SaveItemSignals = {
  TRIP_ITEM_SAVED: "TRIP_ITEM_SAVED",
  TRIP_ITEM_UNSAVED: "TRIP_ITEM_UNSAVED"
};
// src/components/__private/__fragments/shared/trips-save-item-attributes.ts
import { gql as gql30 } from "@apollo/client";
// src/components/__private/__fragments/shared/trips-save-activity-attributes.ts
import { gql as gql23 } from "@apollo/client";
// src/components/__private/__fragments/shared/date.ts
import { gql as gql22 } from "@apollo/client";
var __Date = gql22(_templateObject22());
// src/components/__private/__fragments/shared/trips-save-activity-attributes.ts
var __TripsSaveActivityAttributes = gql23(_templateObject23(), __Date);
// src/components/__private/__fragments/shared/trips-save-car-offer-attributes.ts
import { gql as gql26 } from "@apollo/client";
// src/components/__private/__fragments/shared/car-rental-location.ts
import { gql as gql24 } from "@apollo/client";
var __CarRentalLocation = gql24(_templateObject24());
// src/components/__private/__fragments/shared/date-time.ts
import { gql as gql25 } from "@apollo/client";
var __DateTime = gql25(_templateObject25());
// src/components/__private/__fragments/shared/trips-save-car-offer-attributes.ts
var __TripsSaveCarOfferAttributes = gql26(_templateObject26(), __CarRentalLocation, __DateTime);
// src/components/__private/__fragments/shared/trips-save-flight-search-attributes.ts
import { gql as gql27 } from "@apollo/client";
var __TripsSaveFlightSearchAttributes = gql27(_templateObject27(), __Date);
// src/components/__private/__fragments/shared/trips-save-package-attributes.ts
import { gql as gql28 } from "@apollo/client";
var __TripsSavePackageAttributes = gql28(_templateObject28());
// src/components/__private/__fragments/shared/trips-save-stay-attributes.ts
import { gql as gql29 } from "@apollo/client";
var __TripsSaveStayAttributes = gql29(_templateObject29(), __Date);
// src/components/__private/__fragments/shared/trips-save-item-attributes.ts
var __TripsSaveItemAttributes = gql30(_templateObject30(), __TripsSaveActivityAttributes, __TripsSaveStayAttributes, __TripsSaveFlightSearchAttributes, __TripsSaveCarOfferAttributes, __TripsSavePackageAttributes);
// src/components/__private/__fragments/actions/mutations/save-item-to-trip-mutation.ts
import { gql as gql32 } from "@apollo/client";
// src/components/__private/state/trip-change-save-item.ts
import { gql as gql31 } from "@apollo/client";
var TripsChangeSaveItem = gql31(_templateObject31());
// src/components/__private/__fragments/actions/mutations/save-item-to-trip-mutation.ts
var SaveItemToTripMutationQuery = gql32(_templateObject32(), TripsToast.fragment, TripsChangeSaveItem);
// src/components/__private/__fragments/actions/save-item-to-trip-action.tsx
var __TripsSaveItemToTripActionFragment = gql33(_templateObject33(), __TripsSaveItemAttributes);
var EVENTS2 = {
  SAVE_ITEM_TO_TRIP_ACTION_ERROR: new SystemEvent2(SystemEventLevel2.ERROR, "SAVE_ITEM_TO_TRIP_ACTION_ERROR"),
  SAVE_ITEM_TO_TRIP_ACTION_SUCCESS: new SystemEvent2(SystemEventLevel2.INFO, "SAVE_ITEM_TO_TRIP_ACTION_SUCCESS")
};
var getToast = function (response, htmlElement) {
  var __typename = response.trip.saveItemToTrip.__typename;
  if (__typename !== "TripsView") {
    return void 0;
  }
  if (!response.trip.saveItemToTrip.toast) {
    return void 0;
  }
  return renderChildren( /* @__PURE__ */React21.createElement(TripsToast, {
    data: response.trip.saveItemToTrip.toast
  }), htmlElement);
};
var useSaveItemToTripAction = function (data) {
  var context = useBexApi().context;
  var loggerEvents = useLoggerEvents2(EVENTS2);
  var htmlElement = useReactPortal2().htmlElement;
  var dialogDrawerName = useTripsDrawerName();
  var _useDialog = _sliced_to_array(useDialog(dialogDrawerName), 2),
    isDialogDrawerOpen = _useDialog[0],
    dialogDrawerActions = _useDialog[1];
  var _useDialog1 = _sliced_to_array(useDialog(dialogName2), 2),
    isDialogOpen = _useDialog1[0],
    dialogActions = _useDialog1[1];
  var updateCacheWithNewCheckedState = useUpdateCacheWithNewCheckedState();
  var mapper = useSaveItemAttributesMapper();
  var publishSignal = useSignalPublisher().publishSignal;
  var mutationActionState = useMutationActionState();
  var _useMutation = _sliced_to_array(useMutation(SaveItemToTripMutationQuery), 1),
    saveItemToTrip = _useMutation[0];
  if (data.__typename !== "TripsSaveItemToTripAction") {
    return void 0;
  }
  var tripId = data.tripId,
    saveItemInput = data.saveItemInput;
  return {
    onClick: function () {
      if (saveItemInput) {
        if (isDialogDrawerOpen) {
          dialogDrawerActions.closeDialog();
        }
        if (isDialogOpen) {
          dialogActions.closeDialog();
        }
        var itemId = saveItemInput.itemId,
          pageLocation = saveItemInput.pageLocation,
          source = saveItemInput.source,
          subscriptionAttributes = saveItemInput.subscriptionAttributes,
          tripItem = saveItemInput.tripItem;
        mutationActionState({
          status: "loading" /* Loading */
        });
        saveItemToTrip({
          variables: {
            itemInput: {
              itemId: itemId,
              pageLocation: pageLocation,
              source: source,
              attributes: mapper(saveItemInput.attributes),
              subscriptionAttributes: subscriptionAttributes ? {
                anchorPrice: subscriptionAttributes.anchorPrice
              } : void 0,
              tripItem: tripItem ? {
                tripItemId: tripItem.tripItemId,
                tripViewId: tripItem.tripViewId
              } : void 0
            },
            tripId: tripId,
            context: context
          }
        }).then(function (response) {
          if (response.data) {
            var _tripView_tripsSideEffects;
            var toast = getToast(response.data, htmlElement || document.body);
            mutationActionState({
              status: toast ? "complete" /* Complete */ : "reset" /* Reset */,
              toastElement: toast,
              refetch: true
            });
            var tripView = response.data.trip.saveItemToTrip;
            if (tripView.__typename === "TripsView" && ((_tripView_tripsSideEffects = tripView.tripsSideEffects) === null || _tripView_tripsSideEffects === void 0 ? void 0 : _tripView_tripsSideEffects.length)) {
              tripView.tripsSideEffects.forEach(function (sideEffect) {
                if (sideEffect.__typename === "TripsChangeSaveItemState") {
                  updateCacheWithNewCheckedState(sideEffect.tripItemId, sideEffect.toggleState);
                  publishSignal({
                    type: SaveItemSignals.TRIP_ITEM_SAVED,
                    payload: {
                      tripItemId: sideEffect.tripItemId,
                      toggleState: sideEffect.toggleState
                    }
                  });
                }
              });
            }
            loggerEvents.SAVE_ITEM_TO_TRIP_ACTION_SUCCESS.log({
              message: "Save item to trip succeeded.",
              variables: {
                tripItemId: itemId,
                tripViewId: tripId
              }
            });
            return Promise.resolve();
          }
          return Promise.reject(new Error("response.data is null"));
        }).catch(function (error) {
          mutationActionState({
            status: "error" /* Error */
          });
          loggerEvents.SAVE_ITEM_TO_TRIP_ACTION_ERROR.log({
            message: "Save item to trip failed.",
            variables: {
              tripItemId: itemId,
              tripViewId: tripId
            },
            error: error
          });
        });
      }
    }
  };
};
// src/components/__private/__fragments/shared/trips-save-item-properties.ts
import { gql as gql34 } from "@apollo/client";
var __TripsSaveItemProperties = gql34(_templateObject34());
// src/components/__private/state/drawer-state.ts
import { makeVar as makeVar2 } from "@apollo/client";
var tripDrawerState = makeVar2(void 0);
// src/components/__private/trip-drawer/trip-drawer.tsx
import React57 from "react";
// src/components/__private/trip-drawer/trip-creation-drawer.tsx
import React55 from "react";
import { gql as gql81, useQuery } from "@apollo/client";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { useLocalization as useLocalization2 } from "@shared-ui/localization-context";
import { SystemEvent as SystemEvent6, SystemEventLevel as SystemEventLevel6, useLoggerEvents as useLoggerEvents6 } from "@shared-ui/logger-context";
import { useReactPortal as useReactPortal5 } from "@shared-ui/portal-context";
import { UitkPageLoader as UitkPageLoader2 } from "uitk-react-loader";
import { UitkToast as UitkToast5 } from "uitk-react-toast";
// src/components/__private/__fragments/drawer/composable-drawer.tsx
import React54 from "react";
import { gql as gql80, useReactiveVar as useReactiveVar4 } from "@apollo/client";
// ../internal/src/components/drawer/trips-composable-drawer.tsx
import React22 from "react";
import { gql as gql35 } from "@apollo/client";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkSheet, UitkSheetContent, UitkSheetTransition } from "uitk-react-sheet";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading, UitkSubheading } from "uitk-react-text";
// ../internal/src/components/drawer/__private/drawer-type-mapping.ts
var TripsComposableDrawerTypeMapping = {
  BOTTOM: "bottom",
  CENTER: "centered",
  FULL: "full",
  SIDE: "side"
};
var drawer_type_mapping_default = TripsComposableDrawerTypeMapping;
// ../internal/src/components/drawer/trips-composable-drawer.tsx
var __Fragment5 = gql35(_templateObject35(), ClientSideImpressionAnalyticsIntersectionTracker.fragment);
var TripsComposableDrawer = function (param) {
  var dialogName3 = param.dialogName,
    data = param.data,
    children = param.children,
    toolBar = param.toolBar,
    triggerRef = param.triggerRef;
  var _useDialog2 = _sliced_to_array(useDialog2(dialogName3), 3),
    isDialogOpen = _useDialog2[0],
    DialogComponent = _useDialog2[2];
  var tripsViewHeader = data.tripsViewHeader,
    type = data.type;
  var _ref = tripsViewHeader !== null && tripsViewHeader !== void 0 ? tripsViewHeader : {},
    primary = _ref.primary,
    secondaries = _ref.secondaries;
  var sheetType = type ? drawer_type_mapping_default[type] : void 0;
  var composableDrawerContent = /* @__PURE__ */React22.createElement("div", null, primary && /* @__PURE__ */React22.createElement(UitkSpacing, {
    margin: secondaries && secondaries.length !== 0 ? {
      blockend: "three"
    } : {
      blockend: "six"
    }
  }, /* @__PURE__ */React22.createElement(UitkHeading, {
    tag: "h1",
    size: 4
  }, primary)), Array.isArray(secondaries) && secondaries.map(function (subheading, subheadingIndex) {
    return /* @__PURE__ */React22.createElement(UitkSpacing, {
      key: "trip-subheading-".concat(subheadingIndex),
      padding: {
        blockend: "six"
      }
    }, /* @__PURE__ */React22.createElement("div", null, /* @__PURE__ */React22.createElement(UitkSubheading, {
      tag: "p"
    }, subheading)));
  }), children);
  var composableDrawerComponents = /* @__PURE__ */React22.createElement(React22.Fragment, null, sheetType === "bottom" ? composableDrawerContent : /* @__PURE__ */React22.createElement(UitkSpacing, {
    margin: {
      small: "four",
      medium: "six"
    }
  }, composableDrawerContent));
  var composableDrawer = /* @__PURE__ */React22.createElement(UitkSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React22.createElement(DialogComponent, null, /* @__PURE__ */React22.createElement(Viewport, null, /* @__PURE__ */React22.createElement(ViewSmall, null, /* @__PURE__ */React22.createElement(UitkSheet, {
    isVisible: true,
    type: sheetType !== null && sheetType !== void 0 ? sheetType : "full",
    autoFocus: true,
    returnFocusOnClose: true,
    triggerRef: triggerRef !== null && triggerRef !== void 0 ? triggerRef : null
  }, toolBar, /* @__PURE__ */React22.createElement(UitkSheetContent, {
    key: "".concat(dialogName3, "-composable-drawer-dialog-content")
  }, composableDrawerComponents))), /* @__PURE__ */React22.createElement(ViewMedium, null, /* @__PURE__ */React22.createElement(UitkSheet, {
    isVisible: true,
    type: sheetType !== null && sheetType !== void 0 ? sheetType : "side",
    sideSheetLayout: {
      position: "trailing",
      columns: 6
    },
    triggerRef: triggerRef !== null && triggerRef !== void 0 ? triggerRef : null,
    centeredSheetSize: "small",
    autoFocus: true,
    returnFocusOnClose: true
  }, toolBar, /* @__PURE__ */React22.createElement(UitkSheetContent, {
    padded: false
  }, composableDrawerComponents))), /* @__PURE__ */React22.createElement(ViewLarge, null, /* @__PURE__ */React22.createElement(UitkSheet, {
    isVisible: true,
    type: sheetType !== null && sheetType !== void 0 ? sheetType : "side",
    sideSheetLayout: {
      position: "trailing",
      columns: 4
    },
    triggerRef: triggerRef !== null && triggerRef !== void 0 ? triggerRef : null,
    centeredSheetSize: "small",
    autoFocus: true,
    returnFocusOnClose: true
  }, toolBar, /* @__PURE__ */React22.createElement(UitkSheetContent, {
    padded: false
  }, composableDrawerComponents))))));
  return data.impressionTracking ? /* @__PURE__ */React22.createElement(ClientSideImpressionAnalyticsIntersectionTracker, {
    data: data.impressionTracking
  }, composableDrawer) : composableDrawer;
};
TripsComposableDrawer.displayName = "TripsComposableDrawer";
TripsComposableDrawer.fragment = __Fragment5;
// src/components/__private/__fragments/action-elements/primary-button.tsx
import React29 from "react";
import { gql as gql49, useReactiveVar as useReactiveVar2 } from "@apollo/client";
// ../internal/src/components/action-elements/trips-primary-button.tsx
import React23 from "react";
import { gql as gql36 } from "@apollo/client";
import { UitkPrimaryButton } from "uitk-react-button";
import { UitkIcon as UitkIcon2, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
var __Fragment6 = gql36(_templateObject36());
var TripsPrimaryButton = function (props) {
  var data = props.data,
    actionProps = _object_without_properties(props, ["data"]);
  if (!data || !data.primary) {
    return null;
  }
  var primary = data.primary,
    icon = data.icon,
    width = data.width,
    accessibility = data.accessibility;
  var isFullWidth = width === "MATCH_PARENT_CONTAINER" /* MATCH_PARENT_CONTAINER */;
  return /* @__PURE__ */React23.createElement(UitkPrimaryButton, _object_spread({
    "aria-label": (accessibility === null || accessibility === void 0 ? void 0 : accessibility.label) ? accessibility.label : primary,
    isFullWidth: isFullWidth
  }, actionProps), icon && /* @__PURE__ */React23.createElement(UitkIcon2, {
    name: icon.id,
    size: UitkIconSize2.MEDIUM
  }), primary);
};
TripsPrimaryButton.displayName = "TripsPrimaryButton";
TripsPrimaryButton.fragment = _object_spread_props(_object_spread({}, __Fragment6), {
  __typename: "TripsPrimaryButton"
});
// ../internal/src/components/action-elements/trips-secondary-button.tsx
import React24 from "react";
import { gql as gql37 } from "@apollo/client";
import { UitkSecondaryButton } from "uitk-react-button";
import { UitkIcon as UitkIcon3, UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
var __Fragment7 = gql37(_templateObject37());
var TripsSecondaryButton = function (props) {
  var data = props.data,
    _props_isFullWidth = props.isFullWidth,
    isFullWidth = _props_isFullWidth === void 0 ? true : _props_isFullWidth,
    actionProps = props.actionProps;
  if (!data || !data.primary) {
    return null;
  }
  var primary = data.primary,
    icon = data.icon,
    disabled = data.disabled,
    accessibility = data.accessibility;
  var _accessibility_label;
  return /* @__PURE__ */React24.createElement(UitkSpacing2, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React24.createElement("div", null, /* @__PURE__ */React24.createElement(UitkSecondaryButton, _object_spread_props(_object_spread({
    "aria-label": (_accessibility_label = accessibility === null || accessibility === void 0 ? void 0 : accessibility.label) !== null && _accessibility_label !== void 0 ? _accessibility_label : primary,
    disabled: disabled
  }, actionProps), {
    isFullWidth: isFullWidth
  }), icon && /* @__PURE__ */React24.createElement(UitkIcon3, {
    name: icon.id,
    size: UitkIconSize3.MEDIUM
  }), primary)));
};
TripsSecondaryButton.displayName = "TripsSecondaryButton";
TripsSecondaryButton.fragment = _object_spread_props(_object_spread({}, __Fragment7), {
  __typename: "TripsSecondaryButton"
});
TripsSecondaryButton.getKey = function (secondaryButton) {
  return secondaryButton.primary;
};
// ../internal/src/components/action-elements/trips-tertiary-button.tsx
import React25 from "react";
import { gql as gql38 } from "@apollo/client";
import { UitkButtonSize, UitkTertiaryButton } from "uitk-react-button";
import { UitkIcon as UitkIcon4 } from "uitk-react-icons";
var __Fragment8 = gql38(_templateObject38());
var TripsTertiaryButton = function (props) {
  var data = props.data,
    actionProps = _object_without_properties(props, ["data"]);
  if (!data || !data.primary && !data.icon) {
    return null;
  }
  var primary = data.primary,
    icon = data.icon,
    disabled = data.disabled,
    width = data.width,
    accessibility = data.accessibility;
  var isFullWidth = width === "MATCH_PARENT_CONTAINER" /* MATCH_PARENT_CONTAINER */;
  return /* @__PURE__ */React25.createElement(UitkTertiaryButton, _object_spread({
    size: primary ? UitkButtonSize.MEDIUM : UitkButtonSize.LARGE,
    "aria-label": (accessibility === null || accessibility === void 0 ? void 0 : accessibility.label) ? accessibility.label : primary !== null && primary !== void 0 ? primary : icon === null || icon === void 0 ? void 0 : icon.description,
    disabled: disabled,
    className: primary ? "" : "uitk-button-only-icon",
    isFullWidth: isFullWidth
  }, actionProps), icon && /* @__PURE__ */React25.createElement(UitkIcon4, {
    name: icon.id
  }), primary);
};
TripsTertiaryButton.displayName = "TripsTertiaryButton";
TripsTertiaryButton.fragment = _object_spread_props(_object_spread({}, __Fragment8), {
  __typename: "TripsTertiaryButton"
});
// ../internal/src/components/actions/link.ts
import { gql as gql39 } from "@apollo/client";
var TripsLinkActionFragment = gql39(_templateObject39());
var useTripsLinkAction = function (data) {
  var _data_resource;
  if (data === null || data === void 0 ? void 0 : (_data_resource = data.resource) === null || _data_resource === void 0 ? void 0 : _data_resource.value) {
    return {
      href: data.resource.value,
      target: data.target === "EXTERNAL" /* EXTERNAL */ ? "_blank" : "_self",
      rel: data.target === "EXTERNAL" /* EXTERNAL */ ? "noopener noreferrer" : ""
    };
  }
  return {};
};
// src/components/__private/__fragments/actions/action-hook.ts
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
// src/components/__private/__fragments/actions/create-trip-from-item-action.tsx
import { gql as gql40 } from "@apollo/client";
// ../internal/src/components/actions/mutations/form-submit-mutation.ts
import { useMutation as useMutation2 } from "@apollo/client";
import { getOperationName } from "@apollo/client/utilities";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
import { SystemEvent as SystemEvent3, SystemEventLevel as SystemEventLevel3, useLoggerEvents as useLoggerEvents3 } from "@shared-ui/logger-context";
import { useReactPortal as useReactPortal3 } from "@shared-ui/portal-context";
import { useProvidedState as useProvidedState4 } from "@shared-ui/provided-state-context";
import { useEmitSignalsHandler } from "@shared-ui/retail-trips-providers";
// ../internal/src/components/state/validated-inputs-state.ts
var ValidatedInputsState = function ValidatedInputsState() {
  "use strict";

  _class_call_check(this, ValidatedInputsState);
  __publicField(this, "data", {
    inputFields: []
  });
  __publicField(this, "stateFieldName", "validatedInputs");
  __publicField(this, "events", ["addInputField" /* AddInputField */, "updateInputValue" /* UpdateInputValue */, "updateInputErrorMessage" /* UpdateInputErrorMessage */, "removeInputField" /* RemoveInputField */]);
  // eslint-disable-next-line class-methods-use-this
  __publicField(this, "update", function (event, currentState, payload) {
    switch (event) {
      case "addInputField" /* AddInputField */:
        return _object_spread_props(_object_spread({}, currentState), {
          inputFields: _to_consumable_array(currentState.inputFields).concat([{
            inputId: payload.data.inputId,
            inputValue: payload.data.inputValue,
            currentErrorMessage: void 0,
            validations: payload.data.validations
          }])
        });
      case "updateInputValue" /* UpdateInputValue */:
        return _object_spread_props(_object_spread({}, currentState), {
          inputFields: _to_consumable_array(currentState.inputFields.map(function (inputField) {
            if (inputField.inputId === payload.data.inputId) {
              return _object_spread_props(_object_spread({}, inputField), {
                inputValue: payload.data.inputValue
              });
            }
            return inputField;
          }))
        });
      case "updateInputErrorMessage" /* UpdateInputErrorMessage */:
        return _object_spread_props(_object_spread({}, currentState), {
          inputFields: _to_consumable_array(currentState.inputFields.map(function (inputField) {
            if (inputField.inputId === payload.data.inputId) {
              return _object_spread_props(_object_spread({}, inputField), {
                currentErrorMessage: payload.data.currentErrorMessage
              });
            }
            return inputField;
          }))
        });
      case "removeInputField" /* RemoveInputField */:
        return _object_spread_props(_object_spread({}, currentState), {
          inputFields: _to_consumable_array(currentState.inputFields.filter(function (inputField) {
            return payload.data.inputId !== inputField.inputId;
          }))
        });
      default:
        return _object_spread({}, currentState);
    }
  });
};
// ../internal/src/components/input/validations/validation-helper.ts
var EMAIl_REGEX = /^[a-zA-Z0-9.!#$%&’*+=?^_`{|}~-]+@[a-zA-Z0-9_-]+(\.\w{2,3})+$/;
var runValidation = function (inputValue, validations) {
  var errorMessageToReturn = "";
  if (!(validations === null || validations === void 0 ? void 0 : validations.length)) {
    return errorMessageToReturn;
  }
  var inputValueTrimmedLeadingAndTrailingWhitespaces = inputValue.trim();
  var inputValueLength = inputValueTrimmedLeadingAndTrailingWhitespaces.length;
  validations.every(function (validation) {
    switch (validation.__typename) {
      case "EGDSRequiredInputValidation":
        if (inputValueTrimmedLeadingAndTrailingWhitespaces.length < 1) {
          errorMessageToReturn = validation.errorMessage;
          return false;
        }
        return true;
      case "EGDSMaxLengthInputValidation":
        if (inputValueLength > validation.maxLength) {
          errorMessageToReturn = validation.errorMessage;
          return false;
        }
        return true;
      case "EGDSMinLengthInputValidation":
        if (inputValueLength < validation.minLength) {
          errorMessageToReturn = validation.errorMessage;
          return false;
        }
        return true;
      case "MultiEmailValidation":
        if (inputValueTrimmedLeadingAndTrailingWhitespaces.includes(",")) {
          var emailAddresses = inputValueTrimmedLeadingAndTrailingWhitespaces.split(",");
          var emailAddressesTrimmedLeadingAndTrailingWhitespaces = emailAddresses.map(function (email) {
            return email.trim();
          });
          var isEveryEmailAddressesPassedValidation = emailAddressesTrimmedLeadingAndTrailingWhitespaces.every(function (emailAddress) {
            if (!emailAddress.match(EMAIl_REGEX)) {
              return false;
            }
            return true;
          });
          if (!isEveryEmailAddressesPassedValidation) {
            errorMessageToReturn = validation.errorMessage;
            return false;
          }
        } else if (!inputValueTrimmedLeadingAndTrailingWhitespaces.match(EMAIl_REGEX)) {
          errorMessageToReturn = validation.errorMessage;
          return false;
        }
        return true;
      case "SingleEmailValidation":
        if (!inputValueTrimmedLeadingAndTrailingWhitespaces.match(EMAIl_REGEX)) {
          errorMessageToReturn = validation.errorMessage;
          return false;
        }
        return true;
      case "EGDSRegexInputValidation":
        if (!inputValueTrimmedLeadingAndTrailingWhitespaces.match(validation.pattern)) {
          errorMessageToReturn = validation.errorMessage;
          return false;
        }
        return true;
      default:
        return true;
    }
  });
  return errorMessageToReturn;
};
var isFormSubmissionValid = function (inputsRequiredForSubmission, dispatch) {
  if (!inputsRequiredForSubmission.length) {
    return false;
  }
  return inputsRequiredForSubmission.every(function (inputField) {
    var errorMessage = runValidation(inputField.inputValue, inputField.validations);
    dispatch({
      type: "updateInputErrorMessage" /* UpdateInputErrorMessage */,
      payload: {
        inputId: inputField.inputId,
        currentErrorMessage: errorMessage
      }
    });
    return errorMessage === "" || !inputField.validations;
  });
};
// ../internal/src/components/actions/mutations/form-submit-mutation.ts
var EVENTS3 = {
  TRIPS_MUTATION_SEND_INFO: new SystemEvent3(SystemEventLevel3.INFO, "TRIPS_MUTATION_SEND_INFO"),
  TRIPS_MUTATION_SEND_SUCCESS_INFO: new SystemEvent3(SystemEventLevel3.INFO, "TRIPS_MUTATION_SEND_SUCCESS_INFO"),
  TRIPS_MUTATION_SEND_ERROR: new SystemEvent3(SystemEventLevel3.ERROR, "TRIPS_MUTATION_SEND_ERROR"),
  TRIPS_MUTATION_SEND_INPUTS_NOT_VALIDATED_INFO: new SystemEvent3(SystemEventLevel3.INFO, "TRIPS_MUTATION_SEND_INPUTS_NOT_VALIDATED_INFO")
};
var FormSubmitMutation = function (mutation, variables, getToast3) {
  var refetch = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false,
    emitSignalValues = arguments.length > 4 ? arguments[4] : void 0,
    onComplete = arguments.length > 5 ? arguments[5] : void 0,
    inputsKey = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "inputs";
  var context = useBexApi2().context;
  var loggingEvents = useLoggerEvents3(EVENTS3);
  var _useProvidedState4 = _sliced_to_array(useProvidedState4(), 2),
    state = _useProvidedState4[0],
    dispatch = _useProvidedState4[1];
  var drawerName2 = useTripsDrawerName();
  var _useDialog3 = _sliced_to_array(useDialog3(drawerName2), 2),
    dialogActions = _useDialog3[1];
  var emit = useEmitSignalsHandler(emitSignalValues).emit;
  var htmlElement = useReactPortal3().htmlElement;
  var mutationActionState = useMutationActionState();
  var mutationName = getOperationName(mutation);
  var _useMutation2 = _sliced_to_array(useMutation2(mutation), 1),
    applyFormMutation = _useMutation2[0];
  var onClick = function () {
    mutationActionState({
      status: "loading" /* Loading */
    });
    loggingEvents.TRIPS_MUTATION_SEND_INFO.log({
      message: "Sending ".concat(mutationName),
      variables: variables
    });
    var inputIds = variables.inputIds,
      restVariables = _object_without_properties(variables, ["inputIds"]);
    var inputsRequiredForMutation = state.validatedInputs.inputFields.filter(function (inputField) {
      return inputIds.includes(inputField.inputId);
    });
    if (!isFormSubmissionValid(inputsRequiredForMutation, dispatch)) {
      mutationActionState({
        status: "reset" /* Reset */
      });
      loggingEvents.TRIPS_MUTATION_SEND_INPUTS_NOT_VALIDATED_INFO.log({
        message: "".concat(mutationName, " mutation failed because some inputs validations failed"),
        variables: variables,
        requiredVariables: inputsRequiredForMutation
      });
      var invalidInputField = state.validatedInputs.inputFields.find(function (inputField) {
        return runValidation(inputField.inputValue, inputField.validations) !== "";
      });
      if (invalidInputField) {
        var _document_getElementById;
        var inputElement = (_document_getElementById = document.getElementById(invalidInputField.inputId)) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.focus();
      }
      return;
    }
    var mutationInputs = inputsRequiredForMutation.map(function (inputfield) {
      return {
        key: inputfield.inputId,
        value: inputfield.inputValue
      };
    });
    emit();
    var mutationVariables = _object_spread(_define_property({
      context: context
    }, inputsKey, mutationInputs), restVariables);
    dialogActions.closeDialog();
    inputIds.forEach(function (inputId) {
      dispatch({
        type: "removeInputField" /* RemoveInputField */,
        payload: {
          inputId: inputId
        }
      });
    });
    applyFormMutation({
      variables: mutationVariables
    }).then(function (response) {
      loggingEvents.TRIPS_MUTATION_SEND_SUCCESS_INFO.log({
        message: "".concat(mutationName, " mutation complete"),
        variables: variables
      });
      var toast = getToast3(response.data, htmlElement);
      mutationActionState({
        status: toast ? "complete" /* Complete */ : "reset" /* Reset */,
        toastElement: toast,
        refetch: refetch
      });
      onComplete === null || onComplete === void 0 ? void 0 : onComplete(response.data);
    }).catch(function (error) {
      mutationActionState({
        status: "error" /* Error */
      });
      loggingEvents.TRIPS_MUTATION_SEND_ERROR.log({
        message: "".concat(mutationName, " mutation failed on send"),
        variables: variables,
        error: error
      });
    });
  };
  return {
    onClick: onClick
  };
};
// src/components/__private/__fragments/actions/create-trip-from-item-action.tsx
var __TripsCreateTripFromItemActionFragment = gql40(_templateObject40(), __TripsSaveItemAttributes);
var useTripsCreateTripFromItemAction = function (data) {
  var mapper = useSaveItemAttributesMapper();
  var updateCacheWithNewCheckedState = useUpdateCacheWithNewCheckedState();
  if (data.__typename !== "TripsCreateTripFromItemAction") {
    return void 0;
  }
  var saveItemInput = data.saveItemInput,
    inputIds = data.inputIds;
  if (!saveItemInput) {
    return void 0;
  }
  var itemId = saveItemInput.itemId,
    pageLocation = saveItemInput.pageLocation,
    attributes = saveItemInput.attributes,
    subscriptionAttributes = saveItemInput.subscriptionAttributes;
  var mutationData = {
    inputIds: inputIds,
    itemInput: {
      itemId: itemId,
      pageLocation: pageLocation,
      attributes: mapper(attributes),
      subscriptionAttributes: subscriptionAttributes ? {
        anchorPrice: subscriptionAttributes.anchorPrice
      } : void 0
    }
  };
  var updateCacheWithResponse = function (responseData) {
    var _tripView_tripsSideEffects;
    var tripView = responseData === null || responseData === void 0 ? void 0 : responseData.trip.saveItemToTrip;
    if ((tripView === null || tripView === void 0 ? void 0 : tripView.__typename) === "TripsView" && ((_tripView_tripsSideEffects = tripView.tripsSideEffects) === null || _tripView_tripsSideEffects === void 0 ? void 0 : _tripView_tripsSideEffects.length)) {
      tripView.tripsSideEffects.forEach(function (sideEffect) {
        if (sideEffect.__typename === "TripsChangeSaveItemState") {
          updateCacheWithNewCheckedState(sideEffect.tripItemId, sideEffect.toggleState);
        }
      });
    }
  };
  return FormSubmitMutation(SaveItemToTripMutationQuery, mutationData, getToast, true, [], updateCacheWithResponse, "newTripInputs");
};
// src/components/__private/__fragments/actions/dismiss-drawer-action.ts
import React26 from "react";
import { gql as gql41 } from "@apollo/client";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
var TripsDismissDrawerActionFragment = gql41(_templateObject41());
var useTripsDismissDrawerAction = function () {
  var drawerName2 = useTripsDrawerName();
  var _useDialog4 = _sliced_to_array(useDialog4(drawerName2), 2),
    dialogActions = _useDialog4[1];
  return {
    onClick: React26.useCallback(function () {
      dialogActions.closeDialog();
    }, [dialogActions])
  };
};
// src/components/__private/__fragments/actions/open-create-new-trip-drawer-for-item-action.tsx
import { gql as gql42 } from "@apollo/client";
var __TripsOpenCreateNewTripDrawerForItemActionFragment = gql42(_templateObject42(), __TripsSaveItemAttributes);
var useTripsOpenCreateNewTripDrawerForItemAction = function (data) {
  var mapper = useSaveItemAttributesMapper();
  if (data.__typename !== "TripsOpenCreateNewTripDrawerForItemAction") {
    return void 0;
  }
  var createTripMetadata = data.createTripMetadata;
  if (!createTripMetadata) {
    return void 0;
  }
  var saveItemInput = createTripMetadata.saveItemInput;
  if (!saveItemInput) {
    return void 0;
  }
  var itemId = saveItemInput.itemId,
    pageLocation = saveItemInput.pageLocation,
    attributes = saveItemInput.attributes,
    subscriptionAttributes = saveItemInput.subscriptionAttributes;
  var newDrawerState = {
    type: "TripCreationDrawerOptions",
    queryInputs: {
      item: {
        itemId: itemId,
        saveItemInput: {
          itemId: itemId,
          pageLocation: pageLocation,
          attributes: mapper(attributes),
          subscriptionAttributes: subscriptionAttributes ? {
            anchorPrice: subscriptionAttributes.anchorPrice
          } : void 0
        }
      }
    }
  };
  return {
    onClick: function () {
      tripDrawerState(newDrawerState);
    }
  };
};
// src/components/__private/__fragments/actions/open-save-to-trip-drawer-action.tsx
import { gql as gql43 } from "@apollo/client";
import { useDialog as useDialog5 } from "@shared-ui/dialog-context";
import { SystemEvent as SystemEvent4, SystemEventLevel as SystemEventLevel4, useLoggerEvents as useLoggerEvents4 } from "@shared-ui/logger-context";
var TRIPS_OPEN_SAVE_TO_TRIP_DRAWER_ACTION_INFO = new SystemEvent4(SystemEventLevel4.INFO, "TRIPS_OPEN_SAVE_TO_TRIP_DRAWER_ACTION_INFO");
var __TripsOpenSaveToTripDrawerActionFragment = gql43(_templateObject43(), __TripsSaveItemAttributes);
var useTripsOpenSaveToTripDrawerAction = function (data) {
  var loggerEvents = useLoggerEvents4({
    TRIPS_OPEN_SAVE_TO_TRIP_DRAWER_ACTION_INFO: TRIPS_OPEN_SAVE_TO_TRIP_DRAWER_ACTION_INFO
  });
  var drawerName2 = useTripsDrawerName();
  var _useDialog5 = _sliced_to_array(useDialog5(drawerName2), 2),
    dialogActions = _useDialog5[1];
  var mapper = useSaveItemAttributesMapper();
  if ((data === null || data === void 0 ? void 0 : data.__typename) !== "TripsOpenSaveToTripDrawerAction") {
    return void 0;
  }
  var input = data.input;
  var itemId = input.itemId,
    pageLocation = input.pageLocation,
    attributes = input.attributes,
    subscriptionAttributes = input.subscriptionAttributes,
    tripItem = input.tripItem;
  var newDrawerState = {
    type: "TripSaveItemDrawerOptions",
    queryInputs: {
      item: {
        itemId: itemId,
        pageLocation: pageLocation,
        attributes: mapper(attributes),
        subscriptionAttributes: subscriptionAttributes ? {
          anchorPrice: subscriptionAttributes.anchorPrice
        } : void 0,
        tripItem: tripItem ? {
          tripItemId: tripItem.tripItemId,
          tripViewId: tripItem.tripViewId
        } : void 0
      }
    }
  };
  return {
    onClick: function () {
      loggerEvents.TRIPS_OPEN_SAVE_TO_TRIP_DRAWER_ACTION_INFO.log({
        message: "Save to trip button clicked",
        variables: {
          tripItemId: itemId
        }
      });
      dialogActions.openDialog();
      tripDrawerState(newDrawerState);
    }
  };
};
// src/components/__private/__fragments/actions/trips-dialog-dismiss-action.tsx
import { gql as gql44 } from "@apollo/client";
import { useDialog as useDialog6 } from "@shared-ui/dialog-context";
var __TripsDialogDismissActionFragment = gql44(_templateObject44());
var useTripsDismissAction = function (data) {
  var dialogName3 = useTripsDialogName();
  var _useDialog6 = _sliced_to_array(useDialog6(dialogName3), 2),
    dialogActions = _useDialog6[1];
  var mutationActionState = useMutationActionState();
  if (data.__typename !== "TripsDismissAction") {
    return void 0;
  }
  return {
    onClick: function () {
      mutationActionState({
        status: "reset" /* Reset */
      });
      dialogActions.closeDialog();
    }
  };
};
// src/components/__private/__fragments/actions/trips-form-action.tsx
import React27 from "react";
import { gql as gql46 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { useProvidedState as useProvidedState5 } from "@shared-ui/provided-state-context";
import { useSignalPublisher as useSignalPublisher2 } from "@shared-ui/signal-events-context";
// src/components/__private/__fragments/actions/form-data/trips-form-data.ts
import { gql as gql45 } from "@apollo/client";
var __TripsFormDataFragment = gql45(_templateObject45(), __TripsSaveItemAttributes);
// src/components/__private/__fragments/actions/trips-form-action.tsx
var __TripsFormActionFragment = gql46(_templateObject46(), __TripsFormDataFragment);
var useTripsFormActionAction = function (data) {
  var mapper = useSaveItemAttributesMapper();
  var updateCacheWithNewCheckedState = useUpdateCacheWithNewCheckedState();
  var trackClick = useClickTracker2();
  var _useProvidedState5 = _sliced_to_array(useProvidedState5(), 1),
    state = _useProvidedState5[0];
  var publishSignal = useSignalPublisher2().publishSignal;
  var getCurrentInputValue = React27.useCallback(function (inputId) {
    var inputField = state.validatedInputs.inputFields.find(function (field) {
      return field.inputId === inputId;
    });
    return inputField ? inputField.inputValue : void 0;
  }, [state.validatedInputs.inputFields]);
  var trackedValuesRef = React27.useRef( /* @__PURE__ */new Set());
  React27.useEffect(function () {
    var _data_validatedInputAnalytics;
    if (data.__typename !== "TripsFormAction") {
      return void 0;
    }
    (_data_validatedInputAnalytics = data.validatedInputAnalytics) === null || _data_validatedInputAnalytics === void 0 ? void 0 : _data_validatedInputAnalytics.forEach(function (param) {
      var egdsElementId = param.egdsElementId,
        referenceValue = param.referenceValue,
        analytics = param.analytics;
      if (trackedValuesRef.current.has(egdsElementId)) {
        return void 0;
      }
      var currentValue = getCurrentInputValue(egdsElementId);
      if (currentValue !== void 0 && currentValue !== referenceValue) {
        trackClick(analytics.referrerId, analytics.linkName);
        trackedValuesRef.current.add(egdsElementId);
      }
    });
  }, [data, getCurrentInputValue, trackClick]);
  if (data.__typename !== "TripsFormAction") {
    return void 0;
  }
  var validatedInputIds = data.validatedInputIds,
    formData = data.formData,
    type = data.type;
  if ((formData === null || formData === void 0 ? void 0 : formData.__typename) !== "TripsCreateTripFromItem") {
    return void 0;
  }
  var _formData_input = formData.input,
    itemId = _formData_input.itemId,
    source = _formData_input.source,
    pageLocation = _formData_input.pageLocation,
    attributes = _formData_input.attributes,
    subscriptionAttributes = _formData_input.subscriptionAttributes;
  if (!validatedInputIds.length) {
    return {};
  }
  switch (type) {
    case "CREATE_NEW_TRIP_FROM_ITEM" /* CREATE_NEW_TRIP_FROM_ITEM */:
      {
        var getToast3 = function (response, htmlElement) {
          var _response_trip_saveItemToTrip;
          if (response.trip.saveItemToTrip.__typename !== "TripsView") {
            return void 0;
          }
          var _ref;
          return (_ref = ((_response_trip_saveItemToTrip = response.trip.saveItemToTrip) === null || _response_trip_saveItemToTrip === void 0 ? void 0 : _response_trip_saveItemToTrip.toast) && renderChildren( /* @__PURE__ */React27.createElement(TripsToast, {
            data: response.trip.saveItemToTrip.toast
          }), htmlElement)) !== null && _ref !== void 0 ? _ref : void 0;
        };
        var mutationData = {
          inputIds: validatedInputIds,
          itemInput: {
            itemId: itemId,
            pageLocation: pageLocation,
            source: source,
            attributes: mapper(attributes),
            subscriptionAttributes: subscriptionAttributes ? {
              anchorPrice: subscriptionAttributes.anchorPrice
            } : void 0
          }
        };
        var updateCacheWithResponse = function (responseData) {
          var _tripView_tripsSideEffects;
          var tripView = responseData === null || responseData === void 0 ? void 0 : responseData.trip.saveItemToTrip;
          if ((tripView === null || tripView === void 0 ? void 0 : tripView.__typename) === "TripsView" && ((_tripView_tripsSideEffects = tripView.tripsSideEffects) === null || _tripView_tripsSideEffects === void 0 ? void 0 : _tripView_tripsSideEffects.length)) {
            tripView.tripsSideEffects.forEach(function (sideEffect) {
              if (sideEffect.__typename === "TripsChangeSaveItemState") {
                updateCacheWithNewCheckedState(sideEffect.tripItemId, sideEffect.toggleState);
                publishSignal({
                  type: SaveItemSignals.TRIP_ITEM_SAVED,
                  payload: {
                    tripItemId: sideEffect.tripItemId,
                    toggleState: sideEffect.toggleState
                  }
                });
              }
            });
          }
        };
        return FormSubmitMutation(SaveItemToTripMutationQuery, mutationData, getToast3, true, [], updateCacheWithResponse, "newTripInputs");
      }
    default:
      return {};
  }
};
// src/components/__private/__fragments/actions/trips-open-dialog-action.tsx
import { useDialog as useDialog7 } from "@shared-ui/dialog-context";
// src/components/__private/state/dialog-state.ts
import { makeVar as makeVar3 } from "@apollo/client";
var dialogState = makeVar3(void 0);
// src/components/__private/__fragments/actions/trips-open-dialog-action.tsx
var useTripsOpenDialogAction = function (data) {
  var dialogName3 = useTripsDialogName();
  var _useDialog7 = _sliced_to_array(useDialog7(dialogName3), 2),
    dialogActions = _useDialog7[1];
  if (data.__typename !== "TripsOpenDialogAction") {
    return void 0;
  }
  var modalDialog = data.modalDialog;
  if (!modalDialog) {
    return {};
  }
  return {
    onClick: function () {
      dialogState(modalDialog);
      dialogActions.openDialog();
    }
  };
};
// src/components/__private/__fragments/actions/unsave-item-from-trip-action.tsx
import React28 from "react";
import { gql as gql48, useMutation as useMutation3 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { useDialog as useDialog8 } from "@shared-ui/dialog-context";
import { SystemEvent as SystemEvent5, SystemEventLevel as SystemEventLevel5, useLoggerEvents as useLoggerEvents5 } from "@shared-ui/logger-context";
import { useReactPortal as useReactPortal4 } from "@shared-ui/portal-context";
import { useSignalPublisher as useSignalPublisher3 } from "@shared-ui/signal-events-context";
// src/components/__private/__fragments/actions/mutations/unsave-item-from-trip-mutation.ts
import { gql as gql47 } from "@apollo/client";
var UnsaveItemFromTripMutation = gql47(_templateObject47(), TripsToast.fragment, TripsChangeSaveItem);
// src/components/__private/__fragments/actions/unsave-item-from-trip-action.tsx
var __TripsUnsaveItemFromTripActionFragment = gql48(_templateObject48());
var EVENTS4 = {
  UNSAVE_ITEM_FROM_TRIP_ACTION_ERROR: new SystemEvent5(SystemEventLevel5.ERROR, "UNSAVE_ITEM_FROM_TRIP_ACTION_ERROR"),
  UNSAVE_ITEM_FROM_TRIP_ACTION_SUCCESS: new SystemEvent5(SystemEventLevel5.INFO, "UNSAVE_ITEM_FROM_TRIP_ACTION_SUCCESS")
};
var getToast2 = function (response, htmlElement) {
  var __typename = response.trip.unsaveItemFromTrip.__typename;
  if (__typename !== "TripsView") {
    return void 0;
  }
  if (!response.trip.unsaveItemFromTrip.toast) {
    return void 0;
  }
  return renderChildren( /* @__PURE__ */React28.createElement(TripsToast, {
    data: response.trip.unsaveItemFromTrip.toast
  }), htmlElement);
};
var useUnsaveItemFromTripAction = function (data) {
  var context = useBexApi3().context;
  var loggerEvents = useLoggerEvents5(EVENTS4);
  var htmlElement = useReactPortal4().htmlElement;
  var _useMutation3 = _sliced_to_array(useMutation3(UnsaveItemFromTripMutation), 1),
    unsaveItemFromTrip = _useMutation3[0];
  var drawerName2 = useTripsDrawerName();
  var _useDialog8 = _sliced_to_array(useDialog8(drawerName2), 2),
    dialogActions = _useDialog8[1];
  var updateCacheWithNewCheckedState = useUpdateCacheWithNewCheckedState();
  var publishSignal = useSignalPublisher3().publishSignal;
  var mutationActionState = useMutationActionState();
  if (data.__typename !== "TripsUnsaveItemFromTripAction") {
    return void 0;
  }
  var tripItem = data.tripItem,
    tripEntity = data.tripEntity;
  var tripItemId = tripItem.tripItemId,
    tripViewId = tripItem.tripViewId;
  return {
    onClick: function () {
      dialogActions.closeDialog();
      mutationActionState({
        status: "loading" /* Loading */
      });
      unsaveItemFromTrip({
        variables: {
          tripItem: {
            tripItemId: tripItemId,
            tripViewId: tripViewId
          },
          tripEntity: tripEntity,
          context: context
        }
      }).then(function (response) {
        if (response.data) {
          var _tripView_tripsSideEffects;
          var toast = getToast2(response.data, htmlElement);
          mutationActionState({
            status: toast ? "complete" /* Complete */ : "reset" /* Reset */,
            toastElement: toast,
            refetch: true
          });
          var tripView = response.data.trip.unsaveItemFromTrip;
          if (tripView.__typename === "TripsView" && ((_tripView_tripsSideEffects = tripView.tripsSideEffects) === null || _tripView_tripsSideEffects === void 0 ? void 0 : _tripView_tripsSideEffects.length)) {
            tripView.tripsSideEffects.forEach(function (sideEffect) {
              if (sideEffect.__typename === "TripsChangeSaveItemState") {
                updateCacheWithNewCheckedState(sideEffect.tripItemId, sideEffect.toggleState);
                publishSignal({
                  type: SaveItemSignals.TRIP_ITEM_UNSAVED,
                  payload: {
                    tripItemId: sideEffect.tripItemId,
                    toggleState: sideEffect.toggleState
                  }
                });
              }
            });
          }
          loggerEvents.UNSAVE_ITEM_FROM_TRIP_ACTION_SUCCESS.log({
            message: "Unsave item from trip success",
            variables: {
              tripItemId: tripItemId,
              tripViewId: tripViewId
            }
          });
          return Promise.resolve();
        }
        return Promise.reject(new Error("response.data is null"));
      }).catch(function (error) {
        mutationActionState({
          status: "error" /* Error */
        });
        loggerEvents.UNSAVE_ITEM_FROM_TRIP_ACTION_ERROR.log({
          message: "Unsave item from trip failed",
          variables: {
            tripItemId: tripItemId,
            tripViewId: tripViewId
          },
          error: error
        });
      });
    }
  };
};
// src/components/__private/__fragments/actions/action-hook.ts
var useInvalidAction = function () {
  return void 0;
};
var ActionMap = {
  TripsInvalidValidAction: useInvalidAction,
  TripsSaveItemToTripAction: useSaveItemToTripAction,
  TripsUnsaveItemFromTripAction: useUnsaveItemFromTripAction,
  TripsDismissDrawerAction: useTripsDismissDrawerAction,
  TripsOpenCreateNewTripDrawerForItemAction: useTripsOpenCreateNewTripDrawerForItemAction,
  TripsCreateTripFromItemAction: useTripsCreateTripFromItemAction,
  TripsNavigateToViewAction: useTripsNavigateToViewAction,
  TripsDismissAction: useTripsDismissAction,
  TripsLinkAction: useTripsLinkAction,
  TripsFormAction: useTripsFormActionAction,
  TripsOpenSaveToTripDrawerAction: useTripsOpenSaveToTripDrawerAction,
  TripsOpenDialogAction: useTripsOpenDialogAction
};
function isValidActionType(action) {
  return Boolean(action && Object.keys(ActionMap).find(function (validAction) {
    return action.__typename === validAction;
  }));
}
var useActionMap = function (unknownAction) {
  var clickTracker = useClickTracker3();
  var action = isValidActionType(unknownAction) ? unknownAction : {
    __typename: "TripsInvalidValidAction"
  };
  var hookResponse = ActionMap[action.__typename](action);
  if (action.__typename === "TripsInvalidValidAction" || !hookResponse) {
    return {};
  }
  return _object_spread({
    onClickCapture: function () {
      var uisPrimeMessages = action.analytics.uisPrimeMessages.map(function (value) {
        return {
          messageContent: JSON.parse(value.messageContent),
          schemaName: value.schemaName
        };
      });
      clickTracker(action.analytics.referrerId, action.analytics.linkName, false, uisPrimeMessages);
    }
  }, hookResponse);
};
// src/components/__private/__fragments/action-elements/primary-button.tsx
var __Fragment9 = gql49(_templateObject49(), TripsPrimaryButton.fragment, TripsLinkActionFragment, __TripsNavigateToViewActionFragment, __TripsOpenCreateNewTripDrawerForItemActionFragment, __TripsCreateTripFromItemActionFragment, __TripsFormActionFragment);
var PrimaryButton = function (props) {
  var data = props.data;
  var mutationActionState = useMutationActionState();
  var mutationActionStateData = useReactiveVar2(mutationActionState);
  var actionProps = useActionMap(data.action);
  var actions = _object_spread_props(_object_spread({}, actionProps), {
    disabled: data.disabled || actionProps.disabled || (mutationActionStateData === null || mutationActionStateData === void 0 ? void 0 : mutationActionStateData.status) === "loading" /* Loading */
  });
  return /* @__PURE__ */React29.createElement(TripsPrimaryButton, _object_spread({
    data: data
  }, actions));
};
PrimaryButton.displayName = "PrimaryButton";
PrimaryButton.fragment = _object_spread_props(_object_spread({}, __Fragment9), {
  __typename: "TripsPrimaryButton"
});
// src/components/__private/__fragments/action-elements/secondary-button.tsx
import React34 from "react";
import { gql as gql54 } from "@apollo/client";
// src/components/__private/__fragments/actions/trips-open-dialog-fragment.ts
import { gql as gql53 } from "@apollo/client";
// src/components/__private/__fragments/dialogs/modal-dialog.tsx
import React33 from "react";
import { gql as gql52 } from "@apollo/client";
import { useDialog as useDialog9 } from "@shared-ui/dialog-context";
import { UitkSheetTransition as UitkSheetTransition2 } from "uitk-react-sheet";
// src/components/__private/__fragments/dialogs/actions/dialog-action-element.tsx
import React30 from "react";
import { gql as gql50, useReactiveVar as useReactiveVar3 } from "@apollo/client";
import { UitkPrimaryButton as UitkPrimaryButton2, UitkSecondaryButton as UitkSecondaryButton2, UitkTertiaryButton as UitkTertiaryButton2 } from "uitk-react-button";
import { UitkIcon as UitkIcon5, UitkIconSize as UitkIconSize4 } from "uitk-react-icons";
var __Fragment10 = gql50(_templateObject50(), __TripsSaveItemToTripActionFragment, __TripsDialogDismissActionFragment);
var DialogActionElement = function (props) {
  var data = props.data;
  var mutationActionState = useMutationActionState();
  var mutationActionStateData = useReactiveVar3(mutationActionState);
  var actionProps = useActionMap(data === null || data === void 0 ? void 0 : data.action);
  if (!(data === null || data === void 0 ? void 0 : data.primary)) {
    return null;
  }
  var primary = data.primary,
    icon = data.icon,
    width = data.width,
    __typename = data.__typename,
    disabled = data.disabled;
  var isFullWidth = width === "MATCH_PARENT_CONTAINER" /* MATCH_PARENT_CONTAINER */;
  var actions = _object_spread_props(_object_spread({}, actionProps), {
    disabled: disabled || actionProps.disabled || (mutationActionStateData === null || mutationActionStateData === void 0 ? void 0 : mutationActionStateData.status) === "loading" /* Loading */
  });
  switch (__typename) {
    case "TripsPrimaryButton":
      return /* @__PURE__ */React30.createElement(UitkPrimaryButton2, _object_spread({
        isFullWidth: isFullWidth
      }, actions), icon && /* @__PURE__ */React30.createElement(UitkIcon5, {
        name: icon.id,
        size: UitkIconSize4.MEDIUM
      }), primary);
    case "TripsSecondaryButton":
      return /* @__PURE__ */React30.createElement(UitkSecondaryButton2, _object_spread({
        isFullWidth: isFullWidth
      }, actions), icon && /* @__PURE__ */React30.createElement(UitkIcon5, {
        name: icon.id,
        size: UitkIconSize4.MEDIUM
      }), primary);
    case "TripsTertiaryButton":
      return /* @__PURE__ */React30.createElement(UitkTertiaryButton2, _object_spread({
        isFullWidth: isFullWidth
      }, actions), icon && /* @__PURE__ */React30.createElement(UitkIcon5, {
        name: icon.id,
        size: UitkIconSize4.MEDIUM
      }), primary);
    default:
      return null;
  }
};
DialogActionElement.displayName = "DialogActionElement";
DialogActionElement.fragment = __Fragment10;
// src/components/__private/__fragments/dialogs/content/embedded-content-list.tsx
import React31 from "react";
import { gql as gql51 } from "@apollo/client";
import { UitkText as UitkText3 } from "uitk-react-text";
var __Fragment11 = gql51(_templateObject51());
var EmbeddedContentList = function (param) {
  var data = param.data;
  var _data_secondaries;
  return /* @__PURE__ */React31.createElement(React31.Fragment, null, (_data_secondaries = data.secondaries) === null || _data_secondaries === void 0 ? void 0 : _data_secondaries.map(function (secondary, index) {
    return /* @__PURE__ */React31.createElement(UitkText3, {
      key: "".concat(index)
    }, secondary);
  }));
};
EmbeddedContentList.displayName = "EmbeddedContentList";
EmbeddedContentList.fragment = __Fragment11;
// src/components/__private/__fragments/dialogs/inline-action-dialog.tsx
import React32 from "react";
import { UitkDialog, UitkDialogContent } from "uitk-react-dialog";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
var InlineActionDialog = function (param) {
  var data = param.data;
  var heading = data.heading,
    buttons = data.buttons,
    content = data.content;
  return /* @__PURE__ */React32.createElement(UitkDialog, {
    dialogShow: true,
    returnFocusOnClose: true
  }, /* @__PURE__ */React32.createElement(UitkDialogContent, {
    key: "trips-dialog-inline-content"
  }, heading && /* @__PURE__ */React32.createElement(UitkHeading2, {
    tag: "h1",
    size: 5
  }, heading), content === null || content === void 0 ? void 0 : content.map(function (item, index) {
    return /* @__PURE__ */React32.createElement(EmbeddedContentList, {
      data: item,
      key: index
    });
  }), /* @__PURE__ */React32.createElement(UitkSpacing3, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React32.createElement(UitkLayoutFlex2, {
    space: "three"
  }, buttons === null || buttons === void 0 ? void 0 : buttons.map(function (button, index) {
    return /* @__PURE__ */React32.createElement(UitkLayoutFlexItem2, {
      grow: 1,
      key: "trips-dialog-inline-action-element-".concat(index)
    }, /* @__PURE__ */React32.createElement(UitkSpacing3, null, /* @__PURE__ */React32.createElement(DialogActionElement, {
      data: button
    })));
  })))));
};
// src/components/__private/__fragments/dialogs/modal-dialog.tsx
var __Fragment12 = gql52(_templateObject52(), DialogActionElement.fragment, EmbeddedContentList.fragment);
var ModalDialog = function (param) {
  var data = param.data;
  var _data_content;
  var dialogName3 = useTripsDialogName();
  var _useDialog9 = _sliced_to_array(useDialog9(dialogName3), 3),
    isDialogOpen = _useDialog9[0],
    DialogComponent = _useDialog9[2];
  if (!(data.heading || ((_data_content = data.content) === null || _data_content === void 0 ? void 0 : _data_content.length))) {
    return null;
  }
  return /* @__PURE__ */React33.createElement(UitkSheetTransition2, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React33.createElement(DialogComponent, null, /* @__PURE__ */React33.createElement(InlineActionDialog, {
    data: data
  })));
};
ModalDialog.displayName = "ModalDialog";
ModalDialog.fragment = __Fragment12;
// src/components/__private/__fragments/actions/trips-open-dialog-fragment.ts
var __TripsOpenDialogActionFragment = gql53(_templateObject53(), ModalDialog.fragment);
// src/components/__private/__fragments/action-elements/secondary-button.tsx
var __Fragment13 = gql54(_templateObject54(), TripsSecondaryButton.fragment, TripsLinkActionFragment, TripsDismissDrawerActionFragment, __TripsOpenCreateNewTripDrawerForItemActionFragment, __TripsCreateTripFromItemActionFragment, __TripsOpenSaveToTripDrawerActionFragment, __TripsOpenDialogActionFragment);
var SecondaryButton = function (param) {
  var data = param.data,
    isFullWidth = param.isFullWidth;
  var actionProps = useActionMap(data.action);
  return /* @__PURE__ */React34.createElement(TripsSecondaryButton, {
    actionProps: actionProps,
    data: data,
    isFullWidth: isFullWidth
  });
};
SecondaryButton.displayName = "SecondaryButton";
SecondaryButton.fragment = _object_spread_props(_object_spread({}, __Fragment13), {
  __typename: "TripsSecondaryButton"
});
SecondaryButton.getKey = function (secondaryButton) {
  return secondaryButton.primary;
};
// src/components/__private/__fragments/action-elements/tertiary-button.tsx
import React35 from "react";
import { gql as gql55 } from "@apollo/client";
var __Fragment14 = gql55(_templateObject55(), TripsTertiaryButton.fragment, TripsLinkActionFragment, __TripsOpenCreateNewTripDrawerForItemActionFragment, __TripsCreateTripFromItemActionFragment);
var TertiaryButton = function (props) {
  var data = props.data;
  var actionProps = useActionMap(data.action);
  return /* @__PURE__ */React35.createElement(TripsTertiaryButton, _object_spread({
    data: data
  }, actionProps));
};
TertiaryButton.displayName = "TertiaryButton";
TertiaryButton.fragment = _object_spread_props(_object_spread({}, __Fragment14), {
  __typename: "TripsTertiaryButton"
});
// src/components/__private/__fragments/cards/illustration-card.tsx
import React36 from "react";
import { gql as gql56 } from "@apollo/client";
import { UitkCard } from "uitk-react-cards";
import { UitkIllustrations as UitkIllustrations2 } from "uitk-react-illustrations";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3, UitkText as UitkText4 } from "uitk-react-text";
var __Fragment15 = gql56(_templateObject56());
var IllustrationCard = function (props) {
  var data = props.data;
  if (!data) {
    return null;
  }
  var primary = data.primary,
    secondaries = data.secondaries,
    illustration = data.illustration;
  var illustrationCard = /* @__PURE__ */React36.createElement(UitkSpacing4, {
    margin: {
      small: {
        blockend: "six"
      },
      medium: {
        block: "twelve"
      }
    }
  }, /* @__PURE__ */React36.createElement(UitkCard, null, /* @__PURE__ */React36.createElement(UitkLayoutFlex3, {
    justifyContent: "center",
    direction: "column",
    alignItems: "center"
  }, /* @__PURE__ */React36.createElement(React36.Fragment, null, /* @__PURE__ */React36.createElement(UitkLayoutFlexItem3, {
    maxWidth: "24x"
  }, (illustration === null || illustration === void 0 ? void 0 : illustration.url) && /* @__PURE__ */React36.createElement(UitkIllustrations2, {
    alt: illustration.description,
    url: illustration.url
  })), (primary || (secondaries === null || secondaries === void 0 ? void 0 : secondaries.length) > 0) && /* @__PURE__ */React36.createElement(UitkSpacing4, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React36.createElement("div", null, primary && /* @__PURE__ */React36.createElement(UitkHeading3, {
    tag: "h3",
    size: 5,
    align: "center"
  }, primary), Array.isArray(secondaries) && secondaries.map(function (subheading, subheadingIndex) {
    return /* @__PURE__ */React36.createElement(UitkText4, {
      size: 300,
      key: "trip-illustration-subheading-".concat(subheadingIndex)
    }, subheading);
  })))))));
  return illustrationCard;
};
IllustrationCard.displayName = "TripsIllustrationCardFragment";
IllustrationCard.fragment = _object_spread_props(_object_spread({}, __Fragment15), {
  __typename: "TripsIllustrationCard"
});
// src/components/__private/__fragments/cards/image-slim-card.tsx
import React45 from "react";
import { gql as gql64 } from "@apollo/client";
// ../internal/src/components/cards/image-slim-card.tsx
import React42 from "react";
import { gql as gql61 } from "@apollo/client";
import { UitkBadgeSize as UitkBadgeSize2 } from "uitk-react-badge";
import { UitkCard as UitkCard2, UitkCardContentSection } from "uitk-react-cards";
import { UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading4, UitkText as UitkText6 } from "uitk-react-text";
// ../internal/src/components/egds-badge/egds-badge.tsx
import React40 from "react";
import { gql as gql60 } from "@apollo/client";
// ../internal/src/components/egds-badge/egds-loyalty-badge.tsx
import React37 from "react";
import { gql as gql57 } from "@apollo/client";
import { UitkBadgeLoyalty } from "uitk-react-badge";
// ../internal/src/components/egds-badge/util/egds-badge-size-map.ts
import { UitkBadgeSize } from "uitk-react-badge";
var _obj1;
var egdsBadgeSizeMap = (_obj1 = {}, _define_property(_obj1, UitkBadgeSize.SMALL, "small"), _define_property(_obj1, UitkBadgeSize.LARGE, "large"), _obj1);
// ../internal/src/components/egds-badge/util/egds-badge-themes-map.ts
var egdsBadgeThemesMap = {
  lowtier: "lowtier",
  midtier: "midtier",
  hightier: "hightier",
  vip: "vip",
  extrahightier: "extrahightier"
};
var programBadgeThemesMap = {
  deal: "deal",
  member: "member",
  trip: "trip",
  supplierpromo: "supplierpromo",
  vmc: "vmc"
};
var standardBadgeThemesMap = {
  standard: "standard",
  emphasis: "emphasis",
  info: "info",
  featured: "featured",
  brand: "brand",
  warning: "warning",
  positive: "positive"
};
// ../internal/src/components/egds-badge/egds-loyalty-badge.tsx
var __EGDSLoyaltyBadgeFragment = gql57(_templateObject57());
var EGDSLoyaltyBadge = function (param) {
  var className = param.className,
    badgeSize = param.badgeSize,
    data = param.data;
  var text = data.text,
    theme = data.theme,
    accessibility = data.accessibility,
    size = data.size;
  var egdsBadgeSize = size ? egdsBadgeSizeMap[size] : void 0;
  if (!text) {
    return null;
  }
  return /* @__PURE__ */React37.createElement(UitkBadgeLoyalty, {
    className: className,
    a11yText: accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
    text: text,
    size: badgeSize !== null && badgeSize !== void 0 ? badgeSize : egdsBadgeSize,
    theme: theme ? egdsBadgeThemesMap[theme] : void 0
  });
};
EGDSLoyaltyBadge.fragment = __EGDSLoyaltyBadgeFragment;
EGDSLoyaltyBadge.displayName = "EGDSLoyaltyBadge";
// ../internal/src/components/egds-badge/egds-program-badge.tsx
import React38 from "react";
import { gql as gql58 } from "@apollo/client";
import { UitkBadgeProgram } from "uitk-react-badge";
var __EGDSProgramBadgeFragment = gql58(_templateObject58());
var EGDSProgramBadge = function (param) {
  var className = param.className,
    data = param.data;
  var text = data.text,
    theme = data.theme,
    accessibility = data.accessibility;
  if (!text || !theme) {
    return null;
  }
  var _programBadgeThemesMap_theme;
  return /* @__PURE__ */React38.createElement(UitkBadgeProgram, {
    className: className,
    a11yText: accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
    text: text,
    theme: (_programBadgeThemesMap_theme = programBadgeThemesMap[theme]) !== null && _programBadgeThemesMap_theme !== void 0 ? _programBadgeThemesMap_theme : "deal"
  });
};
EGDSProgramBadge.fragment = __EGDSProgramBadgeFragment;
EGDSProgramBadge.displayName = "EGDSProgramBadge";
// ../internal/src/components/egds-badge/egds-standard-badge.tsx
import React39 from "react";
import { gql as gql59 } from "@apollo/client";
import { UitkIconSize as UitkIconSize5 } from "@egds/react-core/icons";
import { UitkMarkSize as UitkMarkSize2 } from "@egds/react-core/mark";
import { UitkBadgeStandard } from "uitk-react-badge";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkText as UitkText5 } from "uitk-react-text";
var __EGDSStandardBadgeFragment = gql59(_templateObject59(), UIGraphic.fragment);
var EGDSStandardBadge = function (param) {
  var className = param.className,
    badgeSize = param.badgeSize,
    data = param.data;
  var graphic = data.graphic,
    text = data.text,
    theme = data.theme,
    accessibility = data.accessibility,
    size = data.size;
  var egdsBadgeSize = size ? egdsBadgeSizeMap[size] : void 0;
  if (!text) {
    return null;
  }
  if (!theme && graphic) {
    return /* @__PURE__ */React39.createElement("div", {
      className: className
    }, /* @__PURE__ */React39.createElement(UIGraphic, {
      data: graphic,
      defaultIconSize: UitkIconSize5.EXTRA_SMALL,
      defaultMarkSize: UitkMarkSize2.EXTRA_SMALL
    }), /* @__PURE__ */React39.createElement(UitkSpacing5, {
      padding: {
        inlinestart: "one"
      }
    }, /* @__PURE__ */React39.createElement(UitkText5, {
      size: 200,
      inline: true
    }, data.text)));
  }
  return /* @__PURE__ */React39.createElement(UitkBadgeStandard, {
    className: className,
    a11yText: accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
    text: text,
    size: badgeSize !== null && badgeSize !== void 0 ? badgeSize : egdsBadgeSize,
    theme: theme ? standardBadgeThemesMap[theme] : void 0
  });
};
EGDSStandardBadge.fragment = __EGDSStandardBadgeFragment;
EGDSStandardBadge.displayName = "EGDSStandardBadge";
// ../internal/src/components/egds-badge/egds-badge.tsx
var __EGDSBadgeFragment = gql60(_templateObject60(), EGDSStandardBadge.fragment, EGDSLoyaltyBadge.fragment, EGDSProgramBadge.fragment);
var EGDSBadge = function (param) {
  var className = param.className,
    size = param.size,
    data = param.data;
  switch (data.__typename) {
    case "EGDSStandardBadge":
      return /* @__PURE__ */React40.createElement(EGDSStandardBadge, {
        className: className,
        badgeSize: size,
        data: data
      });
    case "EGDSLoyaltyBadge":
      return /* @__PURE__ */React40.createElement(EGDSLoyaltyBadge, {
        className: className,
        badgeSize: size,
        data: data
      });
    case "EGDSProgramBadge":
      return /* @__PURE__ */React40.createElement(EGDSProgramBadge, {
        className: className,
        data: data
      });
    default:
      return null;
  }
};
EGDSBadge.fragment = __EGDSBadgeFragment;
EGDSBadge.displayName = "EGDSBadge";
// ../internal/src/components/helper/trips-image.tsx
import React41 from "react";
import { UitkImage } from "uitk-react-images";
var TripsImage = function (param) {
  var src = param.src,
    alt = param.alt,
    _param_placeholderImage = param.placeholderImage,
    placeholderImage = _param_placeholderImage === void 0 ? true : _param_placeholderImage;
  return /* @__PURE__ */React41.createElement(React41.Fragment, null, src ? /* @__PURE__ */React41.createElement(UitkImage, {
    src: src,
    alt: alt,
    placeholderImage: placeholderImage
  }) : /* @__PURE__ */React41.createElement("div", {
    "data-stid": "placeholder-image",
    className: "uitk-image-placeholder uitk-image-placeholder-image"
  }));
};
// ../internal/src/components/cards/image-slim-card.tsx
var __Fragment16 = gql61(_templateObject61(), ClientSideImpressionAnalyticsIntersectionTracker.fragment, EGDSBadge.fragment);
var TripsImageSlimCardContentSection = function (props) {
  var data = props.data,
    cardRightSideLinkSection = props.cardRightSideLinkSection,
    cardIconSection = props.cardIconSection;
  var primary = data.primary,
    secondaries = data.secondaries,
    badgeList = data.badgeList;
  return /* @__PURE__ */React42.createElement(UitkSpacing6, {
    padding: "three"
  }, /* @__PURE__ */React42.createElement(UitkLayoutFlex4, {
    direction: "column",
    space: "one"
  }, badgeList && badgeList.length > 0 && /* @__PURE__ */React42.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */React42.createElement(UitkLayoutFlex4, {
    wrap: "wrap"
  }, badgeList.map(function (badge, badgeIndex) {
    return /* @__PURE__ */React42.createElement(UitkLayoutFlexItem4, {
      key: "trip-image-slim-card-".concat(primary, "-").concat(badgeIndex)
    }, /* @__PURE__ */React42.createElement(UitkSpacing6, {
      margin: {
        blockend: "half",
        inlineend: "one"
      }
    }, /* @__PURE__ */React42.createElement(EGDSBadge, {
      size: UitkBadgeSize2.SMALL,
      data: badge
    })));
  }))), primary && /* @__PURE__ */React42.createElement(UitkLayoutGrid, {
    rows: 1,
    columns: 2
  }, /* @__PURE__ */React42.createElement(UitkLayoutGrid, null, /* @__PURE__ */React42.createElement(UitkHeading4, {
    size: 6,
    overflow: "truncate-2-lines"
  }, primary)), /* @__PURE__ */React42.createElement(UitkLayoutGrid, null, /* @__PURE__ */React42.createElement(UitkLayoutPosition, {
    type: "absolute",
    cloneElement: true,
    position: {
      top: "zero",
      right: "zero"
    }
  }, /* @__PURE__ */React42.createElement("div", null, cardIconSection, cardRightSideLinkSection)))), secondaries === null || secondaries === void 0 ? void 0 : secondaries.map(function (subheading, subheadingIndex) {
    return /* @__PURE__ */React42.createElement(UitkLayoutFlexItem4, {
      key: "trip-image-slim-card-".concat(subheadingIndex)
    }, /* @__PURE__ */React42.createElement(UitkText6, {
      size: 300,
      overflow: "truncate-2-lines"
    }, subheading));
  })));
};
var TripsImageSlimCard = function (props) {
  var data = props.data,
    middleSection = props.middleSection,
    cardLeftSideLinkSection = props.cardLeftSideLinkSection,
    cardMiddleLinkSection = props.cardMiddleLinkSection,
    cardRightSideLinkSection = props.cardRightSideLinkSection,
    cardIconSection = props.cardIconSection;
  var impressionTracking = data.impressionTracking,
    thumbnail = data.thumbnail;
  var _thumbnail_url, _thumbnail_description;
  var imageSlimCard = /* @__PURE__ */React42.createElement(UitkSpacing6, {
    margin: {
      block: "three"
    }
  }, /* @__PURE__ */React42.createElement(UitkCard2, {
    border: true,
    overflow: true
  }, /* @__PURE__ */React42.createElement(UitkLayoutFlex4, null, thumbnail && /* @__PURE__ */React42.createElement(UitkLayoutFlexItem4, {
    minWidth: "16x",
    shrink: 0
  }, /* @__PURE__ */React42.createElement(UitkCardContentSection, {
    padded: ["blockstart", "blockend", "inlinestart"]
  }, /* @__PURE__ */React42.createElement(UitkFigure, {
    ratio: UitkFigureAspectRatioType.R1_1,
    roundcorner: true
  }, /* @__PURE__ */React42.createElement(TripsImage, {
    src: (_thumbnail_url = thumbnail.url) !== null && _thumbnail_url !== void 0 ? _thumbnail_url : void 0,
    alt: (_thumbnail_description = thumbnail.description) !== null && _thumbnail_description !== void 0 ? _thumbnail_description : void 0
  })), cardLeftSideLinkSection)), /* @__PURE__ */React42.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */React42.createElement("div", null, cardMiddleLinkSection)), /* @__PURE__ */React42.createElement(UitkLayoutFlexItem4, {
    grow: 1
  }, /* @__PURE__ */React42.createElement(UitkCardContentSection, {
    padded: false
  }, middleSection !== null && middleSection !== void 0 ? middleSection : /* @__PURE__ */React42.createElement(TripsImageSlimCardContentSection, {
    data: data,
    cardIconSection: cardIconSection,
    cardRightSideLinkSection: cardRightSideLinkSection
  }))))));
  return impressionTracking ? /* @__PURE__ */React42.createElement(ClientSideImpressionAnalyticsIntersectionTracker, {
    data: impressionTracking
  }, imageSlimCard) : imageSlimCard;
};
TripsImageSlimCard.displayName = "ImageSlimCard";
TripsImageSlimCard.fragment = _object_spread_props(_object_spread({}, __Fragment16), {
  __typename: "TripsImageSlimCard"
});
// ../internal/src/components/cards/slim-card.tsx
import React43 from "react";
import { gql as gql62 } from "@apollo/client";
import { UitkCard as UitkCard3, UitkCardContentSection as UitkCardContentSection2, UitkCardLink } from "uitk-react-cards";
import { UitkIcon as UitkIcon6, UitkIconSize as UitkIconSize6 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkMarkSize as UitkMarkSize3 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading5, UitkText as UitkText7 } from "uitk-react-text";
var __Fragment17 = gql62(_templateObject62(), Icon.fragment, Mark.fragment, Illustration.fragment, ClientSideImpressionAnalyticsIntersectionTracker.fragment);
var TripsSlimCard = function (props) {
  var data = props.data,
    actionProps = props.actionProps,
    isActionAvailable = props.isActionAvailable;
  var graphic = data.graphic,
    primary = data.primary,
    secondaries = data.secondaries,
    accessibility = data.accessibility,
    impressionTracking = data.impressionTracking;
  var slimCard = /* @__PURE__ */React43.createElement(UitkSpacing7, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React43.createElement(UitkCard3, {
    border: true,
    overflow: true
  }, /* @__PURE__ */React43.createElement(UitkCardContentSection2, null, /* @__PURE__ */React43.createElement(UitkSpacing7, {
    margin: primary && !secondaries ? {
      block: "two"
    } : "unset"
  }, /* @__PURE__ */React43.createElement(UitkLayoutFlex5, {
    space: "two",
    alignItems: "center"
  }, /* @__PURE__ */React43.createElement(React43.Fragment, null, graphic && /* @__PURE__ */React43.createElement(UitkSpacing7, {
    padding: {
      inline: "three"
    }
  }, /* @__PURE__ */React43.createElement("div", null, /* @__PURE__ */React43.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */React43.createElement(UIGraphic, {
    data: graphic,
    defaultIconSize: UitkIconSize6.MEDIUM,
    defaultMarkSize: UitkMarkSize3.MEDIUM
  })))), /* @__PURE__ */React43.createElement(UitkLayoutFlexItem5, {
    grow: 1
  }, /* @__PURE__ */React43.createElement("div", null, primary && /* @__PURE__ */React43.createElement(UitkHeading5, {
    tag: "h3",
    size: 6
  }, primary), Array.isArray(secondaries) && secondaries.map(function (subheading, subheadingIndex) {
    return /* @__PURE__ */React43.createElement(UitkText7, {
      size: 300,
      spacing: "one",
      key: "trip-subheading-".concat(subheadingIndex)
    }, subheading);
  }))), isActionAvailable && /* @__PURE__ */React43.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */React43.createElement(UitkIcon6, {
    name: "chevron_right",
    "data-testid": "chevron_right"
  })))))), (actionProps.href || actionProps.onClick) && /* @__PURE__ */React43.createElement(UitkCardLink, null, actionProps.href ? /* @__PURE__ */React43.createElement("a", _object_spread({}, actionProps), accessibility === null || accessibility === void 0 ? void 0 : accessibility.label) : /* @__PURE__ */React43.createElement("button", _object_spread({
    type: "button"
  }, actionProps), accessibility === null || accessibility === void 0 ? void 0 : accessibility.label))));
  return impressionTracking ? /* @__PURE__ */React43.createElement(ClientSideImpressionAnalyticsIntersectionTracker, {
    data: impressionTracking
  }, slimCard) : slimCard;
};
TripsSlimCard.displayName = "SlimCard";
TripsSlimCard.fragment = _object_spread_props(_object_spread({}, __Fragment17), {
  __typename: "TripsSlimCard"
});
// src/components/__private/__fragments/cards/image-slim-card.tsx
import { UitkCardLink as UitkCardLink2 } from "uitk-react-cards";
// src/components/__private/__fragments/cards/card-icon.tsx
import React44 from "react";
import { gql as gql63 } from "@apollo/client";
import { UitkCardContentSection as UitkCardContentSection3 } from "uitk-react-cards";
import { UitkIcon as UitkIcon7 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex6 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkText as UitkText8 } from "uitk-react-text";
var __Fragment18 = gql63(_templateObject63(), __TripsSaveItemToTripActionFragment, __TripsUnsaveItemFromTripActionFragment, TripsLinkActionFragment);
var labelMargin = {
  inlinestart: "one"
};
var iconPadding = {
  blockstart: "three",
  inlineend: "three"
};
var CardIcon = function (param) {
  var data = param.data;
  var label = data.label,
    icon = data.icon;
  var _icon_title, _icon_theme;
  return /* @__PURE__ */React44.createElement(UitkSpacing8, {
    padding: iconPadding
  }, /* @__PURE__ */React44.createElement(UitkCardContentSection3, null, /* @__PURE__ */React44.createElement(UitkLayoutFlex6, {
    alignItems: "center",
    wrap: "wrap",
    justifyContent: "space-around"
  }, icon && /* @__PURE__ */React44.createElement(UitkIcon7, {
    name: icon.id,
    id: icon.id,
    description: icon.description,
    title: (_icon_title = icon.title) !== null && _icon_title !== void 0 ? _icon_title : void 0,
    "data-testid": icon.id,
    theme: (_icon_theme = icon.theme) !== null && _icon_theme !== void 0 ? _icon_theme : "default" /* default */
  }), label && /* @__PURE__ */React44.createElement(UitkSpacing8, {
    margin: labelMargin
  }, /* @__PURE__ */React44.createElement(UitkText8, {
    size: 400,
    overflow: "wrap"
  }, label)))));
};
CardIcon.displayName = "CardIcon";
CardIcon.fragment = _object_spread_props(_object_spread({}, __Fragment18), {
  __typename: "TripsIcon"
});
// src/components/__private/__fragments/cards/image-slim-card.tsx
var __Fragment19 = gql64(_templateObject64(), TripsImageSlimCard.fragment, __TripsSaveItemToTripActionFragment, __TripsUnsaveItemFromTripActionFragment, TripsLinkActionFragment, CardIcon.fragment);
var ImageSlimCard = function (param) {
  var data = param.data;
  var _data_cardIcon;
  var primaryActionProps = useActionMap(data.primaryAction);
  var secondaryActionProps = useActionMap(data.secondaryAction);
  var _data_cardIcon_action;
  var cardIconActionProps = useActionMap((_data_cardIcon_action = (_data_cardIcon = data.cardIcon) === null || _data_cardIcon === void 0 ? void 0 : _data_cardIcon.action) !== null && _data_cardIcon_action !== void 0 ? _data_cardIcon_action : null);
  var accessibility = data.accessibility,
    cardIcon = data.cardIcon;
  var _ref = cardIcon !== null && cardIcon !== void 0 ? cardIcon : {},
    cardIconLabel = _ref.label;
  var cardLeftSideLinkSection = React45.useMemo(function () {
    return secondaryActionProps ? /* @__PURE__ */React45.createElement(UitkCardLink2, null, secondaryActionProps.href ? /* @__PURE__ */React45.createElement("a", _object_spread({}, secondaryActionProps), accessibility === null || accessibility === void 0 ? void 0 : accessibility.label) : /* @__PURE__ */React45.createElement("button", _object_spread({
      type: "button"
    }, secondaryActionProps), accessibility === null || accessibility === void 0 ? void 0 : accessibility.label)) : null;
  }, [accessibility, secondaryActionProps]);
  var cardMiddleLinkSection = React45.useMemo(function () {
    return primaryActionProps ? /* @__PURE__ */React45.createElement(UitkCardLink2, null, primaryActionProps.href ? /* @__PURE__ */React45.createElement("a", _object_spread({}, primaryActionProps), accessibility === null || accessibility === void 0 ? void 0 : accessibility.label) : /* @__PURE__ */React45.createElement("button", _object_spread({
      type: "button"
    }, primaryActionProps), accessibility === null || accessibility === void 0 ? void 0 : accessibility.label)) : null;
  }, [accessibility, primaryActionProps]);
  var cardRightSideLinkSection = React45.useMemo(function () {
    return cardIconActionProps ? /* @__PURE__ */React45.createElement(UitkCardLink2, null, /* @__PURE__ */React45.createElement("button", _object_spread({
      type: "button"
    }, cardIconActionProps), cardIconLabel)) : null;
  }, [cardIconLabel, cardIconActionProps]);
  var cardIconSection = React45.useMemo(function () {
    return cardIcon && /* @__PURE__ */React45.createElement(CardIcon, {
      data: cardIcon
    });
  }, [cardIcon]);
  return /* @__PURE__ */React45.createElement(TripsImageSlimCard, {
    data: data,
    cardLeftSideLinkSection: cardLeftSideLinkSection,
    cardMiddleLinkSection: cardMiddleLinkSection,
    cardRightSideLinkSection: cardRightSideLinkSection,
    cardIconSection: cardIconSection
  });
};
ImageSlimCard.displayName = "ImageSlimCard";
ImageSlimCard.fragment = _object_spread_props(_object_spread({}, __Fragment19), {
  __typename: "TripsImageSlimCard"
});
ImageSlimCard.getKey = function (element) {
  return element.primary;
};
// src/components/__private/__fragments/cards/item-recall-card.tsx
import React46 from "react";
import { gql as gql65 } from "@apollo/client";
import { UitkCard as UitkCard4, UitkCardContentSection as UitkCardContentSection4 } from "uitk-react-cards";
import { UitkFigure as UitkFigure2, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage as UitkImage2 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex7, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading6, UitkText as UitkText9 } from "uitk-react-text";
var __Fragment20 = gql65(_templateObject65());
var ItemRecallCard = function (param) {
  var data = param.data;
  var primary = data.primary,
    secondaries = data.secondaries,
    image = data.image;
  return /* @__PURE__ */React46.createElement(UitkSpacing9, {
    padding: {
      blockend: "six"
    }
  }, /* @__PURE__ */React46.createElement(UitkCard4, null, /* @__PURE__ */React46.createElement(UitkLayoutFlex7, null, /* @__PURE__ */React46.createElement(UitkLayoutFlexItem6, {
    minWidth: 150,
    shrink: 0
  }, /* @__PURE__ */React46.createElement(UitkFigure2, {
    ratio: UitkFigureAspectRatioType2.R3_2,
    roundcorner: true,
    imageFit: "cover"
  }, /* @__PURE__ */React46.createElement(UitkImage2, {
    src: image === null || image === void 0 ? void 0 : image.url,
    alt: image === null || image === void 0 ? void 0 : image.description,
    placeholderImage: true
  }))), /* @__PURE__ */React46.createElement(UitkCardContentSection4, {
    padded: ["inlinestart"]
  }, /* @__PURE__ */React46.createElement("div", null, /* @__PURE__ */React46.createElement(UitkHeading6, {
    overflow: "truncate-3-lines",
    tag: "h3",
    size: 5,
    align: "left"
  }, primary), secondaries === null || secondaries === void 0 ? void 0 : secondaries.map(function (subheading, subheadingIndex) {
    return /* @__PURE__ */React46.createElement(UitkLayoutFlexItem6, {
      key: "trip-item-recall-card-".concat(subheadingIndex)
    }, /* @__PURE__ */React46.createElement(UitkCardContentSection4, {
      padded: ["blockstart"]
    }, /* @__PURE__ */React46.createElement(UitkText9, {
      size: 300
    }, subheading)));
  }))))));
};
ItemRecallCard.displayName = "ItemRecallCard";
ItemRecallCard.fragment = _object_spread_props(_object_spread({}, __Fragment20), {
  __typename: "TripsItemRecallCard"
});
// src/components/__private/__fragments/cards/slim-card.tsx
import React47 from "react";
import { gql as gql66 } from "@apollo/client";
var __Fragment21 = gql66(_templateObject66(), TripsSlimCard.fragment, __TripsNavigateToViewActionFragment);
var SlimCard = function (param) {
  var data = param.data;
  var actionProps = useActionMap(data === null || data === void 0 ? void 0 : data.action);
  var action = data.action;
  return /* @__PURE__ */React47.createElement(TripsSlimCard, {
    data: data,
    actionProps: actionProps,
    isActionAvailable: Boolean(action === null || action === void 0 ? void 0 : action.__typename)
  });
};
SlimCard.displayName = "SlimCard";
SlimCard.fragment = _object_spread_props(_object_spread({}, __Fragment21), {
  __typename: "TripsSlimCard"
});
SlimCard.getKey = function (element) {
  return element.primary;
};
// src/components/__private/__fragments/container/form-container.tsx
import React50 from "react";
import { gql as gql76 } from "@apollo/client";
// ../internal/src/components/form/trips-form.tsx
import React48 from "react";
import { UitkForm } from "uitk-react-form";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
var TripsForm = function (param) {
  var elements = param.elements;
  if (!elements || !elements.length) {
    return null;
  }
  return /* @__PURE__ */React48.createElement(UitkForm, {
    hasRequiredFieldIndicator: true,
    name: "trips-form"
  }, elements.map(function (element, index) {
    return /* @__PURE__ */React48.createElement(UitkSpacing10, {
      key: "trips-form-item-".concat(index),
      margin: {
        blockend: "three"
      }
    }, /* @__PURE__ */React48.createElement("div", null, element));
  }));
};
// ../internal/src/components/input/trips-validated-input.tsx
import React49 from "react";
import { gql as gql75 } from "@apollo/client";
import { useProvidedState as useProvidedState6 } from "@shared-ui/provided-state-context";
import { UitkTextArea, UitkTextInput } from "uitk-react-input";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
// ../internal/src/components/input/validations/max-length-input-validation.ts
import { gql as gql67 } from "@apollo/client";
var __EGDSMaxLengthInputValidationFragment = gql67(_templateObject67());
// ../internal/src/components/input/validations/min-length-input-validation.ts
import { gql as gql68 } from "@apollo/client";
var __EGDSMinLengthInputValidationFragment = gql68(_templateObject68());
// ../internal/src/components/input/validations/regex-input-validation.ts
import { gql as gql69 } from "@apollo/client";
var __EGDSRegexInputValidationFragment = gql69(_templateObject69());
// ../internal/src/components/input/validations/required-input-validation.ts
import { gql as gql70 } from "@apollo/client";
var __EGDSRequiredInputValidationFragment = gql70(_templateObject70());
// ../internal/src/components/input/validations/travelers-input-validation.ts
import { gql as gql71 } from "@apollo/client";
var __EGDSTravelersInputValidationFragment = gql71(_templateObject71());
// ../internal/src/components/input/validations/multi-email-validation.ts
import { gql as gql72 } from "@apollo/client";
var __MultiEmailValidationFragment = gql72(_templateObject72());
// ../internal/src/components/input/validations/single-email-validation.ts
import { gql as gql73 } from "@apollo/client";
var __SingleEmailValidationFragment = gql73(_templateObject73());
// ../internal/src/components/input/validations/duration-span-input-validation.ts
import { gql as gql74 } from "@apollo/client";
var __DurationSpanInputValidationFragment = gql74(_templateObject74());
// ../internal/src/components/input/trips-validated-input.tsx
var __Fragment22 = gql75(_templateObject75(), __EGDSMaxLengthInputValidationFragment, __EGDSMinLengthInputValidationFragment, __EGDSRegexInputValidationFragment, __EGDSRequiredInputValidationFragment, __EGDSTravelersInputValidationFragment, __MultiEmailValidationFragment, __SingleEmailValidationFragment);
function isMaxLengthValidation(validation) {
  return validation.__typename === "EGDSMaxLengthInputValidation";
}
var TripsValidatedInput = function (param) {
  var data = param.data;
  var _useProvidedState6 = _sliced_to_array(useProvidedState6(), 2),
    state = _useProvidedState6[0],
    dispatch = _useProvidedState6[1];
  React49.useEffect(function () {
    if (!data) {
      return;
    }
    var isInputExistedInState = state.validatedInputs.inputFields.some(function (inputField) {
      return inputField.inputId === data.egdsElementId;
    });
    if (isInputExistedInState) {
      return;
    }
    var _data_value;
    dispatch({
      type: "addInputField" /* AddInputField */,
      payload: {
        inputId: data.egdsElementId,
        inputValue: (_data_value = data.value) !== null && _data_value !== void 0 ? _data_value : "",
        validations: data.validations
      }
    });
  }, [data === null || data === void 0 ? void 0 : data.egdsElementId]);
  if (!(data === null || data === void 0 ? void 0 : data.egdsElementId)) {
    return null;
  }
  var egdsElementId = data.egdsElementId,
    label = data.label,
    placeholder = data.placeholder,
    instructions = data.instructions,
    required = data.required,
    leftIcon = data.leftIcon,
    validations = data.validations,
    inputType = data.inputType;
  var isMultiline = inputType === "MULTIPLE" /* MULTIPLE */;
  var maxLengthValidator = isMultiline ? validations === null || validations === void 0 ? void 0 : validations.find(isMaxLengthValidation) : void 0;
  var onChangeHandler = function (event) {
    dispatch({
      type: "updateInputValue" /* UpdateInputValue */,
      payload: {
        inputId: egdsElementId,
        inputValue: event.target.value
      }
    });
    if (maxLengthValidator) {
      var errorMessage = runValidation(event.target.value, validations);
      dispatch({
        type: "updateInputErrorMessage" /* UpdateInputErrorMessage */,
        payload: {
          inputId: egdsElementId,
          currentErrorMessage: errorMessage
        }
      });
    }
  };
  var onBlurHandler = function (event) {
    event.preventDefault();
    var currentInputValue = event.target.value;
    var errorMessage = runValidation(currentInputValue, validations);
    dispatch({
      type: "updateInputErrorMessage" /* UpdateInputErrorMessage */,
      payload: {
        inputId: egdsElementId,
        currentErrorMessage: errorMessage
      }
    });
  };
  var inputFieldInState = state.validatedInputs.inputFields.find(function (inputField) {
    return inputField.inputId === egdsElementId;
  });
  var invalid = inputFieldInState === null || inputFieldInState === void 0 ? void 0 : inputFieldInState.currentErrorMessage;
  var instruction = instructions ? {
    primary: instructions
  } : void 0;
  var _inputFieldInState_inputValue;
  var componentProps = {
    id: egdsElementId,
    icon: leftIcon === null || leftIcon === void 0 ? void 0 : leftIcon.leftIconId,
    name: egdsElementId,
    label: label !== null && label !== void 0 ? label : "",
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    value: (_inputFieldInState_inputValue = inputFieldInState === null || inputFieldInState === void 0 ? void 0 : inputFieldInState.inputValue) !== null && _inputFieldInState_inputValue !== void 0 ? _inputFieldInState_inputValue : "",
    required: required !== null && required !== void 0 ? required : false,
    invalid: invalid,
    instruction: instruction,
    onChange: onChangeHandler,
    onBlur: onBlurHandler
  };
  var InputComponent = isMultiline ? UitkTextArea : UitkTextInput;
  return /* @__PURE__ */React49.createElement(UitkSpacing11, {
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React49.createElement("div", null, /* @__PURE__ */React49.createElement(InputComponent, _object_spread({
    "data-stid": "trips-input-".concat(egdsElementId)
  }, componentProps))));
};
TripsValidatedInput.displayName = "TripsValidatedInput";
TripsValidatedInput.fragment = _object_spread_props(_object_spread({}, __Fragment22), {
  __typename: "TripsValidatedInput"
});
// src/components/__private/__fragments/container/form-container.tsx
var __Fragment23 = gql76(_templateObject76(), PrimaryButton.fragment, SecondaryButton.fragment, TripsValidatedInput.fragment);
var FormContainer = function (param) {
  var data = param.data;
  var elements = data.elements;
  var composableElements = tripsComposableElementList(elements, [PrimaryButton, SecondaryButton, TripsValidatedInput]);
  return /* @__PURE__ */React50.createElement(TripsForm, {
    elements: composableElements
  });
};
FormContainer.displayName = "FormContainer";
FormContainer.fragment = _object_spread_props(_object_spread({}, __Fragment23), {
  __typename: "TripsFormContainer"
});
// src/components/__private/__fragments/container/section-container.tsx
import React52 from "react";
import { gql as gql78 } from "@apollo/client";
// ../internal/src/components/containers/trips-section-container.tsx
import React51 from "react";
import { gql as gql77 } from "@apollo/client";
import { UitkSpacing as UitkSpacing12 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading7, UitkSubheading as UitkSubheading2, UitkText as UitkText10 } from "uitk-react-text";
var __Fragment24 = gql77(_templateObject77(), ClientSideImpressionAnalyticsTracker.fragment);
var TripsSectionContainer = function (param) {
  var data = param.data,
    children = param.children;
  var heading = data.heading,
    subheadings = data.subheadings,
    tripsListSubTexts = data.tripsListSubTexts,
    theme = data.theme;
  var topSpacing = theme === "IMPORTANT" /* IMPORTANT */ ? "six" : "twelve";
  var sectionContainer = /* @__PURE__ */React51.createElement(UitkSpacing12, {
    padding: {
      inline: "six"
    },
    margin: {
      blockstart: topSpacing
    }
  }, /* @__PURE__ */React51.createElement("section", null, heading && /* @__PURE__ */React51.createElement(UitkHeading7, {
    tag: "h2",
    size: 5
  }, heading), subheadings || tripsListSubTexts ? /* @__PURE__ */React51.createElement(UitkSpacing12, {
    margin: {
      block: "three"
    }
  }, /* @__PURE__ */React51.createElement("div", null, subheadings === null || subheadings === void 0 ? void 0 : subheadings.map(function (subheading) {
    return /* @__PURE__ */React51.createElement(UitkSubheading2, {
      key: subheading
    }, subheading);
  }), tripsListSubTexts === null || tripsListSubTexts === void 0 ? void 0 : tripsListSubTexts.map(function (tripsListSubText) {
    return /* @__PURE__ */React51.createElement(UitkText10, {
      key: tripsListSubText,
      size: 100
    }, tripsListSubText);
  }))) : null, children));
  return data.impressionAnalytics ? /* @__PURE__ */React51.createElement(ClientSideImpressionAnalyticsTracker, {
    data: data.impressionAnalytics
  }, sectionContainer) : sectionContainer;
};
TripsSectionContainer.displayName = "TripsSectionContainer";
TripsSectionContainer.fragment = __Fragment24;
TripsSectionContainer.getKey = function (element) {
  return element.heading;
};
// src/components/__private/__fragments/container/section-container.tsx
var __Fragment25 = gql78(_templateObject78(), TripsSectionContainer.fragment, PrimaryButton.fragment, SecondaryButton.fragment, TertiaryButton.fragment, ImageSlimCard.fragment, SlimCard.fragment);
var SectionContainer = function (param) {
  var data = param.data;
  var elements = data.elements;
  var composableElements = tripsComposableElementList(elements, [SlimCard, ImageSlimCard, PrimaryButton, SecondaryButton, TertiaryButton]);
  return /* @__PURE__ */React52.createElement(TripsSectionContainer, {
    data: data
  }, composableElements);
};
SectionContainer.displayName = "SectionContainer";
SectionContainer.fragment = _object_spread_props(_object_spread({}, __Fragment25), {
  __typename: "TripsSectionContainer"
});
// src/components/__private/__fragments/drawer/toolbar.tsx
import React53 from "react";
import { gql as gql79 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog10 } from "@shared-ui/dialog-context";
import { UitkLayoutFlex as UitkLayoutFlex8, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { UitkToolbar } from "uitk-react-toolbar";
var __Fragment26 = gql79(_templateObject79(), TertiaryButton.fragment);
var Toolbar = function (param) {
  var data = param.data,
    dialogName3 = param.dialogName;
  var actions = data.actions;
  var _actions_primary = actions.primary,
    accessibility = _actions_primary.accessibility,
    action = _actions_primary.action;
  var secondaries = actions.secondaries;
  var track = useClickTracker4();
  var _useDialog10 = _sliced_to_array(useDialog10(dialogName3), 2),
    dialogActions = _useDialog10[1];
  var closeToolbar = function () {
    if (action) {
      track(action.analytics.referrerId, action.analytics.linkName);
    }
    dialogActions.closeDialog();
  };
  var toolbarActionContent = secondaries && /* @__PURE__ */React53.createElement(UitkLayoutFlex8, {
    justifyContent: "space-between"
  }, secondaries.map(function (secondary) {
    return /* @__PURE__ */React53.createElement(UitkLayoutFlexItem7, {
      key: secondary.primary
    }, /* @__PURE__ */React53.createElement(TertiaryButton, {
      data: secondary
    }));
  }));
  var _accessibility_label;
  return /* @__PURE__ */React53.createElement(UitkToolbar, {
    key: "".concat(dialogName3, "-composable-drawer-toolbar"),
    navigationContent: {
      onClick: closeToolbar,
      navIconLabel: (_accessibility_label = accessibility === null || accessibility === void 0 ? void 0 : accessibility.label) !== null && _accessibility_label !== void 0 ? _accessibility_label : void 0,
      navType: "close"
    },
    toolbarActionContent: toolbarActionContent
  });
};
Toolbar.fragment = __Fragment26;
Toolbar.displayName = "Toolbar";
// src/components/__private/__fragments/drawer/composable-drawer.tsx
var __Fragment27 = gql80(_templateObject80(), TripsComposableDrawer.fragment, SectionContainer.fragment, FormContainer.fragment, PrimaryButton.fragment, SecondaryButton.fragment, TertiaryButton.fragment, ImageSlimCard.fragment, SlimCard.fragment, Toolbar.fragment, IllustrationCard.fragment, ItemRecallCard.fragment);
var ComposableDrawer = function (param) {
  var data = param.data,
    refetch = param.refetch;
  var _data_tripsViewHeader;
  var elements = data.elements;
  var dialogDrawerName = useTripsDrawerName();
  var childElements = tripsComposableElementList(elements, [SectionContainer, FormContainer, PrimaryButton, SecondaryButton, TertiaryButton, ImageSlimCard, SlimCard, IllustrationCard, ItemRecallCard]);
  var tripDrawerData = useReactiveVar4(tripDrawerState);
  var triggerRef = tripDrawerData === null || tripDrawerData === void 0 ? void 0 : tripDrawerData.favoriteSwitchRef;
  if (!childElements) {
    return null;
  }
  var toolBar = ((_data_tripsViewHeader = data.tripsViewHeader) === null || _data_tripsViewHeader === void 0 ? void 0 : _data_tripsViewHeader.toolbar) ? /* @__PURE__ */React54.createElement(Toolbar, {
    data: data.tripsViewHeader.toolbar,
    dialogName: dialogDrawerName
  }) : null;
  return /* @__PURE__ */React54.createElement(React54.Fragment, null, /* @__PURE__ */React54.createElement(TripsComposableDrawer, {
    triggerRef: triggerRef,
    dialogName: dialogDrawerName,
    data: data,
    toolBar: toolBar
  }, childElements), /* @__PURE__ */React54.createElement(MutationActionStateComponent, {
    refetch: refetch
  }));
};
ComposableDrawer.displayName = "ComposableDrawer";
ComposableDrawer.fragment = _object_spread_props(_object_spread({}, __Fragment27), {
  __typename: "TripsComposableDrawer"
});
// src/components/__private/trip-drawer/trip-creation-drawer.tsx
var __Query = gql81(_templateObject81(), ComposableDrawer.fragment);
var FETCH_TRIP_CREATION_VIEW_ERROR = new SystemEvent6(SystemEventLevel6.ERROR, "FETCH_TRIP_CREATION_VIEW_ERROR");
var TripCreationDrawer = function (props) {
  var _data_trip_creation, _data_trip;
  var inputs = props.inputs;
  var context = useBexApi4().context;
  var htmlElement = useReactPortal5().htmlElement;
  var logger = useLoggerEvents6({
    FETCH_TRIP_CREATION_VIEW_ERROR: FETCH_TRIP_CREATION_VIEW_ERROR
  });
  var formatText = useLocalization2().formatText;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      variables: variables,
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error;
  if (error) {
    logger.FETCH_TRIP_CREATION_VIEW_ERROR.log({
      error: error
    });
    return renderChildren( /* @__PURE__ */React55.createElement(UitkToast5, {
      show: true
    }, formatText("trip.error.detail.message")), htmlElement);
  }
  return /* @__PURE__ */React55.createElement(React55.Fragment, null, loading && renderChildren( /* @__PURE__ */React55.createElement(UitkPageLoader2, {
    visible: true
  }), htmlElement), (data === null || data === void 0 ? void 0 : (_data_trip = data.trip) === null || _data_trip === void 0 ? void 0 : (_data_trip_creation = _data_trip.creation) === null || _data_trip_creation === void 0 ? void 0 : _data_trip_creation.__typename) === "TripsComposableDrawer" && /* @__PURE__ */React55.createElement(ComposableDrawer, {
    data: data.trip.creation
  }));
};
TripCreationDrawer.displayName = "TripCreationDrawer";
// src/components/__private/trip-drawer/trip-save-item-drawer.tsx
import React56 from "react";
import { gql as gql82, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
import { useLocalization as useLocalization3 } from "@shared-ui/localization-context";
import { SystemEvent as SystemEvent7, SystemEventLevel as SystemEventLevel7, useLoggerEvents as useLoggerEvents7 } from "@shared-ui/logger-context";
import { useReactPortal as useReactPortal6 } from "@shared-ui/portal-context";
import { UitkPageLoader as UitkPageLoader3 } from "uitk-react-loader";
import { UitkToast as UitkToast6 } from "uitk-react-toast";
var __Query2 = gql82(_templateObject82(), ComposableDrawer.fragment);
var FETCH_TRIPS_PLAN_VIEW_ERROR = new SystemEvent7(SystemEventLevel7.ERROR, "FETCH_TRIPS_PLAN_VIEW_ERROR");
var TripSaveItemDrawer = function (props) {
  var _data_trips_plan, _data_trips;
  var inputs = props.inputs;
  var context = useBexApi5().context;
  var htmlElement = useReactPortal6().htmlElement;
  var logger = useLoggerEvents7({
    FETCH_TRIPS_PLAN_VIEW_ERROR: FETCH_TRIPS_PLAN_VIEW_ERROR
  });
  var formatText = useLocalization3().formatText;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery2 = useQuery2(__Query2, {
      variables: variables,
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true
    }),
    data = _useQuery2.data,
    loading = _useQuery2.loading,
    error = _useQuery2.error,
    refetch = _useQuery2.refetch;
  if (error) {
    logger.FETCH_TRIPS_PLAN_VIEW_ERROR.log({
      error: error
    });
    return renderChildren( /* @__PURE__ */React56.createElement(UitkToast6, {
      show: true
    }, formatText("trip.error.detail.message")), htmlElement);
  }
  return /* @__PURE__ */React56.createElement(React56.Fragment, null, loading && renderChildren( /* @__PURE__ */React56.createElement(UitkPageLoader3, {
    visible: true
  }), htmlElement), (data === null || data === void 0 ? void 0 : (_data_trips = data.trips) === null || _data_trips === void 0 ? void 0 : (_data_trips_plan = _data_trips.plan) === null || _data_trips_plan === void 0 ? void 0 : _data_trips_plan.__typename) === "TripsComposableDrawer" && /* @__PURE__ */React56.createElement(ComposableDrawer, {
    data: data.trips.plan,
    refetch: refetch
  }));
};
TripSaveItemDrawer.displayName = "TripSaveItemDrawer";
// src/components/__private/trip-drawer/trip-drawer.tsx
var TripDrawer = function (props) {
  switch (props.type) {
    case "TripSaveItemDrawerOptions":
      return /* @__PURE__ */React57.createElement(TripSaveItemDrawer, {
        inputs: {
          item: props.queryInputs.item
        }
      });
    case "TripCreationDrawerOptions":
      return /* @__PURE__ */React57.createElement(TripCreationDrawer, {
        inputs: {
          metadata: {
            saveItemInput: props.queryInputs.item.saveItemInput
          }
        }
      });
    default:
      return null;
  }
};
// src/components/trip-save-item.tsx
var Source = TripsPlanSourceType;
var __TripsSaveItemFragment = gql83(_templateObject83(), __TripsSaveItemAttributes, __TripsSaveItemProperties);
var TripSaveItem = function (param) {
  var data = param.data,
    source = param.source,
    heartLayoutPosition = param.heartLayoutPosition,
    saveItemCallback = param.saveItemCallback,
    removeItemCallback = param.removeItemCallback;
  var shouldRenderToast = function shouldRenderToast() {
    var isCurrentItemAndOneClickSaveExperiment = isOneClickSaveTripItemExperiment() && typeof sessionStorage !== "undefined" && sessionStorage.getItem("itemId") === itemId;
    if ((mutationActionStateData === null || mutationActionStateData === void 0 ? void 0 : mutationActionStateData.status) === "complete" /* Complete */) {
      if (!isToastRenderedOnce) {
        isToastRenderedOnce = true;
        return isCurrentItemAndOneClickSaveExperiment;
      }
      return false;
    }
    return isCurrentItemAndOneClickSaveExperiment;
  };
  var _queryData_localSavedItems_find, _context_identity, _window_location, _window_location1;
  var itemIdFromData = data.itemId,
    initialChecked = data.initialChecked,
    save = data.save,
    remove = data.remove,
    attributes = data.attributes,
    pageLocation = data.source;
  var randomKey = React58.useMemo(function () {
    return Math.random().toString(36).slice(2, 5);
  }, []);
  var uniqueId = "trip-save-item-".concat(randomKey);
  var _React58_useState = _sliced_to_array(React58.useState(itemIdFromData), 2),
    itemId = _React58_useState[0],
    setItemId = _React58_useState[1];
  var clickTracker = useClickTracker5();
  var drawerName2 = useTripsDrawerName();
  var _useDialog11 = _sliced_to_array(useDialog11(drawerName2), 2),
    dialogActions = _useDialog11[1];
  var tripDrawerData = useReactiveVar5(tripDrawerState);
  var mapper = useSaveItemAttributesMapper();
  var context = useBexApi6().context;
  var _useExperiment = useExperiment("Saving_anonymous_signinscreen_web"),
    savingAnonymousSigninScreenExposure = _useExperiment.exposure,
    logSavingAnonymousSigninScreen = _useExperiment.logExperiment;
  var _useExperiment1 = useExperiment("one_click_save"),
    oneClickSaveExposure = _useExperiment1.exposure,
    logOneClickSaveExperiment = _useExperiment1.logExperiment;
  var _useExperiment2 = useExperiment("one_click_save_cars_lx_web"),
    oneClickSaveExposureForLXAndCars = _useExperiment2.exposure,
    logOneClickSaveExperimentForLXAndCars = _useExperiment2.logExperiment;
  var _useExperiment3 = useExperiment("Disable_heart_icon_bug_fix"),
    disableHeartIconExposure = _useExperiment3.exposure,
    logDisableHeartIconExperiment = _useExperiment3.logExperiment;
  var _useExperiment4 = useExperiment("Persist_saving_anonymous"),
    persistSavingAnonymousExposure = _useExperiment4.exposure,
    logPersistSavingAnonymousExperiment = _useExperiment4.logExperiment;
  var _useExperiment5 = useExperiment("Heart_RedOutline_LodgingLX"),
    heartRedOutlineLodgingLxExposure = _useExperiment5.exposure,
    logHeartRedOutlineLodgingLxExperiment = _useExperiment5.logExperiment;
  var _useExperiment6 = useExperiment("Saving_for_Identified_Users"),
    saveForIdentifiedUsersExposure = _useExperiment6.exposure;
  var viewSize = useMediaQueries({
    viewSizes: defaultViewSizes
  });
  var mutationActionState = useMutationActionState();
  var mutationActionStateData = useReactiveVar5(mutationActionState);
  useEffect2(function () {
    setItemId(itemIdFromData);
  }, [itemIdFromData]);
  var datum = {
    __typename: "TripsSaveItemToTripAction",
    analytics: save.analytics,
    saveItemInput: {
      itemId: itemId,
      pageLocation: pageLocation,
      source: source,
      attributes: attributes,
      subscriptionAttributes: null,
      tripItem: null
    }
  };
  var saveItemToTripAction = useSaveItemToTripAction(datum);
  var _useQuery3 = useQuery3(__TripsLocalSavedItemQuery, {
      fetchPolicy: "cache-only"
    }),
    queryData = _useQuery3.data;
  var _useProvidedState7 = _sliced_to_array(useProvidedState7(), 1),
    state = _useProvidedState7[0];
  if (!state.validatedInputs) {
    throw new Error("TripSaveItem must be wrapped with a provider that provides ValidatedInputsState");
  }
  var _queryData_localSavedItems_find_checked;
  var checked = (_queryData_localSavedItems_find_checked = queryData === null || queryData === void 0 ? void 0 : (_queryData_localSavedItems_find = queryData.localSavedItems.find(function (savedItem) {
    return savedItem.id === itemId;
  })) === null || _queryData_localSavedItems_find === void 0 ? void 0 : _queryData_localSavedItems_find.checked) !== null && _queryData_localSavedItems_find_checked !== void 0 ? _queryData_localSavedItems_find_checked : initialChecked;
  var disabled = disableHeartIconExposure.bucket === 1 && (mutationActionStateData === null || mutationActionStateData === void 0 ? void 0 : mutationActionStateData.status) === "loading" /* Loading */ && ((tripDrawerData === null || tripDrawerData === void 0 ? void 0 : tripDrawerData.queryInputs.item.itemId) === itemId || sessionStorage.getItem("itemId") === itemId);
  var _ref;
  var accessibility = (_ref = checked ? remove.accessibility : save.accessibility) !== null && _ref !== void 0 ? _ref : void 0;
  var analytics = checked ? remove.analytics : save.analytics;
  var label = checked ? remove.label : save.label;
  var externalCallback = checked ? removeItemCallback : saveItemCallback;
  var favoriteSwitchRef = React58.useRef(null);
  var authState = (_context_identity = context.identity) === null || _context_identity === void 0 ? void 0 : _context_identity.authState;
  var isAuthenticated = authState === "AUTHENTICATED" /* AUTHENTICATED */;
  var isUnAuthenticated = authState !== "AUTHENTICATED" /* AUTHENTICATED */;
  var isAnonymous = authState === "ANONYMOUS" /* ANONYMOUS */;
  var isIdentified = authState === "IDENTIFIED" /* IDENTIFIED */;
  var isWindowContext = typeof window !== "undefined";
  var search = isWindowContext ? (_window_location = window.location) === null || _window_location === void 0 ? void 0 : _window_location.search : "";
  var pathName = isWindowContext ? (_window_location1 = window.location) === null || _window_location1 === void 0 ? void 0 : _window_location1.pathname : "";
  var searchParams = new URLSearchParams(search);
  var histroy = useHistory();
  var isToastRenderedOnce = false;
  var isCarsV2Source = ["CAR_SEARCH_V2" /* CAR_SEARCH_V2 */, "CAR_INFOSITE_V2" /* CAR_INFOSITE_V2 */].includes(source);
  var isLodgingSource = ["LODGING_DETAILS" /* LODGING_DETAILS */, "LODGING_SEARCH" /* LODGING_SEARCH */].includes(source);
  var isActivitiesSource = ["ACTIVITY_DETAILS" /* ACTIVITY_DETAILS */, "ACTIVITY_SEARCH" /* ACTIVITY_SEARCH */].includes(source);
  var isPackagesSource = source === "PACKAGE_DETAILS" /* PACKAGE_DETAILS */;
  var isLodgingOrActivitiesSource = function () {
    return isLodgingSource || isActivitiesSource;
  };
  var isOneClickSaveTripItemExperiment = function () {
    return oneClickSaveExposure.bucket !== 0 || oneClickSaveExposureForLXAndCars.bucket === 1;
  };
  var isUnAuthenticatedUserInOneClickSaveExperiment = function () {
    return isOneClickSaveTripItemExperiment() && isUnAuthenticated;
  };
  var isSaveForIdentifiedUsersExposureExperimentInVariant = function () {
    return saveForIdentifiedUsersExposure.bucket === 1;
  };
  var isPersistSavingAnonymousExperimentInVariant = function () {
    return persistSavingAnonymousExposure.bucket === 1;
  };
  var isIdentifiedUserInOneClickSaveAndSaveForIdentifiedUsersExperiment = function () {
    return isIdentified && isSaveForIdentifiedUsersExposureExperimentInVariant() && isOneClickSaveTripItemExperiment();
  };
  var isSavingAnonymousSigninScreenInVariant = function () {
    return savingAnonymousSigninScreenExposure.bucket === 1;
  };
  var isUnAuthenticatedUserInSavingSigninScreenExperiment = function () {
    return isSavingAnonymousSigninScreenInVariant() && isUnAuthenticated;
  };
  var newDrawerState = React58.useMemo(function () {
    return {
      type: "TripSaveItemDrawerOptions",
      queryInputs: {
        item: {
          itemId: itemId,
          source: source,
          pageLocation: pageLocation,
          attributes: mapper(attributes),
          subscriptionAttributes: void 0
        }
      },
      favoriteSwitchRef: favoriteSwitchRef
    };
  }, [itemId, source, pageLocation, attributes, mapper]);
  var isOneClickSaveExperimentInEditCTAVariant = function () {
    return oneClickSaveExposure.bucket === 1 || oneClickSaveExposureForLXAndCars.bucket === 1;
  };
  useSignalSubscriber({
    query: {
      type: SaveItemSignals.TRIP_ITEM_SAVED
    },
    onSignal: function (event) {
      if (isOneClickSaveExperimentInEditCTAVariant()) {
        var _event_payload;
        sessionStorage.setItem("itemId", event === null || event === void 0 ? void 0 : (_event_payload = event.payload) === null || _event_payload === void 0 ? void 0 : _event_payload.tripItemId);
      }
    }
  });
  var onEditCTAInToastClick = function () {
    if (isOneClickSaveExperimentInEditCTAVariant()) {
      if (sessionStorage.getItem("itemId")) {
        var _sessionStorage_getItem;
        setItemId((_sessionStorage_getItem = sessionStorage.getItem("itemId")) !== null && _sessionStorage_getItem !== void 0 ? _sessionStorage_getItem : "");
      }
      tripDrawerState(newDrawerState);
      dialogActions.openDialog();
    }
  };
  var isOneClickSaveExperimentInControl = function () {
    return oneClickSaveExposure.bucket === 0 && oneClickSaveExposureForLXAndCars.bucket === 0;
  };
  var shouldOpenDrawer = function () {
    return checked || isOneClickSaveExperimentInControl() && !checked && !isUnAuthenticatedUserInSavingSigninScreenExperiment() || isUnAuthenticatedUserInOneClickSaveExperiment() && !isIdentified && !isSavingAnonymousSigninScreenInVariant() || isIdentified && !isSaveForIdentifiedUsersExposureExperimentInVariant() && isOneClickSaveTripItemExperiment() && !isSavingAnonymousSigninScreenInVariant();
  };
  var shouldHitSaveItemMutation = function () {
    return !isUnAuthenticatedUserInSavingSigninScreenExperiment() && (isIdentifiedUserInOneClickSaveAndSaveForIdentifiedUsersExperiment() || isOneClickSaveTripItemExperiment());
  };
  var getQueryParams = function () {
    var separator = search.length > 0 ? "&" : "?";
    var saveItemParam = isPersistSavingAnonymousExperimentInVariant() ? "".concat(separator, "saveItemId=").concat(itemId) : "";
    var currentPagePath = "".concat(pathName).concat(search).concat(saveItemParam);
    return "enable_login=true&redirectTo=".concat(encodeURIComponent(currentPagePath));
  };
  var favouriteSwitchOnChange = React58.useCallback(function (e) {
    var _analytics_uisPrimeMessages;
    var loginUrl = "/login?".concat(getQueryParams());
    var message = analytics === null || analytics === void 0 ? void 0 : (_analytics_uisPrimeMessages = analytics.uisPrimeMessages) === null || _analytics_uisPrimeMessages === void 0 ? void 0 : _analytics_uisPrimeMessages.map(function (param) {
      var schemaName = param.schemaName,
        messageContent = param.messageContent;
      return {
        schemaName: schemaName,
        messageContent: JSON.parse(messageContent)
      };
    });
    if (analytics) {
      clickTracker(analytics.referrerId, analytics.linkName, void 0, message);
    }
    if (isAnonymous) {
      logPersistSavingAnonymousExperiment(persistSavingAnonymousExposure);
    }
    if (isUnAuthenticated) {
      logSavingAnonymousSigninScreen(savingAnonymousSigninScreenExposure);
      setTimeout(function () {
        if (isSavingAnonymousSigninScreenInVariant()) {
          window.location.href = loginUrl;
        }
      }, 500);
    }
    if (externalCallback) {
      externalCallback();
    }
    e === null || e === void 0 ? void 0 : e.stopPropagation();
    mutationActionState({
      status: "reset" /* Reset */
    });
    favoriteSwitchRef.current = document.activeElement;
    logOneClickSaveExperiment(oneClickSaveExposure);
    logOneClickSaveExperimentForLXAndCars(oneClickSaveExposureForLXAndCars);
    logDisableHeartIconExperiment(disableHeartIconExposure);
    sessionStorage.removeItem("itemId");
    if (shouldOpenDrawer()) {
      dialogActions.openDialog();
      tripDrawerState(newDrawerState);
    } else if (shouldHitSaveItemMutation() && (saveItemToTripAction === null || saveItemToTripAction === void 0 ? void 0 : saveItemToTripAction.onClick)) {
      saveItemToTripAction.onClick();
      sessionStorage.setItem("itemId", itemId);
    }
  }, [analytics, clickTracker, dialogActions, externalCallback, newDrawerState, context]);
  useEffect2(function () {
    if (isPersistSavingAnonymousExperimentInVariant() && itemId && searchParams.get("saveItemId") === itemId && isAuthenticated) {
      var _window_location;
      searchParams.delete("saveItemId");
      histroy.replace({
        pathname: (_window_location = window.location) === null || _window_location === void 0 ? void 0 : _window_location.pathname,
        search: searchParams.toString()
      });
      favouriteSwitchOnChange();
    }
  }, []);
  var _React58_useState1 = _sliced_to_array(React58.useState(label), 2),
    displaylLabel = _React58_useState1[0],
    setLabel = _React58_useState1[1];
  React58.useEffect(function () {
    if (viewSize !== defaultViewSizes.SMALL) {
      setLabel(label);
    } else {
      setLabel("");
    }
  }, [viewSize, label]);
  var localFavoriteSwitch = React58.useMemo(function () {
    return /* @__PURE__ */React58.createElement("div", {
      "data-stid": "outlined-save-button",
      id: uniqueId
    }, /* @__PURE__ */React58.createElement(EGDSLocalFavoriteButton, {
      key: uniqueId,
      checked: checked,
      accessibilityLabel: accessibility,
      accentOutlineHighlighted: true,
      onClick: favouriteSwitchOnChange,
      text: displaylLabel || void 0
    }));
  }, [uniqueId, accessibility, checked, favouriteSwitchOnChange, source, disabled]);
  var favoriteSwitch = React58.useMemo(function () {
    return /* @__PURE__ */React58.createElement(UitkFavoriteSwitch, {
      key: uniqueId,
      id: uniqueId,
      label: accessibility,
      checked: checked,
      onChange: favouriteSwitchOnChange,
      disabled: disabled
    });
  }, [uniqueId, accessibility, checked, favouriteSwitchOnChange, disabled]);
  var labelledFavoriteSwitch = React58.useMemo(function () {
    return /* @__PURE__ */React58.createElement(UitkLayoutFlex9, {
      direction: "row",
      alignItems: "center"
    }, /* @__PURE__ */React58.createElement(UitkLayoutFlexItem8, null, favoriteSwitch), /* @__PURE__ */React58.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */React58.createElement(Viewport2, null, /* @__PURE__ */React58.createElement(ViewMedium2, null, /* @__PURE__ */React58.createElement(UitkSpacing13, {
      padding: {
        inlineend: "four"
      }
    }, /* @__PURE__ */React58.createElement(UitkText11, {
      whiteSpace: "nowrap",
      "data-stid": "save-item-label"
    }, label))))));
  }, [favoriteSwitch, label]);
  var getFavoriteSwitch = React58.useCallback(function () {
    if (isLodgingOrActivitiesSource()) {
      logHeartRedOutlineLodgingLxExperiment(heartRedOutlineLodgingLxExposure);
    }
    var isHeartRedOutlineLodgingLxExperimentInVariant = function () {
      return heartRedOutlineLodgingLxExposure.bucket === 1 && isLodgingOrActivitiesSource();
    };
    var getFavoriteSwitchInternal = function () {
      if (isHeartRedOutlineLodgingLxExperimentInVariant() || isCarsV2Source || isPackagesSource) {
        return localFavoriteSwitch;
      }
      return label ? labelledFavoriteSwitch : favoriteSwitch;
    };
    if (heartLayoutPosition) {
      return /* @__PURE__ */React58.createElement(UitkLayoutPosition2, {
        type: heartLayoutPosition.type,
        position: heartLayoutPosition.position
      }, getFavoriteSwitchInternal());
    }
    return getFavoriteSwitchInternal();
  }, [heartLayoutPosition, source, label, labelledFavoriteSwitch, favoriteSwitch, localFavoriteSwitch]);
  return /* @__PURE__ */React58.createElement(TripSaveItemContextProvider, {
    onEditCTAInToastClick: onEditCTAInToastClick
  }, /* @__PURE__ */React58.createElement(SignalProvider, null, getFavoriteSwitch(), (tripDrawerData === null || tripDrawerData === void 0 ? void 0 : tripDrawerData.queryInputs.item.itemId) === itemId && /* @__PURE__ */React58.createElement(TripDrawer, _object_spread({}, tripDrawerData)), shouldRenderToast() && /* @__PURE__ */React58.createElement(MutationActionStateComponent, null)));
};
TripSaveItem.fragment = __TripsSaveItemFragment;
TripSaveItem.displayName = "sharedui-TripSaveItem";
// src/components/trip-save-entity.tsx
import React64 from "react";
import { gql as gql88, NetworkStatus, useApolloClient as useApolloClient2, useQuery as useQuery4, useReactiveVar as useReactiveVar6 } from "@apollo/client";
import { useBexApi as useBexApi7 } from "@shared-ui/bex-api-context";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { SignalProvider as SignalProvider2 } from "@shared-ui/retail-trips-providers";
import { useSignalSubscriber as useSignalSubscriber2 } from "@shared-ui/signal-events-context";
// src/components/__private/__fragments/save-item-details/save-item-button.tsx
import React59 from "react";
import { gql as gql84 } from "@apollo/client";
import { UitkSwitch } from "uitk-react-switch";
var __Fragment28 = gql84(_templateObject84(), __TripsOpenDialogActionFragment, __TripsOpenSaveToTripDrawerActionFragment);
var TripsSaveItemButton = function (param) {
  var data = param.data;
  var _data_icon;
  var _data_primary;
  var primary = (_data_primary = data.primary) !== null && _data_primary !== void 0 ? _data_primary : void 0;
  var toggleState = ((_data_icon = data.icon) === null || _data_icon === void 0 ? void 0 : _data_icon.theme) === "negative";
  var _useActionMap = useActionMap(data.action),
    onClick = _useActionMap.onClick,
    onClickCapture = _useActionMap.onClickCapture;
  var handleActions = React59.useCallback(function () {
    onClick === null || onClick === void 0 ? void 0 : onClick();
    onClickCapture === null || onClickCapture === void 0 ? void 0 : onClickCapture();
  }, [onClick, onClickCapture]);
  return /* @__PURE__ */React59.createElement(UitkSwitch, {
    checked: toggleState,
    onChange: handleActions,
    a11yLabel: primary
  });
};
TripsSaveItemButton.displayName = "TripsSaveItemButton";
TripsSaveItemButton.fragment = __Fragment28;
// src/components/__private/__fragments/save-item-details/save-item-details.tsx
import React62 from "react";
import { gql as gql87 } from "@apollo/client";
import { UitkCard as UitkCard5, UitkCardContentSection as UitkCardContentSection5 } from "uitk-react-cards";
import { UitkIllustrations as UitkIllustrations3 } from "uitk-react-illustrations";
import { UitkLayoutFlex as UitkLayoutFlex10, UitkLayoutFlexItem as UitkLayoutFlexItem9 } from "uitk-react-layout-flex";
import { UitkSpacingHr } from "uitk-react-spacing";
import { UitkHeading as UitkHeading8, UitkText as UitkText13 } from "uitk-react-text";
// src/components/__private/__fragments/save-item-details/inline-content.tsx
import React61 from "react";
import { gql as gql86 } from "@apollo/client";
// src/components/__private/__fragments/save-item-details/view-content.tsx
import React60 from "react";
import { gql as gql85 } from "@apollo/client";
import { UitkLink } from "uitk-react-link";
import { UitkText as UitkText12 } from "uitk-react-text";
var __Fragment29 = gql85(_templateObject85(), __TripsNavigateToViewActionFragment);
var TripsViewContentItem = function (param) {
  var data = param.data;
  var _data_action;
  var action = ((_data_action = data.action) === null || _data_action === void 0 ? void 0 : _data_action.__typename) === "TripsNavigateToViewAction" ? data.action : void 0;
  var actionProps = useActionMap(data.action);
  return /* @__PURE__ */React60.createElement(React60.Fragment, null, !action && data.primary && /* @__PURE__ */React60.createElement(UitkText12, {
    size: 200
  }, data.primary), action && data.primary && /* @__PURE__ */React60.createElement(UitkLink, {
    size: "small"
  }, /* @__PURE__ */React60.createElement("a", _object_spread({}, actionProps), data.primary)));
};
TripsViewContentItem.displayName = "TripsViewContentItem";
TripsViewContentItem.fragment = __Fragment29;
// src/components/__private/__fragments/save-item-details/inline-content.tsx
var __Fragment30 = gql86(_templateObject86(), TripsViewContentItem.fragment);
var TripsInlineContent = function (param) {
  var data = param.data;
  return /* @__PURE__ */React61.createElement(React61.Fragment, null, data.items.map(function (item, i) {
    return /* @__PURE__ */React61.createElement(TripsViewContentItem, {
      data: item,
      key: "".concat(data.__typename, "-").concat(i)
    });
  }));
};
TripsInlineContent.displayName = "TripsInlineContent";
TripsInlineContent.fragment = __Fragment30;
// src/components/__private/__fragments/save-item-details/save-item-details.tsx
var __Fragment31 = gql87(_templateObject87(), TripsInlineContent.fragment, TripsSaveItemButton.fragment);
var TripsSaveItemDetails = function (param) {
  var data = param.data,
    isFlightsWhiteCanvasExperimentBucketed = param.isFlightsWhiteCanvasExperimentBucketed;
  return /* @__PURE__ */React62.createElement(UitkCard5, {
    padded: true,
    border: isFlightsWhiteCanvasExperimentBucketed
  }, data.graphicText && /* @__PURE__ */React62.createElement(UitkLayoutFlex10, {
    alignItems: "center"
  }, data.graphicText.graphic.__typename === "Illustration" && /* @__PURE__ */React62.createElement(UitkLayoutFlexItem9, {
    alignSelf: "center",
    grow: 0
  }, /* @__PURE__ */React62.createElement(UitkCardContentSection5, {
    padded: false
  }, /* @__PURE__ */React62.createElement(UitkIllustrations3, {
    url: data.graphicText.graphic.url,
    alt: data.graphicText.graphic.description
  }))), /* @__PURE__ */React62.createElement(UitkLayoutFlexItem9, {
    grow: 1
  }, /* @__PURE__ */React62.createElement(UitkCardContentSection5, {
    padded: ["inlinestart"]
  }, /* @__PURE__ */React62.createElement(UitkHeading8, null, data.graphicText.text)))), /* @__PURE__ */React62.createElement(UitkSpacingHr, null), /* @__PURE__ */React62.createElement(UitkLayoutFlex10, {
    alignItems: "center"
  }, /* @__PURE__ */React62.createElement(UitkLayoutFlexItem9, {
    grow: 1
  }, /* @__PURE__ */React62.createElement(UitkCardContentSection5, {
    padded: false
  }, /* @__PURE__ */React62.createElement(UitkText13, {
    spacing: "one"
  }, data.heading), /* @__PURE__ */React62.createElement(TripsInlineContent, {
    data: data.primary
  }))), /* @__PURE__ */React62.createElement(UitkLayoutFlexItem9, {
    grow: 0,
    alignSelf: "center"
  }, /* @__PURE__ */React62.createElement(UitkCardContentSection5, {
    padded: ["inlinestart"]
  }, /* @__PURE__ */React62.createElement(TripsSaveItemButton, {
    data: data.saveItemButton
  })))));
};
TripsSaveItemDetails.displayName = "TripsSaveItemDetails";
TripsSaveItemDetails.fragment = __Fragment31;
// src/components/trip-save-entity-details-loader.tsx
import React63 from "react";
import { ViewLarge as ViewLarge2, Viewport as Viewport3 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard6, UitkCardContentSection as UitkCardContentSection6 } from "uitk-react-cards";
import { UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing14 } from "uitk-react-spacing";
var TripSaveEntityDetailsLoader = function (param) {
  var className = param.className;
  return /* @__PURE__ */React63.createElement(Viewport3, null, /* @__PURE__ */React63.createElement(ViewLarge2, null, /* @__PURE__ */React63.createElement("div", {
    className: className
  }, /* @__PURE__ */React63.createElement(UitkCard6, {
    padded: true
  }, /* @__PURE__ */React63.createElement(UitkCardContentSection6, {
    padded: true
  }, /* @__PURE__ */React63.createElement(UitkSpacing14, {
    padding: {
      blockend: "twelve"
    }
  }, /* @__PURE__ */React63.createElement("div", null, /* @__PURE__ */React63.createElement(UitkLineSkeleton, null), /* @__PURE__ */React63.createElement(UitkSpacing14, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React63.createElement("div", null, /* @__PURE__ */React63.createElement(UitkLineSkeleton, {
    type: "secondary"
  }))))))))));
};
// src/components/trip-save-entity.tsx
var saveItemQuery = "saveItem";
var __TripSaveEntityQuery = gql88(_templateObject88(), TripsSaveItemButton.fragment, TripsSaveItemDetails.fragment);
var TripSaveEntity = function (param) {
  var className = param.className,
    inputs = param.inputs,
    skipSsr = param.skipSsr;
  var tripDrawerData = useReactiveVar6(tripDrawerState);
  var modalDialogData = useReactiveVar6(dialogState);
  var client = useApolloClient2();
  var mutationActionState = useMutationActionState();
  var context = useBexApi7().context;
  var _React64_useState = _sliced_to_array(React64.useState(false), 2),
    shouldRefetch = _React64_useState[0],
    setShouldRefetch = _React64_useState[1];
  var anchorPriceMap = React64.useRef( /* @__PURE__ */new Map());
  var mapKey = JSON.stringify(inputs.saveItemInput);
  var isFlightsWhiteCanvasExperimentBucketed = useExperiment2("Flights_Grey_to_White_Canvas_Web").exposure.bucket === 1;
  var _anchorPriceMap_current_get;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    saveItemInput: _object_spread_props(_object_spread({}, inputs.saveItemInput), {
      anchorPrice: (_anchorPriceMap_current_get = anchorPriceMap.current.get(mapKey)) !== null && _anchorPriceMap_current_get !== void 0 ? _anchorPriceMap_current_get : inputs.saveItemInput.anchorPrice
    }),
    context: context
  });
  var _useQuery4 = useQuery4(__TripSaveEntityQuery, {
      variables: variables,
      ssr: !skipSsr,
      notifyOnNetworkStatusChange: true,
      onCompleted: function (responseData) {
        var _responseData_trips_saveItem;
        var _responseData_trips_saveItem_subscriptionAttributes_anchorPrice;
        var anchorPrice = (_responseData_trips_saveItem_subscriptionAttributes_anchorPrice = (_responseData_trips_saveItem = responseData.trips.saveItem) === null || _responseData_trips_saveItem === void 0 ? void 0 : _responseData_trips_saveItem.subscriptionAttributes.anchorPrice) !== null && _responseData_trips_saveItem_subscriptionAttributes_anchorPrice !== void 0 ? _responseData_trips_saveItem_subscriptionAttributes_anchorPrice : void 0;
        anchorPriceMap.current.set(mapKey, anchorPrice);
        client.cache.writeQuery({
          query: __TripSaveEntityQuery,
          data: responseData,
          variables: _object_spread_props(_object_spread({}, variables), {
            saveItemInput: _object_spread_props(_object_spread({}, variables.saveItemInput), {
              anchorPrice: anchorPrice
            })
          })
        });
      }
    }),
    data = _useQuery4.data,
    error = _useQuery4.error,
    loading = _useQuery4.loading,
    networkStatus = _useQuery4.networkStatus,
    refetch = _useQuery4.refetch;
  useSignalSubscriber2({
    query: {
      type: SaveItemSignals.TRIP_ITEM_SAVED
    },
    onSignal: function () {
      return setShouldRefetch(true);
    }
  });
  useSignalSubscriber2({
    query: {
      type: SaveItemSignals.TRIP_ITEM_UNSAVED
    },
    onSignal: function () {
      return setShouldRefetch(true);
    }
  });
  React64.useEffect(function () {
    if (shouldRefetch) {
      var _data_trips_saveItem;
      client.cache.modify({
        fields: {
          trips: function (existing) {
            return Object.fromEntries(Object.entries(existing).filter(function (param) {
              var _param = _sliced_to_array(param, 1),
                key = _param[0];
              return !key.startsWith(saveItemQuery);
            }));
          }
        }
      });
      var _data_trips_saveItem_subscriptionAttributes_anchorPrice;
      refetch({
        saveItemInput: _object_spread_props(_object_spread({}, variables.saveItemInput), {
          anchorPrice: (_data_trips_saveItem_subscriptionAttributes_anchorPrice = data === null || data === void 0 ? void 0 : (_data_trips_saveItem = data.trips.saveItem) === null || _data_trips_saveItem === void 0 ? void 0 : _data_trips_saveItem.subscriptionAttributes.anchorPrice) !== null && _data_trips_saveItem_subscriptionAttributes_anchorPrice !== void 0 ? _data_trips_saveItem_subscriptionAttributes_anchorPrice : ""
        })
      });
      setShouldRefetch(false);
    }
  }, [client, data, refetch, shouldRefetch, variables]);
  if (loading && networkStatus !== NetworkStatus.refetch) {
    mutationActionState({
      status: "reset" /* Reset */,
      toastElement: void 0
    });
  }
  if (error) {
    return null;
  }
  return /* @__PURE__ */React64.createElement(SignalProvider2, null, tripDrawerData ? /* @__PURE__ */React64.createElement(TripDrawer, _object_spread({}, tripDrawerData)) : /* @__PURE__ */React64.createElement(MutationActionStateComponent, null), modalDialogData && /* @__PURE__ */React64.createElement(ModalDialog, {
    data: modalDialogData
  }), loading || networkStatus === NetworkStatus.refetch ? /* @__PURE__ */React64.createElement(TripSaveEntityDetailsLoader, {
    className: className
  }) : (data === null || data === void 0 ? void 0 : data.trips.saveItem) && /* @__PURE__ */React64.createElement("div", {
    className: className
  }, /* @__PURE__ */React64.createElement(TripsSaveItemDetails, {
    data: data.trips.saveItem.saveItemDetails,
    isFlightsWhiteCanvasExperimentBucketed: isFlightsWhiteCanvasExperimentBucketed
  })));
};
TripSaveEntity.displayName = "sharedui-TripSaveEntity";
// ../internal/src/components/state/trips-toast-state-chunk.ts
var FIELD_NAME = "toastState";
var TripsToastStateEvents = /* @__PURE__ */function (TripsToastStateEvents2) {
  TripsToastStateEvents2["SET_OFFSET"] = "setOffset";
  return TripsToastStateEvents2;
}(TripsToastStateEvents || {});
var update = function (event, currentState, payload) {
  if (event === "setOffset" /* SET_OFFSET */) {
    return _object_spread_props(_object_spread({}, currentState), {
      offset: payload.data.offset
    });
  }
  return currentState;
};
var TripsToastStateChunk = {
  data: {
    offset: 0
  },
  stateFieldName: FIELD_NAME,
  events: ["setOffset" /* SET_OFFSET */],
  update: update
};
export { EGReferrerEventType, IconSpotLight, IconTheme, PageLocation, SaveItemSignals, SaveItemToTripMutationQuery, Source, TripEntity, TripSaveEntity, TripSaveItem, TripsButtonWidth, TripsDisplayMode, TripsLinkTarget, TripsPlanSourceType, TripsToastStateChunk, TripsToastStateEvents, TripsViewType, ValidatedInputsState, __Query2 as __TripsPlanQuery }; /* istanbul ignore file -- @preserve */